webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVersions = getVersions;
exports.getUserX = getUserX;
exports.patchUserX = patchUserX;
exports.getService = getService;
exports.patchService = patchService;
exports.getRentXie = getRentXie;
exports.patchRentXie = patchRentXie;
exports.getRentRule = getRentRule;
exports.addRentRule = addRentRule;
exports.getHelp = getHelp;
exports.patchHelp = patchHelp;
exports.getBanner = getBanner;
exports.putBanner = putBanner;
exports.postVersions = postVersions;
exports.patchVersions = patchVersions;
exports.patchVersionsId = patchVersionsId;
exports.putVersions = putVersions;
exports.deleteVersions = deleteVersions;
exports.filterIndexVersions = filterIndexVersions;
exports.getGlobalSettings = getGlobalSettings;
exports.putGlobalSettings = putGlobalSettings;
exports.patchGlobalSettings = patchGlobalSettings;
exports.getProductCategories = getProductCategories;
exports.putProductCategories = putProductCategories;
exports.patchProductCategories = patchProductCategories;
exports.deleteProductCategories = deleteProductCategories;
exports.getProductTags = getProductTags;
exports.postProductTags = postProductTags;
exports.patchProductTags = patchProductTags;
exports.deleteProductTags = deleteProductTags;
exports.getProductDetails = getProductDetails;
exports.getProductDetailsOnly = getProductDetailsOnly;
exports.addProductDetails = addProductDetails;
exports.putProductDetails = putProductDetails;
exports.patchProductDetails = patchProductDetails;
exports.getProductDetailsId = getProductDetailsId;
exports.putProductDetailsId = putProductDetailsId;
exports.filterProductDetails = filterProductDetails;
exports.filterUser = filterUser;
exports.filterStorages = filterStorages;
exports.getProductAccessories = getProductAccessories;
exports.getProductAccessoriesDetailId = getProductAccessoriesDetailId;
exports.postProductAccessories = postProductAccessories;
exports.deleteProductAccessories = deleteProductAccessories;
exports.getProductAccessoriesId = getProductAccessoriesId;
exports.getProducts = getProducts;
exports.patchProducts = patchProducts;
exports.getStorageCount = getStorageCount;
exports.getProductsId = getProductsId;
exports.getProductsIds = getProductsIds;
exports.patchProductsIds = patchProductsIds;
exports.deleteProducts = deleteProducts;
exports.postProducts = postProducts;
exports.finishOrder = finishOrder;
exports.putProducts = putProducts;
exports.deleteProductsOne = deleteProductsOne;
exports.getStorages = getStorages;
exports.getStoragesId = getStoragesId;
exports.postStorages = postStorages;
exports.patchStorages = patchStorages;
exports.deleteStorages = deleteStorages;
exports.getAccessory = getAccessory;
exports.addAccessory = addAccessory;
exports.removeAccessory = removeAccessory;
exports.removeProduct = removeProduct;
exports.postProductTag = postProductTag;
exports.deleteProductTag = deleteProductTag;
exports.getProductTagId = getProductTagId;
exports.getProductTagAll = getProductTagAll;
exports.getUsers = getUsers;
exports.getUsersDetail = getUsersDetail;
exports.patchUsersPsd = patchUsersPsd;
exports.getUserIdentification = getUserIdentification;
exports.getDefaultAddress = getDefaultAddress;
exports.getUserOrder = getUserOrder;
exports.getOrderId = getOrderId;
exports.deleteUser = deleteUser;
exports.getIdentification = getIdentification;
exports.getIdentificationId = getIdentificationId;
exports.putUserManage = putUserManage;
exports.getOrder = getOrder;
exports.getOrderCount = getOrderCount;
exports.getProductCount = getProductCount;
exports.getProductdetailsCount = getProductdetailsCount;
exports.getProductdetailCount = getProductdetailCount;
exports.getUserCount = getUserCount;
exports.getFeedCount = getFeedCount;
exports.getCommontCount = getCommontCount;
exports.putExpress = putExpress;
exports.sendExpress = sendExpress;
exports.updateZM = updateZM;
exports.deleteOrder = deleteOrder;
exports.cancelOrder = cancelOrder;
exports.alipayMiniCancelOrder = alipayMiniCancelOrder;
exports.backOrder = backOrder;
exports.getStoragesList = getStoragesList;
exports.getComments = getComments;
exports.filterComments = filterComments;
exports.putComments = putComments;
exports.deleteComments = deleteComments;
exports.getOrderDetail = getOrderDetail;
exports.getFeedBack = getFeedBack;
exports.patchFeedBack = patchFeedBack;
exports.deleteFeedBack = deleteFeedBack;
exports.getExpress = getExpress;
exports.getExpressD = getExpressD;
exports.getHot = getHot;
exports.patchHot = patchHot;
exports.getRentHistory = getRentHistory;
exports.getAccount = getAccount;
exports.deleteAccount = deleteAccount;
exports.patchPsd = patchPsd;
exports.getAccountId = getAccountId;
exports.addAccount = addAccount;
exports.changeBackExpress = changeBackExpress;
exports.patchAccount = patchAccount;
exports.getMount = getMount;
exports.getProductRent = getProductRent;
exports.getTongji = getTongji;
exports.getFreashOrder = getFreashOrder;
exports.putProduct = putProduct;
exports.zmRefundOrder = zmRefundOrder;
exports.doInstallment = doInstallment;

var _request = __webpack_require__(157);

var _request2 = _interopRequireDefault(_request);

var _baseUrl = __webpack_require__(104);

var _baseUrl2 = _interopRequireDefault(_baseUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEBUG_MODE = false;
var URL_PREFIX = DEBUG_MODE ? '' : _baseUrl2.default;

function getVersions() {
  return _request2.default.get(URL_PREFIX + '/api/VersionSettings');
}

function getUserX() {
  return _request2.default.get(URL_PREFIX + '/api/VersionSettings/3');
}

function patchUserX(token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/VersionSettings/3?access_token=' + token, data);
}

function getService() {
  return _request2.default.get(URL_PREFIX + '/api/VersionSettings/4');
}

function patchService(token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/VersionSettings/4?access_token=' + token, data);
}

function getRentXie() {
  return _request2.default.get(URL_PREFIX + '/api/VersionSettings/5');
}

function patchRentXie(token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/VersionSettings/5?access_token=' + token, data);
}

function getRentRule(id) {
  return _request2.default.get(URL_PREFIX + '/api/VersionSettings/' + id);
}

function addRentRule(id, token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/VersionSettings/' + id + '?access_token=' + token, data);
}

function getHelp(id) {
  return _request2.default.get(URL_PREFIX + '/api/VersionSettings/' + id);
}

function patchHelp(id, token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/VersionSettings/' + id + '?access_token=' + token, data);
}

function getBanner(data) {
  return _request2.default.get(URL_PREFIX + '/api/VersionSettings?filter=' + data);
}

function putBanner(token, id, data) {
  return _request2.default.put(URL_PREFIX + '/api/VersionSettings/' + id + '?access_token=' + token, data);
}

function postVersions(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/VersionSettings?access_token=' + token, data);
}

function patchVersions(token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/VersionSettings?access_token=' + token, data);
}

function patchVersionsId(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/VersionSettings/' + id + '?access_token=' + token, data);
}

function putVersions(token, id, data) {
  return _request2.default.put(URL_PREFIX + '/api/VersionSettings/' + id + '?access_token=' + token, data);
}

function deleteVersions(token, data) {
  return _request2.default.delete(URL_PREFIX + '/api/VersionSettings/' + data + '?access_token=' + token);
}

function filterIndexVersions() {
  return _request2.default.get(URL_PREFIX + '/api/VersionSettings?filter=%7B%22where%22%3A%7B%22version%22%3A%7B%22like%22%3A%20%22index%25%22%7D%7D%7D');
}

function getGlobalSettings() {
  return _request2.default.get(URL_PREFIX + '/api/GlobalSettings');
}

function putGlobalSettings(token, data) {
  return _request2.default.put(URL_PREFIX + '/api/GlobalSettings?access_token=' + token, data);
}

function patchGlobalSettings(token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/GlobalSettings?access_token=' + token, data);
}

function getProductCategories() {
  return _request2.default.get(URL_PREFIX + '/api/ProductCategories');
}

function putProductCategories(token, data) {
  return _request2.default.put(URL_PREFIX + '/api/ProductCategories?access_token=' + token, data);
}

function patchProductCategories(id, token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/ProductCategories/' + id + '?access_token=' + token, data);
}

function deleteProductCategories(id, token, data) {
  return _request2.default.delete(URL_PREFIX + '/api/ProductCategories/' + id + '?access_token=' + token, data);
}

function getProductTags() {
  return _request2.default.get(URL_PREFIX + '/api/ProductTags');
}

function postProductTags(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/ProductTags?access_token=' + token, data);
}

function patchProductTags(id, token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/ProductTags/' + id + '?access_token=' + token, data);
}

function deleteProductTags(id, token, data) {
  return _request2.default.delete(URL_PREFIX + '/api/ProductTags/' + id + '?access_token=' + token, data);
}

function getProductDetails() {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails');
}

function getProductDetailsOnly(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails?access_token=' + token + '&filter=' + data);
}

function addProductDetails(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/ProductDetails?access_token=' + token, data);
}

function putProductDetails(token, id, data) {
  return _request2.default.put(URL_PREFIX + '/api/ProductDetails/' + id + '?access_token=' + token, data);
}

function patchProductDetails(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/ProductDetails/' + id + '?access_token=' + token, data);
}

function getProductDetailsId(id) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails/' + id);
}

function putProductDetailsId(id, token, data) {
  return _request2.default.put(URL_PREFIX + '/api/ProductDetails/' + id + '?access_token=' + token, data);
}

function filterProductDetails(data) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails?filter=' + data);
}

function filterUser(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/UserManages?access_token=' + token + '&filter=' + data);
}

function filterStorages(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/Storages?access_token=' + token + '&filter=' + data);
}

function getProductAccessories(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails?access_token=' + token + '&filter=' + data);
}

function getProductAccessoriesDetailId(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/ProductAccessories?access_token=' + token + '&filter=' + data);
}

function postProductAccessories(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/ProductAccessories?access_token=' + token, data);
}

function deleteProductAccessories(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/ProductAccessories/' + id + '?access_token=' + token);
}

function getProductAccessoriesId(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails/' + id + '/accessory?access_token=' + token);
}

function getProducts(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Products?access_token=' + token + '&filter=' + filter);
}

function patchProducts(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/Products/' + id + '?access_token=' + token, data);
}

function getStorageCount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Products/count?access_token=' + token + '&where=' + filter);
}

function getProductsId(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/Products/' + id + '?access_token=' + token);
}

function getProductsIds(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/Products/' + id + '?access_token=' + token);
}

function patchProductsIds(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/Products/' + id + '?access_token=' + token, data);
}

function deleteProducts(id) {
  return _request2.default.delete(URL_PREFIX + '/api/Products/' + id);
}

function postProducts(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/Products?access_token=' + token, data);
}

function finishOrder(token, id, data) {
  return _request2.default.post(URL_PREFIX + '/api/Orders/' + id + '/finish?access_token=' + token, data);
}

function putProducts(token, id, data) {
  return _request2.default.put(URL_PREFIX + '/api/Products/' + id + '?access_token=' + token, data);
}

function deleteProductsOne(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/Products/' + id + '?access_token=' + token);
}

function getStorages(token) {
  return _request2.default.get(URL_PREFIX + '/api/Storages?access_token=' + token);
}

function getStoragesId(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/Storages/' + id + '?access_token=' + token);
}

function postStorages(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/Storages?access_token=' + token, data);
}

function patchStorages(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/Storages/' + id + '?access_token=' + token, data);
}

function deleteStorages(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/Storages/' + id + '?access_token=' + token);
}

function getAccessory(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails?access_token=' + token + '&filter=' + data);
}

function addAccessory(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/ProductDetails?access_token=' + token, data);
}

function removeAccessory(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/ProductDetails/' + id + '?access_token=' + token);
}

function removeProduct(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/ProductDetails/' + id + '?access_token=' + token);
}

function postProductTag(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/ProductTagDetails?access_token=' + token, data);
}

function deleteProductTag(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/ProductTagDetails/' + id + '?access_token=' + token);
}

function getProductTagId(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails/' + id + '/tag?access_token=' + token);
}

function getProductTagAll(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/ProductTagDetails?access_token=' + token + '&filter=' + data);
}

function getUsers(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/UserManages?access_token=' + token + '&filter=' + filter);
}

function getUsersDetail(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/UserManages/' + id + '?access_token=' + token);
}

function patchUsersPsd(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/UserManages/' + id + '?access_token=' + token, data);
}

function getUserIdentification(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/UserManages/' + id + '/userIdentification?access_token=' + token);
}

function getDefaultAddress(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/UserManages/' + id + '/defaultAddress?access_token=' + token);
}

function getUserOrder(token, id, filter) {
  return _request2.default.get(URL_PREFIX + '/api/UserManages/' + id + '/orders?access_token=' + token + '&filter=' + filter);
}

function getOrderId(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/Orders/' + id + '?access_token=' + token);
}

function deleteUser(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/UserManages/' + id + '?access_token=' + token);
}

function getIdentification(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/UserIdentifications?access_token=' + token + '&filter=' + data);
}

function getIdentificationId(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/UserIdentifications/' + id + '?access_token=' + token);
}

function putUserManage(token, id, data) {
  return _request2.default.post(URL_PREFIX + '/api/UserManages/' + id + '/identify?access_token=' + token, data);
}

function getOrder(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Orders?access_token=' + token + '&filter=' + filter);
}

function getOrderCount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Orders/count?access_token=' + token + '&where=' + filter);
}

function getProductCount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Products/count?access_token=' + token + '&where=' + filter);
}

function getProductdetailsCount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails/count?access_token=' + token + '&where=' + filter);
}

function getProductdetailCount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails/count?access_token=' + token + '&where=' + filter);
}

function getUserCount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/UserManages/count?access_token=' + token + '&where=' + filter);
}

function getFeedCount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Feedbacks/count?access_token=' + token + '&where=' + filter);
}

function getCommontCount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Comments/count?access_token=' + token + '&where=' + filter);
}

function putExpress(token, id) {
  return _request2.default.put(URL_PREFIX + '/api/Orders/' + id + '/received?access_token=' + token);
}

function sendExpress(token, id, data) {
  return _request2.default.put(URL_PREFIX + '/api/Orders/' + id + '/deliver?access_token=' + token, data);
}

function updateZM(token, id, data) {
  return _request2.default.put(URL_PREFIX + '/api/UserManages/' + id + '/updateZM?access_token=' + token);
}

function deleteOrder(token, id) {
  return _request2.default.post(URL_PREFIX + '/api/Orders/' + id + '/del?access_token=' + token);
}

function cancelOrder(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/Orders/' + id + '/cancel?access_token=' + token);
}

function alipayMiniCancelOrder(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/Orders/' + id + '/alipayMiniCancel?access_token=' + token + '&reason=\'\u7528\u6237\u6C9F\u901A\u53D6\u6D88\'');
}

function backOrder(token, id, data) {
  return _request2.default.put(URL_PREFIX + '/api/Orders/' + id + '/return?access_token=' + token, data);
}

function getStoragesList(token) {
  return _request2.default.get(URL_PREFIX + '/api/Storages?access_token=' + token);
}

function getComments(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Comments?access_token=' + token + '&filter=' + filter);
}

function filterComments(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/Comments?access_token=' + token + '&filter=' + data);
}

function putComments(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/Comments/' + id + '?access_token=' + token, data);
}

function deleteComments(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/Comments/' + id + '?access_token=' + token);
}

function getOrderDetail(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/Orders/' + id + '?access_token=' + token);
}

function getFeedBack(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/Feedbacks?access_token=' + token + '&filter=' + filter);
}

function patchFeedBack(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/Feedbacks/' + id + '?access_token=' + token, data);
}

function deleteFeedBack(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/Feedbacks/' + id + '?access_token=' + token);
}

function getExpress(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/ExpressStatuses?access_token=' + token + '&filter=' + data);
}

function getExpressD(token, express, shipper) {
  return _request2.default.get(URL_PREFIX + '/api/ExpressStatuses/syncStatus?access_token=' + token + '&expressNum=' + express + '&shipper=' + shipper);
}

function getHot(token) {
  return _request2.default.get(URL_PREFIX + '/api/GlobalSettings/search_words?access_token=' + token);
}

function patchHot(token, data) {
  return _request2.default.patch(URL_PREFIX + '/api/GlobalSettings/search_words?access_token=' + token, data);
}
function getRentHistory(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/Products/' + id + '/showHistory?access_token=' + token);
}

function getAccount(token, filter) {
  return _request2.default.get(URL_PREFIX + '/api/AdminUsers?access_token=' + token + '&filter=' + filter);
}

function deleteAccount(token, id) {
  return _request2.default.delete(URL_PREFIX + '/api/AdminUsers/' + id + '?access_token=' + token);
}

function patchPsd(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/AdminUsers/' + id + '?access_token=' + token, data);
}

function getAccountId(token, id) {
  return _request2.default.get(URL_PREFIX + '/api/AdminUsers/' + id + '?access_token=' + token);
}

function addAccount(token, data) {
  return _request2.default.post(URL_PREFIX + '/api/AdminUsers?access_token=' + token, data);
}

function changeBackExpress(token, id, data) {
  return _request2.default.post(URL_PREFIX + '/api/Orders/' + id + '/setReturnExpress?access_token=' + token, data);
}

function patchAccount(token, id, data) {
  return _request2.default.patch(URL_PREFIX + '/api/AdminUsers/' + id + '?access_token=' + token, data);
}

function getMount(token, id, begin, end) {
  return _request2.default.get(URL_PREFIX + '/api/ProductDetails/' + id + '/amount?access_token=' + token + '&begin=' + begin + '&end=' + end);
}

function getProductRent(token, data) {
  return _request2.default.get(URL_PREFIX + '/api/ProductRentLogs?access_token=' + token + '&filter=' + data);
}

function getTongji(token) {
  return _request2.default.get(URL_PREFIX + '/api/AdminUsers/getStatistics?access_token=' + token);
}

function getFreashOrder(token) {
  return _request2.default.get(URL_PREFIX + '/api/AdminUsers/updateOrderSum?access_token=' + token);
}

function putProduct(token, id) {
  return _request2.default.put(URL_PREFIX + '/api/ProductDetails/' + id + '/updateRentalSum?access_token=' + token);
}

function zmRefundOrder(orderId, token) {
  return _request2.default.get(URL_PREFIX + '/api/ZmRefundOrders/refundDone?orderId=' + orderId + '&access_token=' + token);
}

function doInstallment(orderId, token) {
  return _request2.default.get(URL_PREFIX + '/api/ZmInstallments/doInstallment?orderId=' + orderId + '&access_token=' + token);
}

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'https://wx.shareplay.cc';

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(151);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get: function get(url) {
    return _axios2.default.get(url);
  },
  post: function post(url, params) {
    return _axios2.default.post(url, params);
  },
  put: function put(url, params) {
    return _axios2.default.put(url, params);
  },
  delete: function _delete(url, params) {
    return _axios2.default.delete(url);
  },
  patch: function patch(url, params) {
    return _axios2.default.patch(url, params);
  }
};

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(656);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(654);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(655);

var _Home2 = _interopRequireDefault(_Home);

var _IndexVersion = __webpack_require__(669);

var _IndexVersion2 = _interopRequireDefault(_IndexVersion);

var _IndexBanner = __webpack_require__(666);

var _IndexBanner2 = _interopRequireDefault(_IndexBanner);

var _AddBanner = __webpack_require__(658);

var _AddBanner2 = _interopRequireDefault(_AddBanner);

var _IndexTopic = __webpack_require__(668);

var _IndexTopic2 = _interopRequireDefault(_IndexTopic);

var _AddTopic = __webpack_require__(661);

var _AddTopic2 = _interopRequireDefault(_AddTopic);

var _Form = __webpack_require__(665);

var _Form2 = _interopRequireDefault(_Form);

var _user = __webpack_require__(671);

var _user2 = _interopRequireDefault(_user);

var _ShopList = __webpack_require__(670);

var _ShopList2 = _interopRequireDefault(_ShopList);

var _AddShop = __webpack_require__(660);

var _AddShop2 = _interopRequireDefault(_AddShop);

var _IndexCatogrey = __webpack_require__(667);

var _IndexCatogrey2 = _interopRequireDefault(_IndexCatogrey);

var _AddCategory = __webpack_require__(659);

var _AddCategory2 = _interopRequireDefault(_AddCategory);

var _EditBanner = __webpack_require__(662);

var _EditBanner2 = _interopRequireDefault(_EditBanner);

var _ProductClassify = __webpack_require__(701);

var _ProductClassify2 = _interopRequireDefault(_ProductClassify);

var _ProductTag = __webpack_require__(703);

var _ProductTag2 = _interopRequireDefault(_ProductTag);

var _ProductList = __webpack_require__(702);

var _ProductList2 = _interopRequireDefault(_ProductList);

var _EditTopic = __webpack_require__(664);

var _EditTopic2 = _interopRequireDefault(_EditTopic);

var _AddProduct = __webpack_require__(694);

var _AddProduct2 = _interopRequireDefault(_AddProduct);

var _Equipment = __webpack_require__(699);

var _Equipment2 = _interopRequireDefault(_Equipment);

var _AddEquipment = __webpack_require__(691);

var _AddEquipment2 = _interopRequireDefault(_AddEquipment);

var _AddEquipmentX = __webpack_require__(692);

var _AddEquipmentX2 = _interopRequireDefault(_AddEquipmentX);

var _EditEquipmentX = __webpack_require__(696);

var _EditEquipmentX2 = _interopRequireDefault(_EditEquipmentX);

var _OptionalList = __webpack_require__(700);

var _OptionalList2 = _interopRequireDefault(_OptionalList);

var _AddOptional = __webpack_require__(693);

var _AddOptional2 = _interopRequireDefault(_AddOptional);

var _EditOptional = __webpack_require__(697);

var _EditOptional2 = _interopRequireDefault(_EditOptional);

var _EditEquipment = __webpack_require__(695);

var _EditEquipment2 = _interopRequireDefault(_EditEquipment);

var _UserList = __webpack_require__(706);

var _UserList2 = _interopRequireDefault(_UserList);

var _UserView = __webpack_require__(707);

var _UserView2 = _interopRequireDefault(_UserView);

var _Identified = __webpack_require__(705);

var _Identified2 = _interopRequireDefault(_Identified);

var _ChangeIdentified = __webpack_require__(704);

var _ChangeIdentified2 = _interopRequireDefault(_ChangeIdentified);

var _OrderList = __webpack_require__(679);

var _OrderList2 = _interopRequireDefault(_OrderList);

var _EditProduct = __webpack_require__(698);

var _EditProduct2 = _interopRequireDefault(_EditProduct);

var _EditShop = __webpack_require__(663);

var _EditShop2 = _interopRequireDefault(_EditShop);

var _StorageList = __webpack_require__(681);

var _StorageList2 = _interopRequireDefault(_StorageList);

var _CommentList = __webpack_require__(674);

var _CommentList2 = _interopRequireDefault(_CommentList);

var _OrderDetail = __webpack_require__(677);

var _OrderDetail2 = _interopRequireDefault(_OrderDetail);

var _FeedBack = __webpack_require__(676);

var _FeedBack2 = _interopRequireDefault(_FeedBack);

var _OrderExpress = __webpack_require__(678);

var _OrderExpress2 = _interopRequireDefault(_OrderExpress);

var _SendExpress = __webpack_require__(680);

var _SendExpress2 = _interopRequireDefault(_SendExpress);

var _BackDevice = __webpack_require__(672);

var _BackDevice2 = _interopRequireDefault(_BackDevice);

var _BackExpress = __webpack_require__(673);

var _BackExpress2 = _interopRequireDefault(_BackExpress);

var _DeviceBack = __webpack_require__(675);

var _DeviceBack2 = _interopRequireDefault(_DeviceBack);

var _WechatPic = __webpack_require__(689);

var _WechatPic2 = _interopRequireDefault(_WechatPic);

var _Banner = __webpack_require__(683);

var _Banner2 = _interopRequireDefault(_Banner);

var _Rules = __webpack_require__(688);

var _Rules2 = _interopRequireDefault(_Rules);

var _RentRule = __webpack_require__(687);

var _RentRule2 = _interopRequireDefault(_RentRule);

var _Help = __webpack_require__(685);

var _Help2 = _interopRequireDefault(_Help);

var _HotSearch = __webpack_require__(686);

var _HotSearch2 = _interopRequireDefault(_HotSearch);

var _About = __webpack_require__(682);

var _About2 = _interopRequireDefault(_About);

var _ZmSetting = __webpack_require__(690);

var _ZmSetting2 = _interopRequireDefault(_ZmSetting);

var _AccountList = __webpack_require__(657);

var _AccountList2 = _interopRequireDefault(_AccountList);

var _GetStatistics = __webpack_require__(684);

var _GetStatistics2 = _interopRequireDefault(_GetStatistics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '首页设置',
    iconCls: 'el-icon-message',
    children: [{ path: '/main', component: _IndexVersion2.default, name: '首页版本设置' }, { path: '/banner', component: _IndexBanner2.default, name: '', hidden: true }, { path: '/addBanner', component: _AddBanner2.default, name: '', hidden: true }, { path: '/indexTopic', component: _IndexTopic2.default, name: '', hidden: true }, { path: '/addtopic', component: _AddTopic2.default, name: '', hidden: true }, { path: '/shopList', component: _ShopList2.default, name: '', hidden: true }, { path: '/addShop', component: _AddShop2.default, name: '', hidden: true }, { path: '/indexCatogrey', component: _IndexCatogrey2.default, name: '', hidden: true }, { path: '/addCategory', component: _AddCategory2.default, name: '', hidden: true }, { path: '/editBanner/:id', component: _EditBanner2.default, name: '', hidden: true }, { path: '/editTopic/:id', component: _EditTopic2.default, name: '', hidden: true }, { path: '/editProduct/:id', component: _EditProduct2.default, name: '', hidden: true }, { path: '/addProduct', component: _AddProduct2.default, name: '', hidden: true }, { path: '/editShop/:id', component: _EditShop2.default, name: '', hidden: true }]
}, {
    path: '/product',
    component: _Home2.default,
    name: '商品管理',
    iconCls: 'el-icon-message',
    children: [{ path: '/classify', component: _ProductClassify2.default, name: '商品分类' }, { path: '/tag', component: _ProductTag2.default, name: '商品标签' }, { path: '/list', component: _ProductList2.default, name: '商品列表' }, { path: '/equipment/:id', component: _Equipment2.default, name: '设备列表', hidden: true }, { path: '/addEquipment/:id', component: _AddEquipment2.default, name: '添加设备(设备入库)', hidden: true }, { path: '/optinalList', component: _OptionalList2.default, name: '选配列表' }, { path: '/addOptional', component: _AddOptional2.default, name: '', hidden: true }, { path: '/editOptional/:id', component: _EditOptional2.default, name: '', hidden: true }, { path: '/editEquipment/:id', component: _EditEquipment2.default, name: '', hidden: true }, { path: '/addEquipmentX/:id', component: _AddEquipmentX2.default, name: '', hidden: true }, { path: '/editEquipmentX/:id', component: _EditEquipmentX2.default, name: '', hidden: true }, { path: '/changeIdentified/:id', component: _ChangeIdentified2.default, name: '', hidden: true }]
}, {
    path: '/user',
    component: _Home2.default,
    name: '用户管理',
    iconCls: 'el-icon-message',
    children: [{ path: '/userList', component: _UserList2.default, name: '用户列表' }, { path: '/userView/:id', component: _UserView2.default, name: '', hidden: true }, { path: '/identified', component: _Identified2.default, name: '实名认证管理' }]
}, {
    path: '/order',
    component: _Home2.default,
    name: '订单管理',
    iconCls: 'el-icon-message',
    children: [{ path: '/orderList', component: _OrderList2.default, name: '订单列表' }, { path: '/storageList', component: _StorageList2.default, name: '仓库地址设置' }, { path: '/commentList', component: _CommentList2.default, name: '评论列表' }, { path: '/feedBack', component: _FeedBack2.default, name: '意见反馈列表' }, { path: '/orderExpress', component: _OrderExpress2.default, name: '订单发货管理' }, { path: '/backExpress', component: _BackExpress2.default, name: '退款订单列表' }, { path: '/deviceBack', component: _DeviceBack2.default, name: '设备返还入库' }, { path: '/orderDetail/:id', component: _OrderDetail2.default, name: '', hidden: true }, { path: '/sendExpress/:id', component: _SendExpress2.default, name: '', hidden: true }, { path: '/backDevice/:id', component: _BackDevice2.default, name: '', hidden: true }]
}, {
    path: '/other',
    component: _Home2.default,
    name: '其他设置',
    iconCls: 'el-icon-message',
    children: [{ path: '/wechatPic', component: _WechatPic2.default, name: '小程序分享封面图设置' }, { path: '/indexBanner', component: _Banner2.default, name: 'banner设置' }, { path: '/rules', component: _Rules2.default, name: '用户协议设置' }, { path: '/rentRule', component: _RentRule2.default, name: '租赁规则' }, { path: '/help', component: _Help2.default, name: '帮助中心' }, { path: '/alipayRentRule', component: _RentRule2.default, name: '支付宝小程序租赁规则' }, { path: '/alipayHelp', component: _Help2.default, name: '支付宝小程序帮助中心' }, { path: '/hotWord', component: _HotSearch2.default, name: '热门标签设置' }, { path: '/about', component: _About2.default, name: '关于我们' }, { path: '/zmSetting', component: _ZmSetting2.default, name: '芝麻设置' }]
}, {
    path: '/tong',
    component: _Home2.default,
    name: '数据统计',
    iconCls: 'el-icon-message',
    children: [{ path: '/static', component: _GetStatistics2.default, name: '数据统计' }]
}, {
    path: '/account',
    component: _Home2.default,
    name: '账号管理',
    iconCls: 'el-icon-message',
    children: [{ path: '/accountList', component: _AccountList2.default, name: '账号列表' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(22);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(149);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(329);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(330);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10,
    uptoken: '',
    currentIndex: [],
    categoryArr: [],
    topicArr: [],
    productArr: [],
    localBanner: []
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    },
    SETTOKEN: function SETTOKEN(state, token) {
        state.uptoken = token;
    },
    SETCURRENTINDEX: function SETCURRENTINDEX(state, val) {
        state.currentIndex = val;
    },
    SETTOPICARR: function SETTOPICARR(state, val) {
        state.topicArr = val;
    },
    SETCATEGORYARR: function SETCATEGORYARR(state, val) {
        state.categoryArr = val;
    },
    SETPRODUCTARR: function SETPRODUCTARR(state, val) {
        state.productArr = val;
    },
    SETLOCALBANNER: function SETLOCALBANNER(state, val) {
        state.localBanner.push(val);
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			sysName: 'VUEADMIN',
			collapsed: false,
			sysUserName: '111',
			sysUserAvatar: '',

			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},
	created: function created() {
		this.sysUserName = sessionStorage.userName;
		console.log(this.sysUserName, '1');
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {},

		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {}).then(function () {
				sessionStorage.removeItem('user');
				_this.$router.push('/login');
			}).catch(function () {});
		},

		collapse: function collapse() {
			this.collapsed = !this.collapsed;
		},
		showMenu: function showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		}
	},
	mounted: function mounted() {}
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _login = __webpack_require__(327);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;

          var loginParams = { username: _this2.ruleForm2.account, password: _this2.ruleForm2.checkPass };
          (0, _login.login)(loginParams).then(function (data) {
            sessionStorage.setItem('userId', data.data.id);
            sessionStorage.setItem('userName', data.data.userId);
            var ids = data.data.userId;
            (0, _version.getAccountId)(sessionStorage.userId, ids).then(function (res) {
              if (res.data) {
                sessionStorage.power = res.data.power;
              }
            });
            (0, _login.getToken)(data.data.userId, data.data.id).then(function (res) {
              _this2.$store.commit('SETTOKEN', res.data.uptoken);
              sessionStorage.setItem('token', res.data.uptoken);
            });
            _this2.logining = false;
            var status = data.status;

            if (status !== 200) {
              _this2.$message({
                message: '登录失败',
                type: 'error'
              });
            } else {
              sessionStorage.setItem('user', (0, _stringify2.default)('ff'));

              _this2.$router.push({ path: '/main' });
            }
          }).catch(function (err) {
            console.log(err.response, 'ff');
            _this2.$message.error(err.response.data.error.message);
            _this2.logining = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            dialogPsdVisible: false,
            psdForm: {},
            userIds: '',
            fetchList: [],
            addTag: false,
            editTag: false,
            uptoken: {
                token: sessionStorage.token
            },
            userForm: {
                username: '',
                nickName: '',
                phoneNumber: '',
                password: '',
                power: ''

            },
            addTagRules: {
                username: [{
                    required: true,
                    message: '请输入用户名',
                    trigger: 'blur'
                }],
                nickName: [{
                    required: true,
                    message: '请输入姓名',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }],
                power: [{
                    required: true,
                    message: '请选择用户角色',
                    trigger: 'blur'
                }],
                phoneNumber: [{
                    required: true,
                    message: '请输入手机号',
                    trigger: 'blur'
                }]
            }
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getAccount)(sessionStorage.userId, (0, _stringify2.default)({
            'include': 'creator'
        })).then(function (res) {
            console.log(res.data);
            _this.fetchList = res.data;
        }, function (err) {
            console.log(err);
        });
    },


    methods: {
        handleEditPsd: function handleEditPsd(index, row) {
            this.dialogPsdVisible = true;
            this.userIds = row.userId;
        },
        submitNewPsd: function submitNewPsd() {
            var _this2 = this;

            console.log(this.psdForm.psd);

            if (this.psdForm.psd) {
                var data = {
                    password: this.psdForm.psd
                };
                (0, _version.patchPsd)(sessionStorage.userId, this.userIds, data).then(function (res) {
                    if (res.data) {
                        _this2.dialogPsdVisible = false;
                        _this2.$message({
                            message: '成功修改密码',
                            type: 'success'
                        });
                    }
                }, function (err) {
                    _this2.$message.error('修改密码失败');
                });
            }
        },
        handleDelete: function handleDelete(index, row) {
            var _this3 = this;

            this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this3.fetchList.splice(index, 1);

                (0, _version.deleteAccount)(sessionStorage.userId, row.userId).then(function (res) {
                    if (res.data.count) {
                        _this3.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                }, function (err) {
                    _this3.$message.error('删除失败');
                });
            }).catch(function () {
                _this3.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleEdit: function handleEdit(index, row) {
            this.editTag = true;
            this.userForm = JSON.parse((0, _stringify2.default)(row));
            if (this.userForm.power === 1) {
                this.userForm.power = '管理员';
            } else {
                this.userForm.power = '运营';
            }

            console.log(row);
        },
        handleAdd: function handleAdd() {
            this.userForm = {
                username: '',
                nickName: '',
                phoneNumber: '',
                password: '',
                power: ''

            };
            this.addTag = true;
        },
        handleUpdateTag: function handleUpdateTag() {
            var _this4 = this;

            this.$refs['tagForm'].validate(function (valid) {
                var data = JSON.parse((0, _stringify2.default)(_this4.tagForm));
                delete data.tagId;
                (0, _version.patchProductTags)(_this4.tagForm.tagId, sessionStorage.userId, data).then(function (res) {
                    _this4.editTag = false;
                    _this4.$message({
                        type: 'success',
                        message: '更新成功!'
                    });
                }, function (err) {
                    _this4.$message.error('新增分类失败');
                });
            });
        },
        handlePostTag: function handlePostTag() {
            var _this5 = this;

            this.$refs['userForm'].validate(function (valid) {
                if (!_this5.userForm.power) {
                    _this5.$message.error('请选择用户角色');
                } else {
                    var data = JSON.parse((0, _stringify2.default)(_this5.userForm));
                    var id = data.userId;
                    console.log(data.power);
                    if (data.power === '管理员') {
                        data.power = 1;
                    } else {
                        data.power = 0;
                    }
                    delete data.password;
                    delete data.userId;
                    (0, _version.patchAccount)(sessionStorage.userId, id, data).then(function (res) {
                        if (res.data) {
                            _this5.$message({
                                type: 'success',
                                message: '更新成功!'
                            });
                            _this5.editTag = false;
                            (0, _version.getAccount)(sessionStorage.userId, (0, _stringify2.default)({
                                'include': 'creator'
                            })).then(function (res) {
                                console.log(res.data);
                                _this5.fetchList = res.data;
                            }, function (err) {
                                console.log(err);
                            });
                        } else {
                            console.log('ff');
                        }
                    }, function (err) {
                        if (err.response.data.error.statusCode === '422') {
                            _this5.$message.error('姓名已存在，请修改后，在提交');
                        }
                    });
                }
            });
        },
        handleNewTag: function handleNewTag() {
            var _this6 = this;

            this.$refs['userForm'].validate(function (valid) {
                if (!_this6.userForm.power) {
                    _this6.$message.error('请选择用户角色');
                } else {
                    var data = JSON.parse((0, _stringify2.default)(_this6.userForm));
                    console.log(data.power);
                    if (data.power === '管理员') {
                        data.power = 1;
                    } else {
                        data.power = 0;
                    }
                    data.email = 'admin_' + data.username + '@shareplay.cc';
                    (0, _version.addAccount)(sessionStorage.userId, data).then(function (res) {
                        if (res.data) {
                            _this6.$message({
                                type: 'success',
                                message: '创建成功!'
                            });

                            (0, _version.getAccount)(sessionStorage.userId, (0, _stringify2.default)({
                                'include': 'creator'
                            })).then(function (res) {
                                console.log(res.data);
                                _this6.fetchList = res.data;
                            }, function (err) {
                                console.log(err);
                            });

                            _this6.addTag = false;
                        }
                    }, function (err) {
                        if (err.response.data.error.statusCode === '422') {
                            _this6.$message.error('姓名已存在，请修改后，在提交');
                        }
                    });
                }
            });
        }
    }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            bannerForm: {
                type: '',
                choosedName: ''
            },
            choosedName: '',
            imageUrl: '',
            upImage: '',
            type: '',
            targetId: '',
            uptoken: {
                token: sessionStorage.token
            },
            categoryArr: [],
            topicArr: [],
            productArr: [],
            chooseCatogry: false,
            chooseTopic: false,
            chooseProduct: false,
            cur_categroy: {
                now: ''
            },
            cur_topic: {
                now: ''
            },
            cur_product: {
                now: ''
            }
        };
    },
    created: function created() {
        this.productArr = this.$store.state.topicArr;
        this.categoryArr = this.$store.state.categoryArr;
        this.topicArr = this.$store.state.productArr;
        console.log(this.topicArr, 'ff');
    },

    methods: {
        onSubmit: function onSubmit() {
            if (!this.targetId) {
                this.$message.error('您还未选择转换类型具体分类');
            } else if (typeof this.type !== 'number') {
                this.$message.error('您还未选择图片转换类型');
            } else if (!this.upImage) {
                this.$message.error('您还未上传banner图片');
            } else {
                var bannerData = {
                    'picUrl': this.upImage,
                    'type': this.type,
                    'targetId': this.targetId
                };
                var currentData = this.$store.state.currentIndex;

                currentData.value.banner.push(bannerData);
                this.$store.commit('SETCURRENTINDEX', currentData);
                this.$message({
                    message: '新建成功',
                    type: 'success'
                });
                this.$router.push('/banner');
            }
        },
        goBack: function goBack() {
            this.$router.push('/banner');
        },
        typeChange: function typeChange(val) {
            if (val === '商品类型') {
                this.type = 0;
                this.chooseCatogry = true;
            } else if (val === '商品') {
                this.type = 2;
                this.chooseProduct = true;
            } else {
                this.type = 1;
                this.chooseTopic = true;
            }
        },
        handleAvatarSuccess: function handleAvatarSuccess(res, file) {
            this.upImage = 'https://img.shareplay.cc/' + res.key;
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload: function beforeAvatarUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            };

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        productChoose: function productChoose() {
            var _this = this;

            this.targetId = this.cur_product.now;
            this.productArr.forEach(function (item) {
                if (item.productDetailId === _this.targetId) {
                    _this.bannerForm.choosedName = item.name;
                }
            });
            this.chooseProduct = false;
        },
        topicChoose: function topicChoose() {
            var _this2 = this;

            this.targetId = this.cur_topic.now;
            this.topicArr.forEach(function (item) {
                if (item.tagId === _this2.targetId) {
                    _this2.bannerForm.choosedName = item.name;
                }
            });
            this.chooseTopic = false;
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        },
        catogryChoose: function catogryChoose() {
            var _this3 = this;

            this.targetId = this.cur_categroy.now;
            this.categoryArr.forEach(function (item) {
                if (item.categoryId === _this3.targetId) {
                    _this3.bannerForm.choosedName = item.name;
                }
            });
            this.chooseCatogry = false;
        }
    }
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            categoryForm: {
                catogrey: '',
                product: ''
            },
            addShopRules: {
                name: [{
                    required: true,
                    message: '请输入享玩甄选描述',
                    trigger: 'blur'
                }],
                shop: [{
                    type: 'number',
                    required: true,
                    message: '请选择商品',
                    trigger: 'blur'
                }]
            },
            uptoken: {
                token: sessionStorage.token
            },
            catogreyArr: []

        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getProductCategories)().then(function (res) {
            _this.catogreyArr = res.data;
            console.log(res.data);
            _this.$store.commit('SETTOPICARR', _this.catogreyArr);
        });
    },

    methods: {
        catogreyChoose: function catogreyChoose(val) {
            var _this2 = this;

            this.catogreyArr.forEach(function (item) {
                if (item.categoryId === val) {
                    _this2.categoryForm.product = item;
                }
            });
        },
        goBack: function goBack() {
            this.$router.push('/indexCatogrey');
        },
        onSubmit: function onSubmit() {
            if (this.categoryForm.product) {
                var data = {
                    picUrl: this.categoryForm.product.picUrl,
                    targetId: this.categoryForm.product.categoryId,
                    name: this.categoryForm.product.name
                };
                var currentData = this.$store.state.currentIndex;
                currentData.value.category.push(data);
                this.$store.commit('SETCURRENTINDEX', currentData);
                this.$router.push('/indexCatogrey');
            } else {
                this.$message.error('请选择分类');
            }
        }
    }
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            shopForm: {
                price_current: '',
                price_old: '',
                name: '',
                shop: '',
                product: '',
                description: ''
            },
            addShopRules: {
                name: [{
                    required: true,
                    message: '请输入享玩甄选描述',
                    trigger: 'blur'
                }],
                shop: [{
                    type: 'number',
                    required: true,
                    message: '请选择商品',
                    trigger: 'blur'
                }]
            },
            uptoken: {
                token: sessionStorage.token
            },
            productArr: []

        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getProductDetailsOnly)(sessionStorage.userId, (0, _stringify2.default)({ where: { accessoryType: 0 } })).then(function (res) {
            _this.productArr = res.data;
            console.log(res.data);
            _this.$store.commit('SETTOPICARR', _this.productArr);
        });
    },

    methods: {
        goBack: function goBack() {
            this.$router.push('/shopList');
        },
        productChoose: function productChoose(val) {
            var _this2 = this;

            this.productArr.forEach(function (item) {
                if (item.productDetailId === val) {
                    _this2.shopForm.product = item;
                }
            });
        },
        onSubmit: function onSubmit() {
            var _this3 = this;

            console.log(this.shopForm);
            this.$refs['shopForm'].validate(function (valid) {
                if (valid) {
                    _this3.shopForm.price_current = _this3.shopForm.product.rental;
                    _this3.shopForm.price_old = _this3.shopForm.product.oldRental;
                    _this3.shopForm.targetId = _this3.shopForm.product.productDetailId;
                    _this3.shopForm.name = _this3.shopForm.name;
                    _this3.shopForm.description = _this3.shopForm.product.name;
                    _this3.shopForm.picUrl = _this3.shopForm.product.media ? _this3.shopForm.product.media.pic[0] : '';

                    var currentData = _this3.$store.state.currentIndex;
                    var current = JSON.parse((0, _stringify2.default)(_this3.shopForm));
                    delete current.product;
                    delete current.shop;
                    current.targetid = current.targetId * 1;
                    currentData.value.product.push(current);
                    _this3.$store.commit('SETCURRENTINDEX', currentData);
                    _this3.$router.push('/shopList');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            topicForm: {
                targetId: '',
                title: '',
                caption: '',
                topicType: '',
                shop: '',
                banner: '',
                product: '',
                productDetails: []
            },
            topicUrl: '',
            choosedNow: '',
            fileList2: [],
            upImage: '',
            type: '',
            targetId: '',
            uptoken: {
                token: sessionStorage.token
            },
            productArr: [],
            picArr: [],
            topicArr: [],
            categoryArr: [],
            chooseCatogry: false,
            chooseTopic: false,
            cur_categroy: {
                now: ''
            },
            cur_topic: {
                now: ''
            },
            addTopicRules: {
                title: [{
                    required: true,
                    message: '请输入专题标题',
                    trigger: 'blur'
                }],
                caption: [{
                    required: true,
                    message: '请输入专题描述',
                    trigger: 'blur'
                }],
                banner: [{
                    required: true,
                    message: '请上传专题banner图',
                    trigger: 'blur'
                }],
                shop: [{
                    type: 'number',
                    required: true,
                    message: '请选择专题下的商品',
                    trigger: 'blur'
                }],
                topicType: [{
                    required: true,
                    message: '请选择跳转类型',
                    trigger: 'blur'
                }]
            }
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getProductDetailsOnly)(sessionStorage.userId, (0, _stringify2.default)({ where: { accessoryType: 0 } })).then(function (res) {
            _this.productArr = res.data;
            console.log(res.data);
            _this.$store.commit('SETTOPICARR', _this.productArr);
        });
        (0, _version.getProductCategories)().then(function (res) {
            _this.categoryArr = res.data;
            _this.$store.commit('SETCATEGORYARR', _this.categoryArr);
        });

        (0, _version.getProductTags)().then(function (res) {
            _this.topicArr = res.data;
            _this.$store.commit('SETPRODUCTARR', _this.topicArr);
        });
    },

    methods: {
        remove: function remove(index) {
            this.topicForm.productDetails.splice(index, 1);
        },
        goBack: function goBack() {
            this.$router.push('/indexTopic');
        },
        addProduct: function addProduct() {
            var current_product = this.topicForm.product;
            console.log(current_product);

            if (current_product && this.topicUrl) {
                this.topicForm.productDetails.push({
                    picUrl: current_product.media ? current_product.media.pic[0] : null,
                    qrcode: this.topicUrl,
                    name: current_product.name,
                    productDetailId: current_product.productDetailId,
                    price_old: current_product.oldRental,
                    price_current: current_product.rental
                });
                this.topicUrl = '';
                this.topicForm.product = '';
                this.topicForm.shop = '';
            } else if (!current_product) {
                this.$message.error('请先选择商品');
            } else if (!this.topicUrl) {
                this.$message.error('请上传商品二维码尺寸');
            }
        },
        typeChange: function typeChange(val) {
            this.topicForm.topicType = val;
            if (val === '0') {
                this.chooseCatogry = true;
            } else {
                this.chooseTopic = true;
            }
        },
        productChoose: function productChoose(val) {
            var _this2 = this;

            this.productArr.forEach(function (item) {
                if (item.productDetailId === val) {
                    _this2.topicForm.product = item;
                }
            });
        },
        topicChoose: function topicChoose() {
            var _this3 = this;

            this.topicForm.targetId = this.cur_topic.now;
            this.chooseTopic = false;
            this.topicArr.forEach(function (item) {
                if (item.tagId === _this3.topicForm.targetId) {
                    _this3.choosedNow = item.name;
                }
            });
        },
        catogryChoose: function catogryChoose() {
            var _this4 = this;

            this.topicForm.targetId = this.cur_categroy.now;
            this.chooseCatogry = false;
            this.categoryArr.forEach(function (item) {
                if (item.categoryId === _this4.topicForm.targetId) {
                    _this4.choosedNow = item.name;
                }
            });
        },
        onSubmit: function onSubmit() {
            var _this5 = this;

            console.log(this.topicForm);
            this.$refs['topicForm'].validate(function (valid) {
                if (valid) {
                    if (!_this5.topicForm.productDetails.length) {
                        _this5.$message.error('请先添加商品!');
                    } else {
                        var currentData = _this5.$store.state.currentIndex;
                        var current = JSON.parse((0, _stringify2.default)(_this5.topicForm));
                        delete current.shop;
                        delete current.product;
                        current.topicType = current.topicType * 1;
                        currentData.value.topic.push(current);
                        _this5.$store.commit('SETCURRENTINDEX', currentData);
                        _this5.$router.push('/indexTopic');
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleAvatarSuccess: function handleAvatarSuccess(res, file) {
            this.topicForm.banner = 'https://img.shareplay.cc/' + res.key;
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        handlePicArrSuccess: function handlePicArrSuccess(res, file) {
            this.topicUrl = 'https://img.shareplay.cc/' + res.key;
        },
        beforeAvatarUpload: function beforeAvatarUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            };

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        handleRemove: function handleRemove(file, fileList) {
            this.fileList2 = fileList;
        },
        handlePreview: function handlePreview(file) {
            console.log(file);
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        }
    }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            bannerForm: {
                type: '',
                choosedName: ''
            },
            choosedName: '',
            imageUrl: '',
            upImage: '',
            type: '',
            targetId: '',
            uptoken: {
                token: sessionStorage.token
            },
            categoryArr: [],
            topicArr: [],
            productArr: [],
            chooseCatogry: false,
            chooseTopic: false,
            chooseProduct: false,
            cur_categroy: {
                now: ''
            },
            cur_topic: {
                now: ''
            },
            cur_product: {
                now: ''
            }
        };
    },
    created: function created() {
        var _this = this;

        this.productArr = this.$store.state.topicArr;
        this.categoryArr = this.$store.state.categoryArr;
        this.topicArr = this.$store.state.productArr;
        var currentData = '';
        this.$store.state.currentIndex.value.banner.forEach(function (item) {
            if (item.targetId === _this.$route.params.id * 1) {
                currentData = item;
            }
        });

        this.upImage = currentData.picUrl;
        this.imageUrl = currentData.picUrl;
        this.type = currentData.type;
        this.targetId = currentData.targetId;

        this.bannerForm = {
            picUrl: currentData.picUrl,
            type: currentData.type + '',
            targetId: currentData.targetId + ''
        };

        if (currentData.type == 0) {
            this.cur_categroy = {
                now: currentData.targetId
            };
            this.categoryArr.forEach(function (item2) {
                if (item2.categoryId === currentData.targetId) {
                    _this.bannerForm.choosedName = item2.name;
                }
            });
        } else if (currentData.type == 1) {
            this.cur_topic = {
                now: currentData.targetId
            };
            this.topicArr.forEach(function (item2) {
                if (item2.tagId === currentData.targetId) {
                    _this.bannerForm.choosedName = item2.name;
                }
            });
        } else {
            this.cur_product = {
                now: currentData.targetId
            };
            this.productArr.forEach(function (item2) {
                if (item2.productDetailId === currentData.targetId) {
                    _this.bannerForm.choosedName = item2.name;
                }
            });
        }
    },

    methods: {
        onSubmit: function onSubmit() {
            var bannerData = {
                'picUrl': this.upImage,
                'type': this.type * 1,
                'targetId': this.targetId
            };
            console.log(bannerData);
            var currentData = this.$store.state.currentIndex;
            var index = this.$route.params.id * 1;
            currentData.value.banner.forEach(function (item, i) {
                if (item.targetId === index) {
                    currentData.value.banner.splice(i, 1, bannerData);
                }
            });

            console.log(currentData, 'dd');
            this.$store.commit('SETCURRENTINDEX', currentData);
            this.$message({
                message: '编辑成功',
                type: 'success'
            });
            this.$router.push('/banner');
        },
        goBack: function goBack() {
            this.$router.push('/banner');
        },
        typeChange: function typeChange(val) {
            if (val === '0') {
                this.type = '0';
                this.chooseCatogry = true;
            } else if (val === '2') {
                this.type = '2';
                this.chooseProduct = true;
            } else {
                this.type = '1';
                this.chooseTopic = true;
            }
        },
        handleAvatarSuccess: function handleAvatarSuccess(res, file) {
            this.upImage = 'https://img.shareplay.cc/' + res.key;
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload: function beforeAvatarUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            };

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        productChoose: function productChoose() {
            var _this2 = this;

            this.targetId = this.cur_product.now;
            this.productArr.forEach(function (item) {
                if (item.productDetailId === _this2.targetId) {
                    _this2.bannerForm.choosedName = item.name;
                }
            });
            this.chooseProduct = false;
        },
        topicChoose: function topicChoose() {
            var _this3 = this;

            this.targetId = this.cur_topic.now;
            this.topicArr.forEach(function (item) {
                if (item.tagId === _this3.targetId) {
                    _this3.bannerForm.choosedName = item.name;
                }
            });
            this.chooseTopic = false;
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        },
        catogryChoose: function catogryChoose() {
            var _this4 = this;

            this.targetId = this.cur_categroy.now;
            this.categoryArr.forEach(function (item) {
                if (item.categoryId === _this4.targetId) {
                    _this4.bannerForm.choosedName = item.name;
                }
            });
            this.chooseCatogry = false;
        }
    }
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            shopForm: {
                price_current: '',
                price_old: '',
                name: '',
                shop: this.$route.params.id * 1,
                product: '',
                description: ''
            },
            addShopRules: {
                name: [{
                    required: true,
                    message: '请输入享玩甄选描述',
                    trigger: 'blur'
                }],
                shop: [{
                    type: 'number',
                    required: true,
                    message: '请选择商品',
                    trigger: 'blur'
                }]
            },
            uptoken: {
                token: sessionStorage.token
            },
            productArr: []

        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getProductDetailsOnly)(sessionStorage.userId, (0, _stringify2.default)({ where: { accessoryType: 0 } })).then(function (res) {
            _this.productArr = res.data;
            var currentData = _this.$store.state.currentIndex.value.product;
            var _id = _this.$route.params.id;
            var ids = '';

            currentData.forEach(function (item) {
                if (item.name === _id) {
                    _this.shopForm.name = item.name;
                    _this.shopForm.price_current = item.price_current;
                    _this.shopForm.price_old = item.price_old;
                    ids = item.targetId;
                }
            });
            res.data.forEach(function (item) {
                if (item.productDetailId === ids) {
                    _this.shopForm.product = item;
                    _this.shopForm.shop = ids;
                    _this.shopForm.product.rental = _this.shopForm.price_current;
                    _this.shopForm.product.oldRental = _this.shopForm.price_old;
                }
            });
            _this.$store.commit('SETTOPICARR', _this.productArr);
        });
    },

    methods: {
        goBack: function goBack() {
            this.$router.push('/shopList');
        },
        productChoose: function productChoose(val) {
            var _this2 = this;

            this.productArr.forEach(function (item) {
                if (item.productDetailId === val) {
                    _this2.shopForm.product = item;
                    _this2.shopForm.shop = item.productDetailId;
                }
            });
        },
        onSubmit: function onSubmit() {
            var _this3 = this;

            console.log(this.shopForm);
            this.$refs['shopForm'].validate(function (valid) {
                if (valid) {
                    _this3.shopForm.price_current = _this3.shopForm.product.rental;
                    _this3.shopForm.price_old = _this3.shopForm.product.oldRental;
                    _this3.shopForm.targetId = _this3.shopForm.product.productDetailId;
                    _this3.shopForm.name = _this3.shopForm.name;
                    _this3.shopForm.description = _this3.shopForm.product.name;
                    _this3.shopForm.picUrl = _this3.shopForm.product.media.pic[0];

                    var currentData = _this3.$store.state.currentIndex;
                    var current = JSON.parse((0, _stringify2.default)(_this3.shopForm));
                    delete current.product;
                    delete current.shop;
                    current.targetid = current.targetId;
                    currentData.value.product.forEach(function (item, index) {
                        if (item.name === _this3.$route.params.id) {
                            console.log('!');
                            currentData.value.product[index] = current;
                        }
                    });
                    _this3.$store.commit('SETCURRENTINDEX', currentData);
                    _this3.$router.push('/shopList');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            topicForm: {
                targetId: '',
                title: '',
                caption: '',
                topicType: '',
                shop: '',
                banner: '',
                product: '',
                productDetails: []
            },
            oldData: {},
            topicUrl: '',
            choosedNow: '',
            fileList2: [],
            upImage: '',
            type: '',
            targetId: '',
            uptoken: {
                token: sessionStorage.token
            },
            productArr: [],
            picArr: [],
            topicArr: [],
            categoryArr: [],
            chooseCatogry: false,
            chooseTopic: false,
            cur_categroy: {
                now: ''
            },
            cur_topic: {
                now: ''
            },
            addTopicRules: {
                title: [{
                    required: true,
                    message: '请输入专题标题',
                    trigger: 'blur'
                }],
                caption: [{
                    required: true,
                    message: '请输入专题描述',
                    trigger: 'blur'
                }],
                banner: [{
                    required: true,
                    message: '请上传专题banner图',
                    trigger: 'blur'
                }],
                shop: [{
                    type: 'number',
                    required: true,
                    message: '请选择专题下的商品',
                    trigger: 'blur'
                }],
                topicType: [{
                    required: true,
                    message: '请选择跳转类型',
                    trigger: 'blur'
                }]
            }
        };
    },
    created: function created() {
        var _this = this;

        console.log(this.$route.params.id);
        var indexs = this.$route.params.id;
        var currentData = '';
        this.$store.state.currentIndex.value.topic.forEach(function (item, index) {
            if (item.caption === indexs) {
                currentData = item;
            }
        });
        var currentAll = this.$store.state.currentIndex;
        this.oldData = JSON.parse((0, _stringify2.default)(currentAll));
        this.topicForm = {
            targetId: currentData.targetId,
            title: currentData.title,
            caption: currentData.caption,
            topicType: currentData.topicType + '',
            banner: currentData.banner,
            productDetails: currentData.productDetails,
            shop: '',
            product: ''
        };

        console.log(currentData, 'd');
        (0, _version.getProductDetailsOnly)(sessionStorage.userId, (0, _stringify2.default)({ where: { accessoryType: 0 } })).then(function (res) {
            _this.productArr = res.data;
            console.log(res.data);
            _this.$store.commit('SETTOPICARR', _this.productArr);
        });
        (0, _version.getProductCategories)().then(function (res) {
            _this.categoryArr = res.data;
            _this.$store.commit('SETCATEGORYARR', _this.categoryArr);
            console.log(currentData.topicType, 'who');
            if (currentData.topicType === 0) {
                _this.categoryArr.forEach(function (item) {
                    if (item.categoryId === currentData.targetId) {
                        _this.choosedNow = item.name;
                    }
                });
            }
        });

        (0, _version.getProductTags)().then(function (res) {
            _this.topicArr = res.data;
            _this.$store.commit('SETPRODUCTARR', _this.topicArr);
            if (currentData.topicType === 1) {
                _this.topicArr.forEach(function (item) {
                    if (item.tagId === currentData.targetId) {
                        _this.choosedNow = item.name;
                    }
                });
            }
        });
    },

    methods: {
        remove: function remove(index) {
            this.topicForm.productDetails.splice(index, 1);
        },
        goBack: function goBack() {
            this.$router.push('/indexTopic');
            this.$store.commit('SETCURRENTINDEX', this.oldData);
        },
        addProduct: function addProduct() {
            var current_product = this.topicForm.product;

            if (current_product && this.topicUrl) {
                this.topicForm.productDetails.push({
                    picUrl: current_product.media ? current_product.media.pic[0] : '',
                    qrcode: this.topicUrl,
                    name: current_product.name,
                    productDetailId: current_product.productDetailId,
                    price_old: current_product.oldRental,
                    price_current: current_product.rental
                });
                this.topicUrl = '';
                this.topicForm.product = '';
                this.topicForm.shop = '';
            } else if (!current_product) {
                this.$message.error('请先选择商品');
            } else if (!this.topicUrl) {
                this.$message.error('请上传商品二维码尺寸');
            }
        },
        typeChange: function typeChange(val) {
            this.topicForm.topicType = val;
            if (val === '0') {
                this.chooseCatogry = true;
            } else {
                this.chooseTopic = true;
            }
        },
        productChoose: function productChoose(val) {
            var _this2 = this;

            this.productArr.forEach(function (item) {
                if (item.productDetailId === val) {
                    _this2.topicForm.product = item;
                }
            });
        },
        topicChoose: function topicChoose() {
            var _this3 = this;

            this.topicForm.targetId = this.cur_topic.now;
            this.chooseTopic = false;
            this.topicArr.forEach(function (item) {
                if (item.tagId === _this3.topicForm.targetId) {
                    _this3.choosedNow = item.name;
                }
            });
        },
        catogryChoose: function catogryChoose() {
            var _this4 = this;

            this.topicForm.targetId = this.cur_categroy.now;
            this.chooseCatogry = false;
            this.categoryArr.forEach(function (item) {
                if (item.categoryId === _this4.topicForm.targetId) {
                    _this4.choosedNow = item.name;
                }
            });
        },
        onSubmit: function onSubmit() {
            var _this5 = this;

            console.log(this.topicForm);
            this.$refs['topicForm'].validate(function (valid) {
                if (valid) {
                    if (!_this5.topicForm.productDetails.length) {
                        _this5.$message.error('请先添加商品!');
                    } else {
                        var currentData = _this5.$store.state.currentIndex;
                        var current = JSON.parse((0, _stringify2.default)(_this5.topicForm));
                        delete current.shop;
                        delete current.product;
                        current.topicType = current.topicType * 1;
                        currentData.value.topic.forEach(function (item, index) {
                            if (item.caption === _this5.$route.params.id) {
                                currentData.value.topic.splice(index, 1, current);
                            }
                        });

                        _this5.$store.commit('SETCURRENTINDEX', currentData);
                        _this5.$router.push('/indexTopic');
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleAvatarSuccess: function handleAvatarSuccess(res, file) {
            this.topicForm.banner = 'https://img.shareplay.cc/' + res.key;
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        handlePicArrSuccess: function handlePicArrSuccess(res, file) {
            this.topicUrl = 'https://img.shareplay.cc/' + res.key;
        },
        beforeAvatarUpload: function beforeAvatarUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            };

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        handleRemove: function handleRemove(file, fileList) {
            this.fileList2 = fileList;
        },
        handlePreview: function handlePreview(file) {
            console.log(file);
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        }
    }
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		}
	}
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(69);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			Role: sessionStorage.power,
			fetchList: [],
			global: [],
			userRules: {
				user: [{
					max: 10,
					messasge: '最大长度是 10 个字符'
				}]
			},
			userForm: {
				user: '1',
				role: ''
			},
			editFormVisible: false,
			editForm: {
				username: '',
				address: ''
			},
			addBanner: false,
			versionForm: {
				version: '',
				base: '',
				remark: ''
			},
			versionOption: [],
			imageUrl: '',
			uptoken: {
				token: sessionStorage.token
			},
			topicArr: [],
			productArr: [],
			categoryArr: []
		};
	},
	created: function created() {
		var _this = this;

		var cate = (0, _version.getProductCategories)().then(function (res) {
			_this.categoryArr = res.data;
			_this.$store.commit('SETCATEGORYARR', _this.categoryArr);
		});

		var tag = (0, _version.getProductTags)().then(function (res) {
			_this.topicArr = res.data;
			_this.$store.commit('SETPRODUCTARR', _this.topicArr);
		});

		var pro = (0, _version.getProductDetailsOnly)(sessionStorage.userId, (0, _stringify2.default)({ where: { accessoryType: 0 } })).then(function (res) {
			_this.productArr = res.data;
			_this.$store.commit('SETTOPICARR', _this.productArr);
		});

		_promise2.default.all([cate, tag, pro]).then(function (val) {
			var currentData = _this.$store.state.currentIndex;
			var bannerData = [];

			bannerData = JSON.parse((0, _stringify2.default)(currentData.value.banner));
			bannerData.forEach(function (item, index) {
				if (item.type === 0) {
					_this.categoryArr.forEach(function (item2) {
						if (item2.categoryId === item.targetId) {
							item.targetName = item2.name;
						}
					});
				} else if (item.type === 1) {
					_this.topicArr.forEach(function (item2) {
						if (item2.tagId === item.targetId) {
							item.targetName = item2.name;
						}
					});
				} else {
					_this.productArr.forEach(function (item2) {
						if (item2.productDetailId === item.targetId) {
							item.targetName = item2.name;
						}
					});
				}
			});
			_this.fetchList = bannerData;
			console.log(_this.fetchList, 'fetch');
		});

		(0, _version.getGlobalSettings)().then(function (res) {
			_this.global = res.data;
			console.log(res);
		});

		(0, _version.filterIndexVersions)().then(function (res) {
			_this.versionOption = res.data;
			console.log(res, 'hh');
		});
	},

	methods: {
		handleEdit: function handleEdit(index, row) {
			this.$router.push('/editBanner/' + row.targetId);
		},
		handleAdd: function handleAdd() {
			this.$router.push('/addbanner');
		},
		next: function next() {
			var currentData = this.$store.state.currentIndex;
			if (currentData.value.banner.length) {
				this.$router.push('/indexTopic');
			} else {
				this.$message({
					message: '请先添加轮播banner',
					type: 'warning'
				});
			}
		},
		handleDelete: function handleDelete(index, row) {
			var _this2 = this;

			this.$confirm('此操作将永久删除该Banner, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				_this2.fetchList.forEach(function (item, index) {
					if (item.picUrl === row.picUrl) {
						_this2.fetchList.splice(index, 1);
					}
				});

				var currentBanner = JSON.parse((0, _stringify2.default)(_this2.fetchList));
				var currentData = _this2.$store.state.currentIndex;
				currentBanner.forEach(function (item) {
					delete item.targetName;
				});
				currentData.value.banner = currentBanner;
				_this2.$store.commit('SETCURRENTINDEX', currentData);
				_this2.$message({
					type: 'success',
					message: '删除成功!'
				});
			}).catch(function () {
				_this2.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		handleCheck: function handleCheck(val) {},
		refresh: function refresh() {
			this.$refs.user.refresh();
		},
		handleAvatarSuccess: function handleAvatarSuccess(res, file) {
			this.imageUrl = URL.createObjectURL(file.raw);
		},
		beforeAvatarUpload: function beforeAvatarUpload(file) {
			var isJPG = file.type === 'image/jpeg';
			var isLt2M = file.size / 1024 / 1024 < 2;
			this.uptoken = {
				token: sessionStorage.token
			};

			if (!isJPG) {
				this.$message.error('上传头像图片只能是 JPG 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
			}
			return isJPG && isLt2M;
		}
	}
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            Role: sessionStorage.power,
            uptoken: {
                token: sessionStorage.userId
            }
        };
    },
    created: function created() {
        var currentData = this.$store.state.currentIndex;
        this.fetchList = currentData.value.category;
    },


    methods: {
        handleAdd: function handleAdd() {
            this.$router.push('/addCategory');
        },
        next: function next() {
            var _this = this;

            var currentData = this.$store.state.currentIndex;
            var upData = JSON.parse((0, _stringify2.default)(currentData));
            delete upData.base;
            if (upData.id) {
                var data = JSON.parse((0, _stringify2.default)(upData));
                delete data.id;

                (0, _version.putVersions)(this.uptoken.token, upData.id, data).then(function (res) {
                    console.log(res, 'xi');
                    if (res.data.version) {
                        _this.$message({
                            message: '成功更新版本信息',
                            type: 'success'
                        });
                        _this.$router.push('/main');
                    }
                }, function (err) {
                    _this.$message.error('更新数据失败');
                });
            } else {
                (0, _version.postVersions)(this.uptoken.token, upData).then(function (res) {
                    console.log(res.data.data);
                    if (res.data) {
                        _this.$message({
                            message: '成功创建首页版本',
                            type: 'success'
                        });
                        _this.$router.push('/main');
                    }
                }, function (err) {
                    console.log(err);
                    _this.$message.error('创建失败，请检查相关数据');
                });
            }

            console.log(currentData);
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                console.log(_this2.fetchList);
                console.log(index);
                _this2.fetchList.splice(index, 1);
                var currentCategory = JSON.parse((0, _stringify2.default)(_this2.fetchList));
                var currentData = _this2.$store.state.currentIndex;

                currentData.value.category = currentCategory;
                _this2.$store.commit('SETCURRENTINDEX', currentData);
                _this2.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
    }
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			Role: sessionStorage.power,
			fetchList: [],
			editFormVisible: false,
			editForm: {
				username: '',
				address: ''
			},
			imgUrl: '',
			uptoken: {
				token: sessionStorage.token
			}
		};
	},
	created: function created() {
		var currentData = this.$store.state.currentIndex;
		this.fetchList = currentData.value.topic;
	},


	methods: {
		handleEdit: function handleEdit(index, row) {
			console.log(row);
			this.$router.push('/editTopic/' + row.caption);
		},
		handleAdd: function handleAdd() {
			this.$router.push('/addtopic');
		},
		next: function next() {
			var currentData = this.$store.state.currentIndex;
			if (currentData.value.topic.length) {
				this.$router.push('/shopList');
			} else {
				this.$message({
					message: '请先添加专题',
					type: 'warning'
				});
			}
		},
		handleDelete: function handleDelete(index, row) {
			var _this = this;

			this.$confirm('此操作将永久删除该Banner, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				_this.fetchList.splice(index, 1);
				var currentTopic = JSON.parse((0, _stringify2.default)(_this.fetchList));
				var currentData = _this.$store.state.currentIndex;

				currentData.value.topic = currentTopic;
				_this.$store.commit('SETCURRENTINDEX', currentData);
				_this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}).catch(function () {
				_this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		}
	}
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(336);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(158);

var _assign2 = _interopRequireDefault(_assign);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fetchList: [],
      global: [],
      Role: sessionStorage.power,
      referList: {
        global: '全部来源',
        wechat: '微信小程序',
        alipay: '支付宝小程序',
        h5: 'H5网页APP'
      },
      addVersionRules: {
        remark: [{
          required: true,
          message: '请输入版本名称',
          trigger: 'blur'
        }],
        version: [{
          required: true,
          message: '请输入版本号',
          trigger: 'blur'
        }]
      },
      userForm: {
        user: '1',
        role: ''
      },
      addVersion: false,
      editVersion: false,
      versionForm: {
        version: '',
        base: '',
        remark: ''
      },
      versionOption: []
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    var localVersion = this.$store.state.currentIndex;
    (0, _version.getVersions)().then(function (data) {
      _this.fetchList = data.data.filter(function (item) {
        if (item.version && item.version.indexOf('index') == 0) {
          return item;
        }
      });
      if (localVersion.length) {
        _this.fetchList.push(localVersion);
      }
    }, function (err) {
      console.log(err, 'xx');
    });

    (0, _version.getGlobalSettings)().then(function (res) {
      res.data.forEach(function (item) {
        if (item.SettingKey === 'home_version') {
          item.SettingValue = JSON.parse(item.SettingValue);
        }
      });
      _this.global = res.data;
    });

    (0, _version.filterIndexVersions)().then(function (res) {
      _this.versionOption = res.data;
    });
  },

  methods: {
    handleEdit: function handleEdit(index, row) {
      this.versionForm = (0, _assign2.default)({}, row);
      this.editVersion = true;
      console.log(row);
    },
    handleLive: function handleLive(index, row) {
      var _this2 = this;

      var data = {
        "SettingKey": 'home_version',
        "SettingValue": (0, _stringify2.default)((0, _assign2.default)(this.global[0].SettingValue, (0, _defineProperty3.default)({}, row.refer, row.version)))
      };

      (0, _version.putGlobalSettings)(sessionStorage.userId, data).then(function (res) {
        console.log(res.data);
        if (res.data.SettingKey) {
          _this2.$message({
            message: '成功激活',
            type: 'success'
          });
          _this2.global[0].SettingValue = JSON.parse(res.data.SettingValue);
        }
      }, function (err) {
        console.log(err);
      });
    },
    handleAdd: function handleAdd() {
      this.versionForm = {
        version: '',
        base: '',
        remark: '',
        refer: ''
      };
      this.addVersion = true;
    },
    handleDelete: function handleDelete(index, row) {
      var _this3 = this;

      this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        console.log(row.id);
        (0, _version.deleteVersions)(sessionStorage.userId, row.id).then(function (res) {
          console.log(res);
          _this3.$message({
            type: 'success',
            message: '删除成功!'
          });
          _this3.fetchList.splice(index, 1);
        }, function (err) {
          _this3.$message({
            type: 'info',
            message: '删除失败'
          });
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleCheck: function handleCheck(val) {},
    submitForm: function submitForm(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this4.versionForm.value && _this4.versionForm.value.banner.length) {} else if (_this4.versionForm.base) {
            var nowId = _this4.versionForm.base;
            _this4.versionOption.forEach(function (item) {
              console.log(item, 'gg');
              if (item.id === nowId) {
                _this4.versionForm.value = item.value;
              }
            });
          } else {
            _this4.versionForm.value = {
              banner: [],
              category: [],
              product: [],
              topic: []
            };
          }
          var nowData = JSON.parse((0, _stringify2.default)(_this4.versionForm));
          nowData.base ? delete nowData.base : '';
          _this4.fetchList.push(_this4.versionForm);
          _this4.$store.commit('SETCURRENTINDEX', nowData);
          _this4.$router.push('banner');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			fetchList: [],
			Role: sessionStorage.power,
			uptoken: { token: sessionStorage.token }
		};
	},
	created: function created() {
		var currentData = this.$store.state.currentIndex;
		this.fetchList = currentData.value.product;
		console.log(this.fetchList, 'all');
	},


	methods: {
		handleAdd: function handleAdd() {
			this.$router.push('/addShop');
		},
		next: function next() {
			var currentData = this.$store.state.currentIndex;
			if (currentData.value.product.length) {
				this.$router.push('/indexCatogrey');
			} else {
				this.$message({
					message: '请先设置享玩甄选',
					type: 'warning'
				});
			}
		},
		handleDelete: function handleDelete(index, row) {
			var _this = this;

			this.$confirm('此操作将永久删除该Banner, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				_this.fetchList.forEach(function (item, index) {
					if (item.name === row.name) {
						_this.fetchList.splice(index, 1);
					}
				});

				var currentProduct = JSON.parse((0, _stringify2.default)(_this.fetchList));
				var currentData = _this.$store.state.currentIndex;

				currentData.value.product = currentProduct;
				_this.$store.commit('SETCURRENTINDEX', currentData);
				_this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}).catch(function () {
				_this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		handleEdit: function handleEdit(index, row) {
			console.log(row);
			this.$router.push('/editShop/' + row.name);
		}
	}
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(326);

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			loading: false,
			users: []
		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},

		getUser: function getUser() {
			var _this = this;

			var para = {
				name: this.filters.name
			};
			this.loading = true;

			(0, _api.getUserList)(para).then(function (res) {
				_this.users = res.data.users;
				_this.loading = false;
			});
		}
	},
	mounted: function mounted() {
		this.getUser();
	}
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            num: 0,
            row: {},
            userInfo: {},
            rentDay: '',
            wayValue: '',
            backCount: 0,
            withholdCount: 0,
            sendForm: {
                shipper: ''
            },
            form: {},
            dialogFormVisible: false,
            waysArr: [{
                value: 'self',
                name: '自提'
            }, {
                value: 'express',
                name: '快递'
            }],
            expressArr: [{
                value: 'SF',
                name: '顺丰'
            }],
            options: [],
            value5: [],
            items: [],
            cur: '',
            productVal: [],
            allProduct: [],
            isFinish: false
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getOrderId)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            console.log(res, 'd');
            _this.row = res.data;
            _this.items = JSON.parse((0, _stringify2.default)(_this.row.orderItems));


            (0, _version.getUsersDetail)(sessionStorage.userId, res.data.userId).then(function (res) {
                _this.userInfo = res.data;
            });

            var day = '';

            if (res.data && res.data.dispalyExtra && res.data.dispalyExtra.tenancy.length) {
                console.log(res.data.dispalyExtra.tenancy, 'f');
                day = parseInt((new Date(res.data.dispalyExtra.tenancy[0].end) - new Date(res.data.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                _this.rentDay = day === 0 ? '1' : day + 1;
            }

            if (res.data.delivery && res.data.delivery.sendShipper) {
                var filter = {
                    'where': {
                        'expressNum': res.data.delivery.sendExpressNum,
                        'shipper': res.data.delivery.sendShipper
                    }
                };

                console.log(filter);
                (0, _version.getExpress)(sessionStorage.userId, (0, _stringify2.default)(filter)).then(function (res) {
                    console.log(res.data);
                    _this.expressData = res.data[0];
                });
            }
        });
    },

    methods: {
        fromatDate: function fromatDate(str) {
            function double(val) {
                if (val > 9) {
                    return val;
                }
                return '0' + val;
            }

            var d = new Date(str);
            var year = d.getFullYear();
            var month = d.getMonth() + 1;
            var date = d.getDate();

            return double(year) + '-' + double(month) + '-' + double(date);
        },
        handleBack: function handleBack() {
            history.go(-1);
        },
        back: function back() {
            var _this2 = this;

            if (!this.backCount && !this.row.isAlipayMini) {
                this.$message({
                    type: 'info',
                    message: '请填写押金退还金额'
                });
            }

            this.$confirm('此操作将确认入库, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.isFinish = true;
                (0, _version.finishOrder)(sessionStorage.userId, _this2.$route.params.id, { depositRefundCount: _this2.backCount * 1, withholdCount: _this2.withholdCount * 1 }).then(function (res) {
                    if (res.data) {
                        _this2.$message({
                            message: '已确认',
                            type: 'success'
                        });
                        history.go(-1);
                    }
                }, function (err) {
                    _this2.$message.error(err.response.data.error.message);
                });
            });
        },
        handleChoose: function handleChoose(index, row) {
            var _this3 = this;

            this.dialogFormVisible = true;
            this.cur = index;
            (0, _version.getProducts)(sessionStorage.userId, (0, _stringify2.default)({
                'where': {
                    'productDetailId': row.productDetailId,
                    'isOnline': true
                }
            })).then(function (res) {
                if (res.data) {
                    _this3.productVal = [];
                    var _row = _this3.row.orderItems[index];

                    if (_row.productIds) {
                        _row.productIds.forEach(function (id) {
                            res.data.forEach(function (item) {
                                var oflag = true;
                                if (item.productId === id) {
                                    _this3.productVal.push(item);
                                    for (var i = 0; i < _this3.allProduct.length; i++) {
                                        if (_this3.allProduct[i].productId === id) {
                                            oflag = false;
                                        }
                                    }

                                    if (oflag) {
                                        _this3.allProduct.push(item);
                                    }
                                }
                            });
                        });
                    }
                }
            });
            console.log(row);
        },
        sureNow: function sureNow() {
            var _this4 = this;

            console.log(this.productVal);
            this.productVal.forEach(function (item) {
                console.log(item);
                _this4.num++;
                (0, _version.patchProductsIds)(sessionStorage.userId, item.productId, { 'otherProperty': item.otherProperty }).then(function (res) {});
            });

            this.dialogFormVisible = false;
        },
        onSubmit: function onSubmit() {
            var _this5 = this;

            if (!this.sendForm.expressNumber) {
                this.$message.error('请填写快递单号');
            } else if (this.wayValue != 'self' && !this.sendForm.shipper) {
                this.$message.error('请选择快递公司');
            } else {

                this.sendForm.products = [];
                this.items.forEach(function (item) {
                    _this5.sendForm.products.push({
                        orderItemId: item.productDetailId,
                        productIds: item.productIds
                    });
                });
                console.log(this.wayValue);
                if (this.wayValue === 'self') {
                    this.sendForm.shipper = 'SELF';
                }

                this.$confirm('此操作将确认发货, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {

                    (0, _version.sendExpress)(sessionStorage.userId, _this5.$route.params.id, _this5.sendForm).then(function (res) {
                        console.log(res.data);
                        if (res.data) {
                            _this5.$message({
                                message: '已发货',
                                type: 'success'
                            });
                            _this5.$router.push('/orderExpress');
                        }
                    });
                }).catch(function () {
                    _this5.$message({
                        type: 'info',
                        message: '已取消发货'
                    });
                });
            }
        }
    }
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            currentPage: 1,
            totalNum: 0,
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        var filter = (0, _stringify2.default)({
            "limit": 20,
            "skip": 0,
            "order": "id desc",
            'include': 'userManage',
            'where': {
                'or': [{
                    status: 8
                }, {
                    status: 9
                }]
            }
        });
        (0, _version.getOrder)(sessionStorage.userId, filter).then(function (res) {
            _this.fetchList = res.data;
            _this.totalCount = res.data.length;
            _this.loading = false;
            _this.fetchList.forEach(function (item, index) {
                var day = '';
                if (item.dispalyExtra.tenancy[0]) {
                    day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                }

                _this.fetchList[index].rentDay = day === 0 ? '1' : day;
            });
        });
        (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({
            'or': [{
                status: 8
            }, {
                status: 9
            }]
        })).then(function (res) {
            console.log(res.data);
            _this.totalNum = res.data.count;
        });
    },


    methods: {
        handleSizeChange: function handleSizeChange(val) {
            console.log("\u6BCF\u9875 " + val + " \u6761");
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this2 = this;

            this.loading = true;
            var filter = (0, _stringify2.default)({
                "limit": 20,
                "skip": 20 * --val,
                "order": "id desc",
                'where': {
                    status: 8
                }
            });
            (0, _version.getOrder)(sessionStorage.userId, filter).then(function (res) {
                _this2.fetchList = res.data;
                _this2.totalCount = res.data.length;
                _this2.loading = false;
                _this2.fetchList.forEach(function (item, index) {
                    console.log(item);
                    var day = '';
                    if (item.dispalyExtra.tenancy[0]) {
                        day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                    }

                    _this2.fetchList[index].rentDay = day === 0 ? '1' : day;
                });
            });
        },
        handleSend: function handleSend(index, row) {
            this.$router.push('/sendExpress/' + row.id);
        },
        agreeRefund: function agreeRefund(index, row) {
            var _this3 = this;

            (0, _version.zmRefundOrder)(row.id, sessionStorage.userId).then(function (res) {
                if (res.data.result === 'success') {
                    _this3.fetchList[index].status = 9;
                }
            });
        },

        selectionChange: function selectionChange(selections) {
            this.$emit("selectionChange", selections);
        },
        Search: function Search() {},
        startChange: function startChange(val) {
            console.log(val);
            this.pickerOptionsEnd = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < new Date(val).getTime();
                }
            };
        },
        endChange: function endChange(val) {
            console.log(val);
            this.pickerOptionsStart = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > new Date(val).getTime();
                }
            };
        }
    }
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(333);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(69);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            currentPage: 1,
            loading: true,
            totalNum: 0,
            fetchList: [],
            formInline: {
                orderNo: '',
                username: ''
            },
            dialogFormVisible: false,
            dialogCheckVisible: false,
            userInfo: '',
            form: {
                orderId: ''

            },
            filter: {}

        };
    },
    created: function created() {
        var _this2 = this;

        this.filter = (0, _stringify2.default)({
            "order": "id desc",
            "limit": 20,
            "skip": 0
        });
        (0, _version.getComments)(sessionStorage.userId, this.filter).then(function (res) {
            res.data.forEach(function (item, index) {
                var _this = index;
                var _data = res.data;
                _this2.fetchList = _data;

                if (_data[_this].photo.length) {
                    _data[_this].photo.forEach(function (item2, index) {
                        _data[_this].photo[index] = 'https://img.shareplay.cc/' + item2;
                    });
                }

                (0, _version.getUsersDetail)(sessionStorage.userId, item.userId).then(function (res) {
                    var _data = JSON.parse((0, _stringify2.default)(_this2.fetchList));
                    console.log(_this, 'g');
                    _data[_this].userInfo = res.data;
                    _this2.fetchList = _data;
                });

                (0, _version.getOrderDetail)(sessionStorage.userId, item.orderId).then(function (res) {
                    var _data = JSON.parse((0, _stringify2.default)(_this2.fetchList));
                    _data[_this].orderInfo = res.data;
                    _this2.fetchList = _data;
                });

                (0, _version.getProductDetailsId)(item.productDetailId).then(function (res) {
                    var _data = JSON.parse((0, _stringify2.default)(_this2.fetchList));
                    _data[_this].productObj = res.data;
                    _this2.fetchList = _data;
                });
            });
            _this2.loading = false;
            console.log(_this2.fetchList);
        });

        (0, _version.getCommontCount)(sessionStorage.userId, (0, _stringify2.default)({})).then(function (res) {
            console.log(res.data);
            _this2.totalNum = res.data.count;
        });
    },


    methods: {
        handleSizeChange: function handleSizeChange(val) {
            console.log('\u6BCF\u9875 ' + val + ' \u6761');
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this3 = this;

            this.loading = true;
            var filter = JSON.parse(this.filter);
            filter.skip = 20 * --val;
            this.filter = (0, _stringify2.default)(this.filter);
            (0, _version.getComments)(sessionStorage.userId, filter).then(function (res) {
                res.data.forEach(function (item, index) {
                    var _this = index;
                    var _data = res.data;

                    if (_data[_this].photo.length) {
                        _data[_this].photo.forEach(function (item2, index) {
                            _data[_this].photo[index] = 'https://img.shareplay.cc/' + item2;
                        });
                    }

                    (0, _version.getUsersDetail)(sessionStorage.userId, item.userId).then(function (res) {
                        _data[_this].userInfo = res.data;
                        _this3.fetchList = _data;
                    });

                    (0, _version.getOrderDetail)(sessionStorage.userId, item.orderId).then(function (res) {
                        _data[_this].orderInfo = res.data;
                        _this3.fetchList = _data;
                    });

                    (0, _version.getProductDetailsId)(item.productDetailId).then(function (res) {
                        _data[_this].productObj = res.data;
                        _this3.fetchList = _data;
                    });
                });
                console.log(_this3.fetchList);
                _this3.loading = false;
            });
        },
        handleView: function handleView(index, row) {
            this.dialogFormVisible = true;
            this.form = row;
        },
        handleCheck: function handleCheck(index, row) {
            this.dialogCheckVisible = true;
            this.form = row;
        },
        handlePass: function handlePass() {
            var _this4 = this;

            (0, _version.putComments)(sessionStorage.userId, this.form.id, {
                isAllowed: true,
                status: 1
            }).then(function (res) {
                console.log(res.data);
                if (res.data) {
                    _this4.$message({
                        message: '审核成功',
                        type: 'success'
                    });
                    _this4.fetchList.forEach(function (item) {
                        if (item.id === _this4.form.id) {
                            item.isAllowed = true;
                            item.status = 1;
                        }
                    });
                    _this4.dialogCheckVisible = false;
                }
            }, function (err) {
                _this4.$message.error('审核失败');
            });
        },
        handleNo: function handleNo() {
            var _this5 = this;

            (0, _version.putComments)(sessionStorage.userId, this.form.id, {
                isAllowed: false,
                status: 2
            }).then(function (res) {
                console.log(res.data);
                if (res.data) {
                    _this5.$message({
                        message: '审核成功',
                        type: 'success'
                    });
                    _this5.fetchList.forEach(function (item) {
                        if (item.id === _this5.form.id) {
                            item.isAllowed = false;
                            item.status = 2;
                        }
                    });
                    _this5.dialogCheckVisible = false;
                }
            }, function (err) {
                _this5.$message.error('审核失败');
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this6 = this;

            this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.deleteComments)(sessionStorage.userId, row.id).then(function (res) {
                    if (res.data) {
                        _this6.$message({
                            message: '成功删除',
                            type: 'success'
                        });
                        _this6.fetchList.splice(index, 1);
                    }
                }, function (err) {
                    _this6.$message.error('删除失败');
                });
            }).catch(function () {
                _this6.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        resetForm: function resetForm(formName) {
            this.formInline = {
                mobile: '',
                orderId: ''
            };
            this.$refs[formName].resetFields();
        },
        handleAdd: function handleAdd() {
            this.dialogNewVisible = true;
        },
        Search: function Search() {
            var _this7 = this;

            var search = {};
            var find = [];
            var orderTag = false;
            var userTag = false;
            if (this.formInline.orderNo) {
                orderTag = true;
                find[0] = (0, _version.getOrder)(sessionStorage.userId, (0, _stringify2.default)({
                    'where': {
                        'orderNo': {
                            'like': '%25' + this.formInline.orderNo + '%25'
                        }
                    }
                }));
            }
            if (this.formInline.username) {
                userTag = true;
                find[1] = (0, _version.filterUser)(sessionStorage.userId, (0, _stringify2.default)({
                    'where': {
                        'username': {
                            'like': '%25' + this.formInline.username + '%25'
                        }
                    }
                }));
            }

            _promise2.default.all(find).then(function (response) {
                console.log(response[0], 'ff');
                if (response[0]) {
                    var res = response[0];
                    if (res.data && res.data.length) {
                        search.orderId = res.data[0].id;
                    } else {
                        _this7.totalNum = 0;
                        _this7.fetchList = [];
                    }
                }
                if (response[1]) {
                    var _res = response[1];
                    if (_res.data && _res.data.length) {
                        search.userId = _res.data[0].userId;
                    } else {
                        _this7.totalNum = 0;
                        _this7.fetchList = [];
                    }
                }
            }).then(function (res) {
                console.log(search, 'search');
                if ((0, _keys2.default)(search).length == 0) {
                    if (userTag || orderTag) {
                        _this7.$message.error('没有符合条件的评论');
                        return false;
                    } else {
                        _this7.filter = (0, _stringify2.default)({
                            "order": "id desc",
                            "limit": 20,
                            "skip": 0
                        });
                    }
                } else {
                    if (userTag && !search.userId) {
                        _this7.$message.error('没有符合条件的评论');
                        return false;
                    }
                    if (orderTag && !search.orderId) {
                        _this7.$message.error('没有符合条件的评论');
                        return false;
                    }
                    _this7.filter = (0, _stringify2.default)({
                        "order": "id desc",
                        "limit": 20,
                        "skip": 0,
                        'where': search
                    });
                }

                (0, _version.getComments)(sessionStorage.userId, _this7.filter).then(function (res) {
                    res.data.forEach(function (item, index) {
                        var _this = index;
                        var _data = res.data;
                        _this7.fetchList = _data;

                        if (_data[_this].photo.length) {
                            _data[_this].photo.forEach(function (item2, index) {
                                _data[_this].photo[index] = 'https://img.shareplay.cc/' + item2;
                            });
                        }

                        (0, _version.getUsersDetail)(sessionStorage.userId, item.userId).then(function (res) {
                            var _data = JSON.parse((0, _stringify2.default)(_this7.fetchList));
                            console.log(_this, 'g');
                            _data[_this].userInfo = res.data;
                            _this7.fetchList = _data;
                        });

                        (0, _version.getOrderDetail)(sessionStorage.userId, item.orderId).then(function (res) {
                            var _data = JSON.parse((0, _stringify2.default)(_this7.fetchList));
                            _data[_this].orderInfo = res.data;
                            _this7.fetchList = _data;
                        });

                        (0, _version.getProductDetailsId)(item.productDetailId).then(function (res) {
                            var _data = JSON.parse((0, _stringify2.default)(_this7.fetchList));
                            _data[_this].productObj = res.data;
                            _this7.fetchList = _data;
                        });
                    });
                    _this7.loading = false;
                    console.log(_this7.fetchList);
                });

                (0, _version.getCommontCount)(sessionStorage.userId, (0, _stringify2.default)(search)).then(function (res) {
                    console.log(res.data);
                    _this7.totalNum = res.data.count;
                });
            });
        }
    }
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            currentPage: 1,
            totalNum: 0,
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        var filter = (0, _stringify2.default)({
            "limit": 20,
            "skip": 0,
            "order": "id desc",
            'where': {
                status: 6
            },
            'include': 'userManage'
        });
        var All = '';
        (0, _version.getOrder)(sessionStorage.userId, filter).then(function (res) {
            All = res.data;
            _this.totalCount = res.data.length;

            _this.loading = false;
            All.forEach(function (item, index) {
                console.log(item);
                _this.loading = false;
                var day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                All[index].rentDay = day === 0 ? '1' : day + 1;
                _this.fetchList = All;
            });
        });
        (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({
            'status': 6
        })).then(function (res) {
            console.log(res.data);
            _this.totalNum = res.data.count;
        });
    },


    methods: {
        handleSizeChange: function handleSizeChange(val) {
            console.log("\u6BCF\u9875 " + val + " \u6761");
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this2 = this;

            this.loading = true;
            var filter = (0, _stringify2.default)({
                "limit": 20,
                "skip": 20 * --val,
                "order": "id desc",
                'where': {
                    status: 6
                }
            });
            var All = '';
            (0, _version.getOrder)(sessionStorage.userId, filter).then(function (res) {
                All = res.data;
                _this2.totalCount = res.data.length;
                _this2.loading = false;
                All.forEach(function (item, index) {
                    console.log(item);
                    var day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                    All[index].rentDay = day === 0 ? '1' : day + 1;
                    _this2.fetchList = All;
                });
            });
        },
        handleSend: function handleSend(index, row) {
            this.$router.push('/backDevice/' + row.id);
        },

        selectionChange: function selectionChange(selections) {
            this.$emit("selectionChange", selections);
        },
        Search: function Search() {},
        startChange: function startChange(val) {
            console.log(val);
            this.pickerOptionsEnd = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < new Date(val).getTime();
                }
            };
        },
        endChange: function endChange(val) {
            console.log(val);
            this.pickerOptionsStart = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > new Date(val).getTime();
                }
            };
        }
    }
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            loading: true,
            totalNum: 0,
            currentPage: 1,
            fetchList: [],
            formInline: {
                phone: ''
            },
            dialogFormVisible: false,
            userInfo: '',
            form: {
                orderId: ''

            },
            filter: {}

        };
    },
    created: function created() {
        var _this = this;

        this.filter = (0, _stringify2.default)({
            'include': 'userManage',
            "order": "id desc",
            "limit": 20,
            "skip": 0
        });

        (0, _version.getFeedBack)(sessionStorage.userId, this.filter).then(function (res) {
            _this.fetchList = res.data;
            _this.loading = false;
            console.log(_this.fetchList);
        });

        (0, _version.getFeedCount)(sessionStorage.userId, (0, _stringify2.default)({})).then(function (res) {
            console.log(res.data);
            _this.totalNum = res.data.count;
        });
    },


    methods: {
        handleSizeChange: function handleSizeChange(val) {
            console.log('\u6BCF\u9875 ' + val + ' \u6761');
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this2 = this;

            this.loading = true;
            var filter = JSON.parse(this.filter);
            filter.skip = 20 * --val;
            this.filter = (0, _stringify2.default)(filter);
            (0, _version.getFeedBack)(sessionStorage.userId, this.filter).then(function (res) {
                _this2.fetchList = res.data;
                _this2.loading = false;
            });
        },
        handleView: function handleView(index, row) {
            this.dialogFormVisible = true;
            this.form = row;
        },
        handleCheck: function handleCheck(index, row) {
            var _this3 = this;

            this.$confirm('标记为已反馈, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchFeedBack)(sessionStorage.userId, row.id, {
                    status: 1
                }).then(function (res) {
                    if (res.data) {
                        _this3.$message({
                            message: '标记成功',
                            type: 'success'
                        });
                        _this3.fetchList.forEach(function (item, index) {
                            if (item.id === row.id) {
                                _this3.fetchList[index].status = 1;
                            }
                        });
                    }
                }, function (err) {
                    _this3.$message.error('标记失败');
                });
            }).catch(function () {
                _this3.$message({
                    type: 'info',
                    message: '已取消标记'
                });
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this4 = this;

            this.$confirm('此操作将永久删除该反馈, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.deleteFeedBack)(sessionStorage.userId, row.id).then(function (res) {
                    if (res.data) {
                        _this4.$message({
                            message: '成功删除',
                            type: 'success'
                        });
                        _this4.fetchList.splice(index, 1);
                    }
                }, function (err) {
                    _this4.$message.error('删除失败');
                });
            }).catch(function () {
                _this4.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        resetForm: function resetForm(formName) {
            this.formInline = {
                phone: ''
            };
            this.$refs[formName].resetFields();
        },
        handleAdd: function handleAdd() {
            this.dialogNewVisible = true;
        },
        Search: function Search() {
            var _this5 = this;

            if (this.formInline.phone) {
                (0, _version.getFeedBack)(sessionStorage.userId, (0, _stringify2.default)({
                    "order": "id desc",
                    "limit": 20,
                    "skip": 0,
                    'include': 'userManage',
                    'where': {
                        'phone': {
                            'like': '%25' + this.formInline.phone + '%25'
                        }
                    }
                })).then(function (res) {
                    _this5.fetchList = res.data;
                }, function (err) {
                    console.log(err);
                });
                (0, _version.getFeedCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'phone': {
                        'like': '%25' + this.formInline.phone + '%25'
                    }

                })).then(function (res) {
                    console.log(res.data);
                    _this5.totalNum = res.data.count;
                });
            } else {
                this.filter = (0, _stringify2.default)({
                    'include': 'userManage',
                    "order": "id desc",
                    "limit": 20,
                    "skip": 0
                });

                (0, _version.getFeedBack)(sessionStorage.userId, this.filter).then(function (res) {
                    _this5.fetchList = res.data;
                    _this5.loading = false;
                    console.log(_this5.fetchList);
                });

                (0, _version.getFeedCount)(sessionStorage.userId, (0, _stringify2.default)({})).then(function (res) {
                    console.log(res.data);
                    _this5.totalNum = res.data.count;
                });
            }
        }
    }
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            dialogWu: false,
            Role: sessionStorage.power,
            wuliu: {},
            row: {},
            sureB: {},
            dialogBack: false,
            dialogBacke: false,
            status: '',
            expressData: {},
            userInfo: {},
            rentDay: '',
            storageName: '',
            storageNo: '',
            dialogFormVisible: false,
            form: {},
            value: '',
            loading: true,
            xuDay: 0,
            options: [{
                value: 'cancel',
                label: '取消订单',
                disabled: true
            }, {
                value: 'change',
                label: '更改物流信息',
                disabled: true

            }, {
                value: 'delete',
                label: '删除订单',
                disabled: true
            }, {
                value: 'sure',
                label: '确认收货',
                disabled: true
            }, {
                value: 'back',
                label: '确认返还',
                disabled: true
            }, {
                value: 'backe',
                label: '更改返还快递单号',
                disabled: true
            }],
            identityInfo: null
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getOrderId)(sessionStorage.userId, this.$route.params.id).then(function (res) {

            _this.row = res.data;

            _this.getIdentityInfo(_this.row.userId);

            if (_this.row.rentOrders.length > 1) {
                var _day = 0;

                _this.row.rentOrders.forEach(function (item, index) {
                    if (index > 0 && item.end && item.status !== 0) {
                        _day += 1;
                        _day += parseInt((new Date(item.end) - new Date(item.begin)) / (1000 * 60 * 60 * 24));
                    }
                });

                _this.xuDay = _day;
            }

            var ress = res.data;
            _this.status = res.data.status;
            ress.orderItems.forEach(function (item, index) {
                if (item.insurance > 0) {
                    ress.orderItems.push({
                        id: '',
                        name: 'PlayCare',
                        productCount: 1,
                        unitPrice: item.insurance
                    });
                }
                if (item.productIds && item.productIds.length) {
                    ress.orderItems[index].deviceArr = [];
                    item.productIds.forEach(function (item2) {
                        (0, _version.getProductsId)(sessionStorage.userId, item2).then(function (res) {
                            if (res.data) {

                                ress.orderItems[index].deviceArr.push(res.data.deviceId);
                                _this.row = JSON.parse((0, _stringify2.default)(ress));
                            }
                        });
                    });
                }
            });
            if (_this.row.status === 0) {
                _this.options[0].disabled = false;
                if (_this.Role === '1') {
                    _this.options[2].disabled = false;
                }
            }

            if (_this.row.status === 2 && _this.Role === '1') {
                _this.options[2].disabled = false;
            }

            if (_this.row.status === 3) {
                _this.options[1].disabled = false;
                _this.options[3].disabled = false;
            }

            if (_this.row.status === 4 || _this.row.status === 5) {
                _this.options[4].disabled = false;
                _this.options[5].disabled = false;
            }

            if (_this.row.status === 6 || _this.row.status === 7) {
                _this.options[5].disabled = false;
            }

            (0, _version.getUsersDetail)(sessionStorage.userId, res.data.userId).then(function (res) {
                _this.userInfo = res.data;
            });
            if (res.data.storageId) {
                (0, _version.getStoragesId)(sessionStorage.userId, res.data.storageId).then(function (res) {
                    _this.storageName = res.data.storageName;
                    _this.storageNo = res.data.storageNo;
                });
            }

            var day = '';

            if (res.data && res.data.dispalyExtra && res.data.dispalyExtra.tenancy.length) {

                day = parseInt((new Date(res.data.dispalyExtra.tenancy[0].end) - new Date(res.data.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                _this.rentDay = day === 0 ? '1' : day + 1;
            }

            if (res.data.delivery && res.data.delivery.sendShipper) {
                var filter = {
                    'where': {
                        'expressNum': res.data.delivery.sendExpressNum,
                        'shipper': res.data.delivery.sendShipper
                    }
                };

                (0, _version.getExpress)(sessionStorage.userId, (0, _stringify2.default)(filter)).then(function (res) {
                    console.log(res.data, 'gg');
                    if (res.data.length === 0) {
                        console.log('fs');
                        _this.expressData = {
                            shipper: 'SELF',
                            expressNum: filter.where.expressNum
                        };
                    } else {
                        _this.expressData = res.data[0];
                    }
                });
            }
        });
    },

    methods: {
        fromatDate: function fromatDate(str) {
            function double(val) {
                if (val > 9) {
                    return val;
                }
                return '0' + val;
            }

            var d = new Date(str);
            var year = d.getFullYear();
            var month = d.getMonth() + 1;
            var date = d.getDate();

            return double(year) + '-' + double(month) + '-' + double(date);
        },
        sureBackOrdere: function sureBackOrdere() {
            var _this2 = this;

            (0, _version.changeBackExpress)(sessionStorage.userId, this.row.id, {
                returnExpressNum: this.sureB.name,
                returnShipper: this.row.delivery.reurnShipper
            }).then(function (res) {
                console.log(res);
                if (res.data) {
                    _this2.$message({
                        type: 'success',
                        message: '更改成功！'
                    });
                    _this2.dialogBacke = false;
                    console.log(_this2.row, 'fd');
                    _this2.row.delivery.returnExpressNum = _this2.sureB.name;
                }
            }, function (err) {
                console.log(err.response.data.error);
                _this2.$message.error(err.response.data.error.message);
            });
        },
        sureChangeW: function sureChangeW() {
            var _this3 = this;

            if (this.wuliu.expressNum) {
                var products = [];
                this.row.orderItems.forEach(function (item) {
                    products.push({
                        orderItemId: item.id,
                        productIds: item.productIds
                    });
                });
                var data = {
                    expressNumber: this.wuliu.expressNum,
                    shipper: this.row.delivery.sendShipper,
                    id: this.$route.params.id,
                    products: products
                };
                (0, _version.sendExpress)(sessionStorage.userId, this.$route.params.id, data).then(function (res) {
                    if (res.data) {
                        _this3.$message({
                            type: 'success',
                            message: '更改成功！'
                        });
                        _this3.dialogWu = false;
                        history.go(-1);
                    }
                });
            }
        },
        sureBackOrder: function sureBackOrder() {
            var _this4 = this;

            (0, _version.backOrder)(sessionStorage.userId, this.$route.params.id, {
                type: 1,
                data: {
                    expressNum: this.sureB.name,
                    shipper: 'xx'
                }
            }).then(function (res) {
                if (res.data) {
                    _this4.$message({
                        type: 'success',
                        message: '确认返还成功！'
                    });
                    _this4.dialogBack = false;
                    history.go(-1);
                }
            });
        },
        back: function back() {
            history.go(-1);
        },
        handlePictureCardPreview: function handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleDetailSuccess: function handleDetailSuccess(res, file) {
            this.picArr.push({
                imgUrl: 'https://img.shareplay.cc/' + res.key,
                title: this.title

            });
        },
        searchExpress: function searchExpress() {
            var _this5 = this;

            this.loading = true;
            this.dialogFormVisible = true;
            (0, _version.getExpressD)(sessionStorage.userId, this.expressData.expressNum, this.expressData.shipper).then(function (res) {
                _this5.loading = false;
                _this5.form = res.data.result;
            });
        },
        searchBackExpress: function searchBackExpress() {
            var _this6 = this;

            (0, _version.getExpressD)(sessionStorage.userId, this.row.delivery.returnExpressNum, this.row.delivery.returnShipper).then(function (res) {
                if (res.data) {
                    _this6.dialogFormVisible = true;
                    _this6.loading = false;
                    _this6.form = res.data.result;
                }
            });
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        },
        beforeDetailUpload: function beforeDetailUpload() {},
        handleDetailRemove: function handleDetailRemove(file, fileList) {
            var _this7 = this;

            console.log(fileList[0].response);
            var arr = [];
            fileList.forEach(function (item) {
                arr.push({
                    imgUrl: 'https://img.shareplay.cc/' + item.response.key,
                    title: _this7.title
                });
            });
            this.picArr = arr;
        },
        controlChange: function controlChange(val) {
            var _this8 = this;

            if (val === 'delete') {
                this.$confirm('此操作将删除该订单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    (0, _version.deleteOrder)(sessionStorage.userId, _this8.$route.params.id).then(function (res) {
                        if (res.data) {
                            _this8.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            history.go(-1);
                        }
                    });
                }).catch(function () {
                    _this8.value = '';
                    _this8.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }

            if (val === 'sure') {
                this.$confirm('此操作将确认收货, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    (0, _version.putExpress)(sessionStorage.userId, _this8.$route.params.id).then(function (res) {
                        if (res.data) {
                            _this8.$message({
                                type: 'success',
                                message: '成功确认收货!'
                            });
                            history.go(-1);
                        }
                    });
                }).catch(function () {
                    _this8.value = '';
                    _this8.$message({
                        type: 'info',
                        message: '已取消确认收货'
                    });
                });
            }

            if (val === 'cancel') {
                this.$confirm('此操作将取消该订单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    var handler = _version.cancelOrder;
                    if (_this8.row.isAlipayMini) {
                        handler = _version.alipayMiniCancelOrder;
                    }

                    handler(sessionStorage.userId, _this8.$route.params.id).then(function (res) {
                        if (res.data) {
                            _this8.$message({
                                type: 'success',
                                message: '取消订单成功'
                            });
                        }
                    });
                }).catch(function () {
                    _this8.value = '';
                    _this8.$message({
                        type: 'info',
                        message: '已取消此操作'
                    });
                });
            }

            if (val === 'back') {
                this.dialogBack = true;
            }

            if (val === 'backe') {
                this.dialogBacke = true;
                this.sureB.name = this.row.delivery.returnExpressNum;
            }

            if (val === 'change') {
                this.dialogWu = true;
            }
        },
        onSubmit: function onSubmit() {
            var _this9 = this;

            if (this.type === 'pic') {
                if (this.picArr.length) {
                    delete this.bannerForm.id;
                    this.bannerForm.value.type = 'pic';
                    this.bannerForm.value.content = JSON.parse((0, _stringify2.default)(this.picArr));
                    putBanner(sessionStorage.userId, 13, this.bannerForm).then(function (res) {
                        if (res.data) {
                            _this9.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                        }
                    });
                }
            } else if (this.type === 'video') {
                this.bannerForm.value.type = 'video';
                this.videoData = JSON.parse((0, _stringify2.default)(this.bannerForm));
                delete this.videoData.content;
                this.videoData.value.content = {
                    videoUrl: this.videoUrl,
                    title: this.title
                };
                delete this.videoData.id;
                putBanner(sessionStorage.userId, 13, this.videoData).then(function (res) {
                    if (res.data) {
                        _this9.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                    }
                });
            }
        },
        getIdentityInfo: function getIdentityInfo(userId) {
            var _this10 = this;

            (0, _version.getUserIdentification)(sessionStorage.userId, userId).then(function (res) {
                _this10.identityInfo = res.data;
            });
        }
    }
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            currentPage: 1,
            totalNum: 0,
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        var filter = (0, _stringify2.default)({
            "limit": 20,
            "skip": 0,
            "order": "id desc",
            'include': 'userManage',
            'where': {
                status: 1
            }
        });
        (0, _version.getOrder)(sessionStorage.userId, filter).then(function (res) {
            _this.fetchList = res.data;
            _this.totalCount = res.data.length;

            _this.loading = false;
            _this.fetchList.forEach(function (item, index) {
                console.log(item);
                _this.loading = false;
                var day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                _this.fetchList[index].rentDay = day === 0 ? '1' : day + 1;
            });
        });
        (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({
            'status': 1
        })).then(function (res) {
            console.log(res.data);
            _this.totalNum = res.data.count;
        });
    },


    methods: {
        handleSizeChange: function handleSizeChange(val) {
            console.log("\u6BCF\u9875 " + val + " \u6761");
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this2 = this;

            this.loading = true;
            var filter = (0, _stringify2.default)({
                "limit": 20,
                "skip": 20 * --val,
                "order": "id desc",
                'include': 'userManage',
                'where': {
                    status: 1
                }
            });
            (0, _version.getOrder)(sessionStorage.userId, filter).then(function (res) {
                _this2.fetchList = res.data;
                _this2.totalCount = res.data.length;
                _this2.loading = false;
                _this2.fetchList.forEach(function (item, index) {
                    console.log(item);
                    var day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                    _this2.fetchList[index].rentDay = day === 0 ? '1' : day + 1;
                });
            });
        },
        handleSend: function handleSend(index, row) {
            this.$router.push('/sendExpress/' + row.id);
        },

        selectionChange: function selectionChange(selections) {
            this.$emit("selectionChange", selections);
        },
        Search: function Search() {},
        startChange: function startChange(val) {
            console.log(val);
            this.pickerOptionsEnd = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < new Date(val).getTime();
                }
            };
        },
        endChange: function endChange(val) {
            console.log(val);
            this.pickerOptionsStart = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > new Date(val).getTime();
                }
            };
        }
    }
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filterBtn: [{
                name: '全部订单',
                checked: true
            }, {
                name: '待付款',
                checked: false
            }, {
                name: '待发货',
                checked: false
            }, {
                name: '待收货',
                checked: false
            }, {
                name: '待返还确认',
                checked: false
            }, {
                name: '已完成',
                checked: false
            }, {
                name: '交易关闭',
                checked: false
            }, {
                name: '近三月',
                checked: false
            }, {
                name: '待返还',
                checked: false
            }],
            fetchList: [],
            formInline: {
                nickName: '',
                username: '',
                dayStart: '',
                dayEnd: '',
                orderNo: ''
            },
            pickerOptionsStart: {
                disabledDate: function disabledDate(time) {}
            },
            pickerOptionsEnd: {
                disabledDate: function disabledDate(time) {}
            },
            currentPage: 1,
            totalNum: 0,
            loading: true,
            filter: ''
        };
    },
    created: function created() {
        var _this = this;

        this.filter = (0, _stringify2.default)({
            "limit": 20,
            "skip": 0,
            "order": "id desc",
            'include': 'userManage'
        });
        (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
            var All = res.data;
            _this.totalCount = res.data.length;
            All.forEach(function (item, index) {
                var day = 0;
                if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                    day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                    All[index].rentDay = day === 0 ? '1' : day + 1;
                }

                _this.fetchList = All;
            });
            if (!All.length) {
                _this.fetchList = All;
            }

            _this.loading = false;
        });
        (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({})).then(function (res) {
            console.log(res.data);
            _this.totalNum = res.data.count;
        });
    },


    methods: {
        handleSizeChange: function handleSizeChange(val) {
            console.log('\u6BCF\u9875 ' + val + ' \u6761');
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this2 = this;

            this.loading = true;
            this.filter = JSON.parse(this.filter);
            this.filter['skip'] = 20 * --val;
            this.filter = (0, _stringify2.default)(this.filter);
            (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                var All = res.data;
                _this2.totalCount = res.data.length;
                All.forEach(function (item, index) {
                    var day = 0;
                    if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                        day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                        All[index].rentDay = day === 0 ? '1' : day + 1;
                    }

                    _this2.fetchList = All;
                });
                if (!All.length) {
                    _this2.fetchList = All;
                }

                _this2.loading = false;
            });
        },
        handleView: function handleView(index, row) {
            this.$router.push('/orderDetail/' + row.id);
        },

        selectionChange: function selectionChange(selections) {
            this.$emit("selectionChange", selections);
        },
        Search: function Search(id) {
            var _this3 = this;

            console.log(id);
            this.loading = true;
            this.currentPage = 1;
            this.resetForm('formInline');
            this.filterBtn.forEach(function (item) {
                item.checked = false;
            });
            this.filterBtn[id].checked = true;
            if (id === 0) {
                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage'
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this3.fetchList = All;
                    });
                    if (!All.length) {
                        _this3.fetchList = All;
                    }

                    _this3.loading = false;
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({})).then(function (res) {
                    console.log(res.data);
                    _this3.totalNum = res.data.count;
                });
            } else if (id === 1) {
                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        'status': 0
                    }
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this3.fetchList = All;
                    });
                    if (!All.length) {
                        _this3.fetchList = All;
                    }

                    _this3.loading = false;
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'status': 0

                })).then(function (res) {
                    console.log(res.data);
                    _this3.totalNum = res.data.count;
                });
            } else if (id === 2) {
                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        'status': 1
                    }
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this3.fetchList = All;
                    });
                    if (!All.length) {
                        _this3.fetchList = All;
                    }

                    _this3.loading = false;
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'status': 1

                })).then(function (res) {
                    console.log(res.data);
                    _this3.totalNum = res.data.count;
                });
            } else if (id === 3) {
                console.log('aa');

                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        'status': 3
                    }
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'status': 3

                })).then(function (res) {
                    console.log(res.data, 'fffff');
                    _this3.totalNum = res.data.count;
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this3.fetchList = All;
                    });
                    if (!All.length) {
                        _this3.fetchList = All;
                    }

                    _this3.loading = false;
                });
            } else if (id === 4) {
                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        'status': 6
                    }
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        console.log(item, 'a');
                        _this3.loading = false;
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                        }
                        All[index].rentDay = day === 0 ? '1' : day + 1;
                    });
                    _this3.fetchList = All;
                    _this3.loading = false;
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'status': 6

                })).then(function (res) {
                    console.log(res.data);
                    _this3.totalNum = res.data.count;
                });
            } else if (id === 5) {
                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        'status': 7
                    }
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this3.fetchList = All;
                    });
                    if (!All.length) {
                        _this3.fetchList = All;
                    }

                    _this3.loading = false;
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'status': 7

                })).then(function (res) {
                    console.log(res.data);
                    _this3.totalNum = res.data.count;
                });
            } else if (id === 6) {
                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        'status': 2
                    }
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this3.fetchList = All;
                    });
                    if (!All.length) {
                        _this3.fetchList = All;
                    }

                    _this3.loading = false;
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'status': 2

                })).then(function (res) {
                    console.log(res.data);
                    _this3.totalNum = res.data.count;
                });
            } else if (id === 7) {
                var date = new Date();
                var t = date.getTime();
                var m = t - 30 * 24 * 3600 * 1000;
                var s = new Date(m);
                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        created: {
                            gt: s
                        }
                    }
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this3.fetchList = All;
                    });
                    if (!All.length) {
                        _this3.fetchList = All;
                    }

                    _this3.loading = false;
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({

                    crreated: {
                        gt: s
                    }

                })).then(function (res) {
                    console.log(res.data);
                    _this3.totalNum = res.data.count;
                });
            } else if (id === 8) {
                this.filter = (0, _stringify2.default)({
                    "limit": 20,
                    "skip": 0,
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        'status': 5
                    }
                });
                (0, _version.getOrder)(sessionStorage.userId, this.filter).then(function (res) {
                    var All = res.data;
                    _this3.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this3.fetchList = All;
                    });
                    if (!All.length) {
                        _this3.fetchList = All;
                    }

                    _this3.loading = false;
                });
                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'status': 5

                })).then(function (res) {
                    console.log(res.data);
                    _this3.totalNum = res.data.count;
                });
            }
        },
        SearchFilter: function SearchFilter() {
            var _this4 = this;

            console.log(this.filter);
            this.fetchList = [];
            this.totalNum = 0;
            var status = '';
            var countFilter = {};
            var ifUser = false;
            var filterUserData = {
                'where': {}
            };

            if (this.formInline.nickName) {

                filterUserData.where.nickName = {
                    'like': '%25' + this.formInline.nickName + '%25'
                };
                ifUser = true;
            }
            if (this.formInline.username) {
                filterUserData.where.username = {
                    'like': '%25' + this.formInline.username + '%25'
                };
                ifUser = true;
            }

            if (ifUser) {
                (0, _version.filterUser)(sessionStorage.userId, (0, _stringify2.default)(filterUserData)).then(function (res) {
                    console.log(res.data);

                    if (res.data && res.data.length) {
                        res.data.forEach(function (item) {
                            countFilter.userId = item.userId;
                            if (_this4.formInline.orderNo) {
                                countFilter.orderNo = _this4.formInline.orderNo;
                            }
                            if (_this4.formInline.dayEnd || _this4.formInline.dayStart) {
                                countFilter.created = {};
                            }
                            if (_this4.formInline.dayEnd && _this4.formInline.dayStart) {
                                countFilter.created.between = [_this4.formInline.dayStart, _this4.formInline.dayEnd];
                            } else if (_this4.formInline.dayStart) {
                                countFilter.created.gt = _this4.formInline.dayStart;
                            } else if (_this4.formInline.dayEnd) {
                                countFilter.created.lt = _this4.formInline.dayEnd;
                            }

                            var countFilter2 = {
                                'where': JSON.parse((0, _stringify2.default)(countFilter))
                            };
                            countFilter2.limit = 20;
                            countFilter2.skip = 0;
                            countFilter2.order = 'id desc';
                            countFilter2.include = 'userManage';
                            _this4.filter = (0, _stringify2.default)(countFilter2);

                            (0, _version.getOrder)(sessionStorage.userId, (0, _stringify2.default)(countFilter2)).then(function (res) {
                                var All = res.data;
                                _this4.totalCount = res.data.length;
                                All.forEach(function (item, index) {
                                    var day = 0;
                                    if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                                        day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                                        All[index].rentDay = day === 0 ? '1' : day + 1;
                                    }
                                });
                                _this4.fetchList = _this4.fetchList.concat(All);


                                _this4.loading = false;
                            });

                            (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)(countFilter)).then(function (res) {
                                console.log(res.data);
                                _this4.totalNum += res.data.count;
                                _this4.currentPage = 1;
                            });
                        });
                    } else {
                        _this4.totalNum = 0;
                        _this4.fetchList = [];
                        return false;
                    }
                });
            } else {
                if (this.formInline.orderNo) {
                    countFilter.orderNo = this.formInline.orderNo;
                }
                if (this.formInline.dayEnd || this.formInline.dayStart) {
                    countFilter.created = {};
                }
                if (this.formInline.dayEnd && this.formInline.dayStart) {
                    countFilter.created.between = [this.formInline.dayStart, this.formInline.dayEnd];
                } else if (this.formInline.dayStart) {
                    countFilter.created.gt = this.formInline.dayStart;
                } else if (this.formInline.dayEnd) {
                    countFilter.created.lt = this.formInline.dayEnd;
                }

                var countFilter2 = {
                    'where': JSON.parse((0, _stringify2.default)(countFilter))
                };
                countFilter2.limit = 20;
                countFilter2.skip = 0;
                countFilter2.order = 'id desc';
                countFilter2.include = 'userManage';
                this.filter = (0, _stringify2.default)(countFilter2);

                (0, _version.getOrder)(sessionStorage.userId, (0, _stringify2.default)(countFilter2)).then(function (res) {
                    var All = res.data;
                    _this4.totalCount = res.data.length;
                    All.forEach(function (item, index) {
                        var day = 0;
                        if (item.dispalyExtra.tenancy && item.dispalyExtra.tenancy.length) {
                            day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                            All[index].rentDay = day === 0 ? '1' : day + 1;
                        }

                        _this4.fetchList = All;
                    });
                    if (!All.length) {
                        _this4.fetchList = All;
                    }

                    _this4.loading = false;
                });

                (0, _version.getOrderCount)(sessionStorage.userId, (0, _stringify2.default)(countFilter)).then(function (res) {
                    console.log(res.data);
                    _this4.totalNum = res.data.count;
                });
            }
        },
        startChange: function startChange(val) {
            console.log(val);
            this.pickerOptionsEnd = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < new Date(val).getTime();
                }
            };
        },
        resetForm: function resetForm(formName) {
            this.formInline.dayEnd = '';
            this.formInline.dayStart = '';
            this.$refs[formName].resetFields();
        },
        endChange: function endChange(val) {
            console.log(val);
            this.pickerOptionsStart = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > new Date(val).getTime();
                }
            };
        }
    }
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            curId: '',
            row: {},
            wayValue: '',
            sendForm: {
                shipper: ''
            },
            userInfo: {},
            rentDay: '',
            form: {},
            dialogFormVisible: false,
            storageArr: [],
            storage: '',
            waysArr: [{
                value: 'self',
                name: '自提'
            }, {
                value: 'express',
                name: '快递'
            }],
            expressArr: [{
                value: 'SF',
                name: '顺丰'
            }],
            options: [],
            value5: [],
            items: [],
            cur: '',
            canInstallment: true,
            installmentCount: 0,
            hasInstallmentCount: 0,
            installmentDone: false
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getStoragesList)(sessionStorage.userId).then(function (res) {
            _this.storageArr = res.data;
        });

        (0, _version.getOrderId)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            console.log(res, 'd');
            if (res.data.isAlipayMini) {
                res.data.dispalyExtra.paidData.installmentHistory = res.data.dispalyExtra.paidData.installmentHistory.filter(function (item) {
                    return !item.isFinishLose;
                });
                var canInstallment = true;
                var installmentCount = Math.floor(res.data.dispalyExtra.paidData.rental / 2000) + 1;
                var installmentHistory = res.data.dispalyExtra.paidData.installmentHistory;
                var hasInstallmentCount = installmentHistory.length;
                if (res.data.isAlipayMini) {
                    if (installmentCount === hasInstallmentCount) {
                        canInstallment = false;
                    } else if (hasInstallmentCount > 0) {
                        canInstallment = !(installmentHistory[hasInstallmentCount - 1].created.substring(0, 10) == _this.getDate());
                    }
                }

                _this.canInstallment = canInstallment;
                _this.installmentCount = installmentCount;
                _this.hasInstallmentCount = hasInstallmentCount;
                _this.installmentDone = hasInstallmentCount === installmentCount;
            }

            _this.row = res.data;
            _this.items = JSON.parse((0, _stringify2.default)(_this.row.orderItems));
            _this.items.forEach(function (item) {
                item.productIds = [];
                item.choosed = [];
            });

            (0, _version.getUsersDetail)(sessionStorage.userId, res.data.userId).then(function (res) {
                _this.userInfo = res.data;
            });

            var day = '';

            if (res.data && res.data.dispalyExtra && res.data.dispalyExtra.tenancy.length) {
                console.log(res.data.dispalyExtra.tenancy, 'f');
                day = parseInt((new Date(res.data.dispalyExtra.tenancy[0].end) - new Date(res.data.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24));
                _this.rentDay = day === 0 ? '1' : day + 1;
            }

            if (res.data.delivery && res.data.delivery.sendShipper) {
                var filter = {
                    'where': {
                        'expressNum': res.data.delivery.sendExpressNum,
                        'shipper': res.data.delivery.sendShipper
                    }
                };

                console.log(filter);
                (0, _version.getExpress)(sessionStorage.userId, (0, _stringify2.default)(filter)).then(function (res) {
                    console.log(res.data);
                    _this.expressData = res.data[0];
                });
            }
        });
    },

    methods: {
        fromatDate: function fromatDate(str) {
            function double(val) {
                if (val > 9) {
                    return val;
                }
                return '0' + val;
            }

            var d = new Date(str);
            var year = d.getFullYear();
            var month = d.getMonth() + 1;
            var date = d.getDate();

            return double(year) + '-' + double(month) + '-' + double(date);
        },
        handleBack: function handleBack() {
            history.go(-1);
        },
        getDate: function getDate() {
            var d = new Date();
            var year = d.getFullYear();
            var month = d.getMonth() + 1;
            var date = d.getDate();
            var double = function double(val) {
                if (val > 9) {
                    return val;
                }
                return '0' + val;
            };

            return double(year) + '-' + double(month) + '-' + double(date);
        },
        storageChange: function storageChange(val) {
            var _this2 = this;

            console.log(val);
            (0, _version.getProducts)(sessionStorage.userId, (0, _stringify2.default)({
                'where': {
                    'productDetailId': this.curId,
                    'isOnline': true,
                    'storageId': this.storage
                }
            })).then(function (res) {
                _this2.options = res.data;
            });
        },
        handleChoose: function handleChoose(index, row) {
            if (this.row.isAlipayMini && this.canInstallment) {
                return this.$message.error('\u8BF7\u5148\u6267\u884C\u6263\u6B3E\u64CD\u4F5C');
            }

            this.dialogFormVisible = true;

            this.value5 = JSON.parse((0, _stringify2.default)(row.productIds));
            this.storage = row.storage;
            this.cur = index;
            this.curId = row.productDetailId;
        },
        doInstallment: function doInstallment() {
            var _this3 = this;

            (0, _version.doInstallment)(this.row.id, sessionStorage.userId).then(function (res) {
                if (res.data.result === 'success') {
                    _this3.$message.success('\u6263\u6B3E\u64CD\u4F5C\u6210\u529F');
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
            });
        },
        sureNow: function sureNow() {
            var _this4 = this;

            if (this.value5.length !== this.items[this.cur].productCount) {
                this.$message.error('\u8BE5\u5546\u54C1\u53EA\u80FD\u9009\u62E9' + this.items[this.cur].productCount + '\u4E2A\u8BBE\u5907');
            } else {
                this.items[this.cur].productIds = JSON.parse((0, _stringify2.default)(this.value5));
                this.items[this.cur].storageIds = this.storage;
                this.value5.forEach(function (item) {
                    _this4.options.forEach(function (item2) {
                        if (item === item2.productId) {
                            _this4.items[_this4.cur].choosed.push(item2.deviceId);
                        }
                    });
                });
                console.log(this.items[this.cur]);
                this.dialogFormVisible = false;
            }
        },
        onSubmit: function onSubmit() {
            var _this5 = this;

            if (this.row.isAlipayMini && this.canInstallment) {
                return this.$message.error('\u8BF7\u5148\u6267\u884C\u6263\u6B3E\u64CD\u4F5C');
            }
            if (!this.sendForm.expressNumber) {
                this.$message.error('请填写快递单号');
            } else if (this.wayValue != 'self' && !this.sendForm.shipper) {
                this.$message.error('请选择快递公司');
            } else if (!this.sendForm.operator) {
                this.$message.error('请填写发货人');
            } else {
                this.sendForm.products = [];
                console.log(this.items, 'itm');

                for (var i = 0; i < this.items.length; i++) {
                    if (!this.items[i].choosed.length) {
                        this.$message.error('请选择设备');
                        return false;
                    }
                    this.sendForm.products.push({
                        orderItemId: this.items[i].id,
                        productIds: this.items[i].productIds
                    });
                }

                this.items.forEach(function (item, index) {});
                console.log(this.wayValue);
                if (this.wayValue === 'self') {
                    this.sendForm.shipper = 'SELF';
                }

                this.$confirm('此操作将确认发货, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {

                    (0, _version.sendExpress)(sessionStorage.userId, _this5.$route.params.id, _this5.sendForm).then(function (res) {
                        console.log(res.data);
                        if (res.data) {
                            _this5.$message({
                                message: '已发货',
                                type: 'success'
                            });
                            _this5.$router.push('/orderExpress');
                        }
                    });
                }).catch(function () {
                    _this5.$message({
                        type: 'info',
                        message: '已取消发货'
                    });
                });
            }
        }
    }
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

var _elementChinaAreaData = __webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            formInline: {
                mobile: ''
            },
            dialogFormVisible: false,
            dialogNewVisible: false,
            dialogEditVisible: false,
            form: {
                fullAddress: '',
                mobile: '',
                recipient: '',
                id: '',
                storageName: ''
            },
            addStorageRules: {
                address: [{
                    required: true,
                    message: '请填写详细地址',
                    trigger: 'blur'
                }],
                storageName: [{
                    required: true,
                    message: '请填写仓库名称',
                    trigger: 'blur'
                }],
                mobile: [{
                    required: true,
                    message: '请填写手机号',
                    trigger: 'blur'
                }],
                recipient: [{
                    required: true,
                    message: '请填写收货人',
                    trigger: 'blur'
                }],
                storageNo: [{
                    required: true,
                    message: '请填写编号',
                    trigger: 'blur'
                }]
            },
            newForm: {
                fullAddress: '',
                address: '',
                mobile: '',
                recipient: '',
                storageName: '',
                storageNo: '',
                province: '',
                city: '',
                district: ''
            },
            options: _elementChinaAreaData.regionData,
            selectedOptions: []
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getStoragesList)(sessionStorage.userId).then(function (res) {
            _this.fetchList = res.data;
            _this.fetchList.forEach(function (item, index) {
                _this.fetchList[index].deviceCount = 0;
                (0, _version.getStorageCount)(sessionStorage.userId, (0, _stringify2.default)({

                    'storageId': item.id,
                    'isOnline': true

                })).then(function (res) {
                    if (res.data) {
                        _this.fetchList[index].deviceCount = res.data.count;
                        _this.fetchList = JSON.parse((0, _stringify2.default)(_this.fetchList));
                    }
                });
            });
        });
    },


    methods: {
        handleView: function handleView(index, row) {
            this.dialogFormVisible = true;
            this.form = row;
        },
        handleChange: function handleChange(value) {
            var _this2 = this;

            console.log(this.selectedOptions);
            value.forEach(function (item, index) {
                if (index === 0) {
                    _this2.newForm.province = _elementChinaAreaData.CodeToText[item];
                } else if (index === 1) {
                    _this2.newForm.city = _elementChinaAreaData.CodeToText[item];
                } else {
                    _this2.newForm.district = _elementChinaAreaData.CodeToText[item];
                }
                console.log(_elementChinaAreaData.CodeToText[item]);
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this3 = this;

            this.$confirm('此操作将永久删除该仓库, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.deleteStorages)(sessionStorage.userId, row.id).then(function (res) {
                    if (res.data) {
                        _this3.$message({
                            message: '成功删除',
                            type: 'success'
                        });
                        _this3.fetchList.splice(index, 1);
                    }
                }, function (err) {
                    _this3.$message.error('删除失败');
                });
            }).catch(function () {
                _this3.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        resetForm: function resetForm(formName) {
            this.formInline.dayEnd = '';
            this.$refs[formName].resetFields();
        },
        handleAdd: function handleAdd() {
            this.dialogNewVisible = true;
            this.newForm = {};
        },
        handleEdit: function handleEdit(index, row) {
            this.dialogEditVisible = true;
            this.newForm = JSON.parse((0, _stringify2.default)(row));
            console.log(this.newForm);
            if (this.newForm.province === '上海市' || this.newForm.province === '重庆市' || this.newForm.province === '北京市' || this.newForm.province === '天津市') {
                this.newForm.city = '市辖区';
            }
            this.selectedOptions = [];
            this.selectedOptions[0] = _elementChinaAreaData.TextToCode[this.newForm.province].code;
            this.selectedOptions[1] = _elementChinaAreaData.TextToCode[this.newForm.province][this.newForm.city].code;
            this.selectedOptions[2] = _elementChinaAreaData.TextToCode[this.newForm.province][this.newForm.city][this.newForm.district].code;
        },
        editStorage: function editStorage() {
            var _this4 = this;

            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    if (!_this4.newForm.province) {
                        _this4.$message.error('请选择地区');
                    } else {
                        _this4.newForm.fullAddress = '' + _this4.newForm.fullAddress;
                        var data = JSON.parse((0, _stringify2.default)(_this4.newForm));
                        delete data.address;
                        if (data.city === '市辖区') {
                            data.city = data.province;
                        }
                        _this4.fetchList.forEach(function (item, index) {
                            if (item.id === data.id) {
                                _this4.fetchList[index] = JSON.parse((0, _stringify2.default)(_this4.newForm));
                            }
                        });
                        delete data.id;
                        (0, _version.patchStorages)(sessionStorage.userId, _this4.newForm.id, data).then(function (res) {
                            if (res.data) {
                                _this4.$message({
                                    message: '成功更新仓库信息',
                                    type: 'success'
                                });
                                _this4.dialogEditVisible = false;
                                _this4.newForm = {
                                    fullAddress: '',
                                    address: '',
                                    mobile: '',
                                    recipient: '',
                                    storageName: '',
                                    storageNo: '',
                                    province: '',
                                    city: '',
                                    district: ''
                                };
                                _this4.selectedOptions = [];
                            }
                        }, function (err) {
                            _this4.$message.error('更新失败');
                        });
                    }
                }
            });
        },
        addNewOne: function addNewOne() {
            var _this5 = this;

            console.log(this.newForm);
            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    if (!_this5.newForm.province) {
                        _this5.$message.error('请选择地区');
                    } else {
                        _this5.newForm.fullAddress = '' + _this5.newForm.province + _this5.newForm.city + _this5.newForm.district + _this5.newForm.address;
                        var data = JSON.parse((0, _stringify2.default)(_this5.newForm));
                        delete data.address;
                        if (data.city === '市辖区') {
                            data.city = data.province;
                        }

                        (0, _version.postStorages)(sessionStorage.userId, data).then(function (res) {
                            if (res.data) {
                                _this5.$message({
                                    message: '成功创建仓库',
                                    type: 'success'
                                });
                                res.data.deviceCount = 0;
                                _this5.fetchList.push(res.data);
                                _this5.dialogNewVisible = false;
                                _this5.newForm = {
                                    fullAddress: '',
                                    address: '',
                                    mobile: '',
                                    recipient: '',
                                    storageName: '',
                                    storageNo: '',
                                    province: '',
                                    city: '',
                                    district: ''
                                };
                                _this5.selectedOptions = [];
                            }
                        }, function (err) {
                            _this5.$message.error('创建失败');
                        });
                    }
                }
            });
        },
        Search: function Search() {
            var _this6 = this;

            var search = {
                'where': {
                    mobile: this.formInline.mobile
                }
            };
            console.log((0, _stringify2.default)(search));
            (0, _version.filterStorages)(sessionStorage.userId, (0, _stringify2.default)(search)).then(function (res) {
                _this6.fetchList = res.data;
            }, function (err) {
                console.log(err);
            });
        }
    }
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            aboutForm: {},
            dialogImageUrl: '',
            videoUrl: '',
            imgUrl: '',
            bannerFormFules: {
                name: [{
                    required: true,
                    message: '请输入享玩甄选描述',
                    trigger: 'blur'
                }],
                shop: [{
                    type: 'number',
                    required: true,
                    message: '请选择商品',
                    trigger: 'blur'
                }]
            },

            uptoken: {
                token: sessionStorage.token
            },
            productArr: [],
            imageUrl: '',
            fileListDetail: [],
            type: 'video',
            title: '',
            picArr: [],
            videoData: '',
            global: {},
            curVersion: ''
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getGlobalSettings)().then(function (res) {
            _this.global = res.data;
            res.data.forEach(function (item) {
                if (item.SettingKey === 'wx_about') {
                    _this.curVersion = item.SettingValue;

                    (0, _version.getVersions)().then(function (res) {
                        console.log(res.data);
                        res.data.forEach(function (item2) {
                            if (item2.version === _this.curVersion) {
                                _this.aboutForm = item2;
                                _this.imgUrl = 'https://img.shareplay.cc/' + item2.value.logo;
                            }
                        });
                    });
                }
            });
            console.log(res);
        });
    },

    methods: {
        handlePictureCardPreview: function handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleDetailSuccess: function handleDetailSuccess(res, file) {
            this.picArr.push({
                imgUrl: 'https://img.shareplay.cc/' + res.key,
                title: this.title

            });
        },
        handleAvatarSuccess: function handleAvatarSuccess(res, file) {
            this.imgUrl = 'https://img.shareplay.cc/' + res.key;
            this.aboutForm.value.logo = res.key;
        },
        beforeAvatarUpload: function beforeAvatarUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            };

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        },
        beforeDetailUpload: function beforeDetailUpload() {},
        onSubmit: function onSubmit() {
            var _this2 = this;

            var about = JSON.parse((0, _stringify2.default)(this.aboutForm));
            var ids = about.id;
            console.log(ids);
            delete this.aboutForm.id;
            (0, _version.patchVersionsId)(sessionStorage.userId, ids, this.aboutForm).then(function (res) {
                console.log(res.data);
                if (res.data) {
                    _this2.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                }
            });
        }
    }
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            bannerForm: {},
            dialogVisible: false,
            dialogImageUrl: '',
            videoUrl: '',
            imgUrl: '',
            bannerFormFules: {
                name: [{
                    required: true,
                    message: '请输入享玩甄选描述',
                    trigger: 'blur'
                }],
                shop: [{
                    type: 'number',
                    required: true,
                    message: '请选择商品',
                    trigger: 'blur'
                }]
            },
            options: [{
                value: 'video',
                label: '视频'
            }, {
                value: 'pic',
                label: '图片'
            }],
            uptoken: {
                token: sessionStorage.token
            },
            productArr: [],
            imageUrl: '',
            fileListDetail: [],
            type: 'video',
            title: '',
            picArr: [],
            videoData: ''
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getBanner)((0, _stringify2.default)({
            'where': {
                'version': 'home_banner'
            }
        })).then(function (res) {
            console.log(res);
            _this.bannerForm = res.data[0];
            _this.type = res.data[0].value.type;

            if (_this.bannerForm.value.type === 'pic') {
                _this.title = res.data[0].value.content[0].title;
                _this.bannerForm.value.content.forEach(function (item) {
                    _this.fileListDetail.push({
                        url: item.imgUrl
                    });
                });
            } else {
                _this.title = res.data[0].value.content.title;
                _this.videoUrl = res.data[0].value.content.videoUrl;
                _this.imgUrl = res.data[0].value.content.imgUrl;
            }
        });
    },

    methods: {
        handlePictureCardPreview: function handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleDetailSuccess: function handleDetailSuccess(res, file) {
            this.picArr.push({
                imgUrl: 'https://img.shareplay.cc/' + res.key,
                title: this.title

            });
        },
        handleAvatarSuccess: function handleAvatarSuccess(res, file) {
            this.upImage = 'https://img.shareplay.cc/' + res.key;
            this.imgUrl = 'https://img.shareplay.cc/' + res.key;
        },
        beforeAvatarUpload: function beforeAvatarUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            };

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        },
        beforeDetailUpload: function beforeDetailUpload() {},
        productChoose: function productChoose(val) {
            console.log(val);
        },
        handleDetailRemove: function handleDetailRemove(file, fileList) {
            var _this2 = this;

            console.log(file);
            console.log(fileList[0].response);
            var arr = [];
            fileList.forEach(function (item) {
                arr.push({
                    imgUrl: 'https://img.shareplay.cc/' + item.response.key,
                    title: _this2.title
                });
            });
            this.picArr = arr;
        },
        onSubmit: function onSubmit() {
            var _this3 = this;

            if (this.type === 'pic') {
                if (this.picArr.length) {
                    delete this.bannerForm.id;
                    this.bannerForm.value.type = 'pic';
                    this.bannerForm.value.content = JSON.parse((0, _stringify2.default)(this.picArr));
                    (0, _version.putBanner)(sessionStorage.userId, 13, this.bannerForm).then(function (res) {
                        console.log(res.data);
                        if (res.data) {
                            _this3.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                        }
                    });
                }
            } else if (this.type === 'video') {
                this.bannerForm.value.type = 'video';
                this.videoData = JSON.parse((0, _stringify2.default)(this.bannerForm));
                delete this.videoData.content;
                this.videoData.value.content = {
                    videoUrl: this.videoUrl,
                    title: this.title,
                    imgUrl: this.imgUrl
                };
                delete this.videoData.id;
                (0, _version.putBanner)(sessionStorage.userId, 13, this.videoData).then(function (res) {
                    console.log(res.data);
                    if (res.data) {
                        _this3.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                    }
                });
            }
        }
    }
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            fetch: {}
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getTongji)(sessionStorage.userId).then(function (res) {
            _this.fetch = res.data;
        });
    },

    methods: {
        freashRent: function freashRent() {
            var _this2 = this;

            (0, _version.getFreashOrder)(sessionStorage.userId).then(function (res) {
                console.log(res.data);
                if (res.data) {
                    (0, _version.getTongji)(sessionStorage.userId).then(function (res) {
                        _this2.fetch = res.data;
                    });
                    _this2.$message({
                        type: 'success',
                        message: '更新成功!'
                    });
                }
            });
        }
    }
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            comonQ: [],
            dinnerQ: [],
            payQ: [],
            cur: '',
            dialogCommon: false,
            dialogPay: false,
            dialogDinner: false,
            dialogCommonEdit: false,
            dialogDinnerEdit: false,
            dialogPayEdit: false,
            titles: [],
            addStorageRules: {
                Q: [{
                    required: true,
                    message: '请填写标题',
                    trigger: 'blur'
                }],
                A: [{
                    required: true,
                    message: '请填写内容',
                    trigger: 'blur'
                }]

            },
            newForm: {
                Q: '',
                A: ''
            }

        };
    },

    computed: {
        isAlipay: function isAlipay() {
            return this.$route.path === '/alipayHelp';
        },
        editId: function editId() {
            var id = 6;

            if (this.isAlipay) {
                id = 51;
            }

            return id;
        }
    },
    created: function created() {
        this.loadData();
    },

    watch: {
        '$route': function $route() {
            this.loadData();
        }
    },
    methods: {
        loadData: function loadData() {
            var _this = this;

            (0, _version.getHelp)(this.editId).then(function (res) {
                _this.comonQ = res.data.value[0].content;
                _this.payQ = res.data.value[1].content;
                _this.dinnerQ = res.data.value[2].content;

                res.data.value.forEach(function (item) {
                    _this.titles.push(item.title);
                });
            });
        },
        addCommon: function addCommon() {
            this.dialogCommon = true;
        },
        addCommonOne: function addCommonOne() {
            var _this2 = this;

            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    _this2.comonQ.push(JSON.parse((0, _stringify2.default)(_this2.newForm)));

                    _this2.newForm = {
                        Q: '',
                        A: ''
                    };
                    _this2.dialogCommon = false;
                }
            });
        },
        addDinnerOne: function addDinnerOne() {
            var _this3 = this;

            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    _this3.dinnerQ.push(JSON.parse((0, _stringify2.default)(_this3.newForm)));

                    _this3.newForm = {
                        Q: '',
                        A: ''
                    };
                    _this3.dialogDinner = false;
                }
            });
        },
        addPayOne: function addPayOne() {
            var _this4 = this;

            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    _this4.payQ.push(JSON.parse((0, _stringify2.default)(_this4.newForm)));

                    _this4.newForm = {
                        Q: '',
                        A: ''
                    };
                    _this4.dialogPay = false;
                }
            });
        },
        addDinner: function addDinner() {
            this.dialogDinner = true;
        },
        addPay: function addPay() {
            this.dialogPay = true;
        },
        uploadHelp: function uploadHelp() {
            var _this5 = this;

            var data = {
                value: [{
                    'title': this.titles[0],
                    'content': []
                }, {
                    'title': this.titles[1],
                    'content': []
                }, {
                    'title': this.titles[2],
                    'content': []
                }]
            };

            data.value[0].content = this.comonQ;
            data.value[1].content = this.payQ;
            data.value[2].content = this.dinnerQ;
            (0, _version.patchHelp)(this.editId, sessionStorage.userId, data).then(function (res) {
                if (res.data) {
                    _this5.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                }
            });
        },
        commonDelete: function commonDelete(index) {
            this.comonQ.splice(index, 1);
        },
        commonEdit: function commonEdit(index) {
            console.log(index);
            this.cur = index;
            this.dialogCommonEdit = true;
            this.newForm = this.comonQ[index];
        },
        editCommonOne: function editCommonOne() {
            var _this6 = this;

            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    _this6.comonQ.splice(_this6.cur, 1, _this6.newForm);

                    _this6.newForm = {
                        Q: '',
                        A: ''
                    };
                    _this6.dialogCommonEdit = false;
                    _this6.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                }
            });
        },
        payDelete: function payDelete(index) {
            this.payQ.splice(index, 1);
        },
        payEdit: function payEdit(index) {
            this.cur = index;
            this.dialogPayEdit = true;
            this.newForm = this.payQ[index];
        },
        orderDelete: function orderDelete(index) {
            this.dinnerQ.splice(index, 1);
        },
        orderEdit: function orderEdit(index) {
            this.cur = index;
            this.dialogDinnerEdit = true;
            this.newForm = this.dinnerQ[index];
        },
        editPayOne: function editPayOne() {
            var _this7 = this;

            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    _this7.payQ.splice(_this7.cur, 1, _this7.newForm);

                    _this7.newForm = {
                        Q: '',
                        A: ''
                    };
                    _this7.dialogPayEdit = false;
                    _this7.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                }
            });
        },
        editDinnerOne: function editDinnerOne() {
            var _this8 = this;

            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    _this8.dinnerQ.splice(_this8.cur, 1, _this8.newForm);

                    _this8.newForm = {
                        Q: '',
                        A: ''
                    };
                    _this8.dialogDinnerEdit = false;
                    _this8.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                }
            });
        }
    }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            hotForm: {},
            hot: '',
            row: ''
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getHot)(sessionStorage.userId).then(function (res) {
            var data = res.data;
            _this.row = data.SettingValue.split(',');
            console.log(_this.row);
        });
    },

    methods: {
        onSubmit: function onSubmit() {
            var _this2 = this;

            (0, _version.patchHot)(sessionStorage.userId, { 'SettingValue': this.row.join(',') }).then(function (res) {
                console.log(res);
                if (res.data) {
                    _this2.$message({
                        message: '成功更新热门搜索标签',
                        type: 'success'
                    });
                } else {
                    _this2.$message.error('更新标签失败');
                }
            }, function (err) {
                _this2.$message.error('更新标签失败');
            });
        },
        handleAdd: function handleAdd() {
            if (this.hot) {
                this.row.push(this.hot);
                this.hot = '';
            }
        },
        handleClose: function handleClose(tag) {
            this.row.splice(this.row.indexOf(tag), 1);
        }
    }
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            fetchList: [],
            cur: '',
            dialogNewVisible: false,
            dialogEditVisible: false,
            addStorageRules: {
                Q: [{
                    required: true,
                    message: '请填写标题',
                    trigger: 'blur'
                }],
                A: [{
                    required: true,
                    message: '请填写内容',
                    trigger: 'blur'
                }]

            },
            newForm: {
                Q: '',
                A: ''
            },
            editForm: {
                Q: '',
                A: ''
            }
        };
    },
    created: function created() {
        this.loadData();
    },

    watch: {
        '$route': function $route() {
            this.loadData();
        }
    },

    computed: {
        isAlipay: function isAlipay() {
            return this.$route.path === '/alipayRentRule';
        },
        editId: function editId() {
            var id = 7;

            if (this.isAlipay) {
                id = 53;
            }

            return id;
        }
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            (0, _version.getRentRule)(this.editId).then(function (res) {
                _this.fetchList = res.data.value;
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            this.$confirm('此操作将永久删除该规则, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                var data = { value: JSON.parse((0, _stringify2.default)(_this2.fetchList)) };
                data.value.splice(index, 1);

                (0, _version.addRentRule)(_this2.editId, sessionStorage.userId, data).then(function (res) {
                    if (res.data) {
                        _this2.$message({
                            message: '成功删除',
                            type: 'success'
                        });
                        _this2.fetchList.splice(index, 1);
                    }
                }, function (err) {
                    _this2.$message.error('删除失败');
                });
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleEdit: function handleEdit(index, row) {
            this.dialogEditVisible = true;
            this.editForm = JSON.parse((0, _stringify2.default)(row));
            this.cur = index;
        },
        editRule: function editRule() {
            var _this3 = this;

            this.$refs['editForm'].validate(function (valid) {
                if (valid) {
                    var data = { value: JSON.parse((0, _stringify2.default)(_this3.fetchList)) };
                    data.value.splice(_this3.cur, 1, _this3.editForm);
                    (0, _version.addRentRule)(_this3.editId, sessionStorage.userId, data).then(function (res) {
                        console.log(res.data);
                        if (res.data) {
                            _this3.fetchList[_this3.cur] = _this3.editForm;
                            _this3.dialogEditVisible = false;
                            _this3.$message({
                                message: '成功修改租赁规则',
                                type: 'success'
                            });
                        } else {
                            _this3.$message.error('修改失败');
                        }
                    });
                }
            });
        },
        handleAdd: function handleAdd() {
            this.dialogNewVisible = true;
        },
        addNewOne: function addNewOne() {
            var _this4 = this;

            console.log(this.newForm);
            this.$refs['newForm'].validate(function (valid) {
                if (valid) {
                    var data = {
                        value: JSON.parse((0, _stringify2.default)(_this4.fetchList))
                    };
                    data.value.push(_this4.newForm);
                    (0, _version.addRentRule)(_this4.editId, sessionStorage.userId, data).then(function (res) {
                        console.log(res.data);
                        if (res.data) {
                            _this4.fetchList.push(_this4.newForm);
                            _this4.dialogNewVisible = false;
                            _this4.$message({
                                message: '成功添加租赁规则',
                                type: 'success'
                            });
                        } else {
                            _this4.$message.error('添加失败');
                        }
                    });
                }
            });
        }
    }
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(69);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            bannerForm: {
                user: '',
                liu: '',
                service: ''
            },

            bannerFormFules: {
                user: [{
                    required: true,
                    message: '请输入用户协议',
                    trigger: 'blur'
                }],
                liu: [{
                    required: true,
                    message: '请输入流程规则',
                    trigger: 'blur'
                }],
                service: [{
                    required: true,
                    message: '请输入服务条款',
                    trigger: 'blur'
                }]
            }

        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getUserX)().then(function (res) {
            console.log(res.data);
            _this.bannerForm.user = (0, _stringify2.default)(res.data.value);
        });

        (0, _version.getService)().then(function (res) {
            console.log(res.data);
            _this.bannerForm.service = (0, _stringify2.default)(res.data.value);
        });

        (0, _version.getRentXie)().then(function (res) {
            _this.bannerForm.liu = (0, _stringify2.default)(res.data.value);
        });
    },

    methods: {
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.$refs['bannerForm'].validate(function (valid) {
                if (valid) {
                    var a = (0, _version.patchService)(sessionStorage.userId, {
                        value: _this2.bannerForm.service
                    });

                    var b = (0, _version.patchUserX)(sessionStorage.userId, {
                        value: _this2.bannerForm.user
                    });

                    var c = (0, _version.patchRentXie)(sessionStorage.userId, {
                        value: _this2.bannerForm.liu
                    });

                    _promise2.default.all([a, b, c]).then(function (val) {
                        console.log(val);
                        if (val.length) {
                            _this2.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                        } else _this2.$message.error('修改失败');
                    });
                }
            });
        }
    }
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            pic: '',
            imageUrl: '',
            uptoken: {
                token: sessionStorage.token
            }
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getGlobalSettings)().then(function (res) {
            console.log(res.data);
            res.data.forEach(function (item) {
                if (item.SettingKey === 'share_pic') {
                    _this.imageUrl = 'https://img.shareplay.cc/' + item.SettingValue;
                    _this.pic = item.SettingValue;
                }
            });
        });
    },


    methods: {
        onSubmit: function onSubmit() {
            var _this2 = this;

            var data = {
                SettingKey: 'share_pic',
                SettingValue: this.pic
            };
            (0, _version.patchGlobalSettings)(sessionStorage.userId, data).then(function (res) {
                console.log(res);
                if (res.data) {
                    _this2.$message({
                        message: '更改成功',
                        type: 'success'
                    });
                }
            }, function (err) {
                _this2.$message.error('更改失败');
            });
        },
        handleAvatarSuccess: function handleAvatarSuccess(res, file) {
            this.pic = res.key;
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload: function beforeAvatarUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            };

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        }
    }
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            dialogSearch: false,
            searchForm: {},
            fetchList: [],
            global: [],
            addVersionRules: {
                version: [{
                    required: true,
                    message: '请输入版本名称',
                    trigger: 'blur'
                }],
                one: [{
                    required: true,
                    message: '请输入600-700分的值',
                    trigger: 'blur'
                }],
                two: [{
                    required: true,
                    message: '请输入701-750分的值',
                    trigger: 'blur'
                }],
                three: [{
                    required: true,
                    message: '请输入751-800分的值',
                    trigger: 'blur'
                }],
                four: [{
                    required: true,
                    message: '请输入801-850分的值',
                    trigger: 'blur'
                }]
            },
            userForm: {
                user: '1',
                role: ''
            },
            addVersion: false,
            editVersion: false,
            versionForm: {},
            editVersionForm: {},
            versionOption: []
        };
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        var localVersion = this.$store.state.currentIndex;
        (0, _version.getVersions)().then(function (data) {
            _this.fetchList = data.data.filter(function (item) {
                if (item.version && item.version.indexOf('zm') == 0) {
                    return item;
                }
            });
            if (localVersion.length) {
                _this.fetchList.push(localVersion);
            }
        }, function (err) {
            console.log(err, 'xx');
        });

        (0, _version.getGlobalSettings)().then(function (res) {
            res.data.forEach(function (item) {
                if (item.SettingKey === 'zm_line') {
                    _this.global = item.SettingValue;
                }
            });
            console.log(res);
        });
    },

    methods: {
        searhSure: function searhSure() {
            var _this2 = this;

            if (this.searchForm.username) {
                (0, _version.getUsers)(sessionStorage.userId, (0, _stringify2.default)({
                    'where': {
                        'username': this.searchForm.username
                    }
                })).then(function (res) {
                    if (res.data && res.data.length) {
                        (0, _version.updateZM)(sessionStorage.userId, res.data[0].userId).then(function (res) {
                            if (res.data) {
                                _this2.$message({
                                    message: '更新成功',
                                    type: 'success'
                                });
                            }
                        }).catch(function (err) {
                            _this2.$message.error(err.response.data.error.message);
                        });
                    } else {
                        _this2.$message.error('暂无此用户');
                    }
                }).catch(function (err) {
                    _this2.$message.error(err.response.data.error.message);
                });
            } else {
                this.$message.error('请输入用户手机号');
            }
        },
        handleUser: function handleUser() {
            this.dialogSearch = true;
        },
        handleEdit: function handleEdit(index, row) {
            this.editVersionForm = {
                'version': row.version,
                'id': row.id,
                'one': row.value[700],
                'two': row.value[750],
                'three': row.value[800],
                'four': row.value[850]

            };
            this.editVersion = true;
        },
        handleLive: function handleLive(index, row) {
            var _this3 = this;

            console.log(row);
            var data = {
                "SettingKey": 'zm_line',
                "SettingValue": row.version
            };
            (0, _version.putGlobalSettings)(sessionStorage.userId, data).then(function (res) {
                console.log(res.data);
                if (res.data.SettingKey) {
                    _this3.$message({
                        message: '成功激活',
                        type: 'success'
                    });
                    _this3.global = res.data.SettingValue;
                }
            }, function (err) {
                console.log(err);
            });
        },
        handleAdd: function handleAdd() {
            this.versionForm = {
                version: '',
                base: '',
                remark: ''
            };
            this.addVersion = true;
        },
        handleDelete: function handleDelete(index, row) {
            var _this4 = this;

            this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                console.log(row.id);
                (0, _version.deleteVersions)(sessionStorage.userId, row.id).then(function (res) {
                    console.log(res);
                    _this4.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    _this4.fetchList.splice(index, 1);
                }, function (err) {
                    _this4.$message({
                        type: 'info',
                        message: '删除失败'
                    });
                });
            }).catch(function () {
                _this4.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleCheck: function handleCheck(val) {},
        submitForm: function submitForm(formName) {
            var _this5 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    console.log(_this5.versionForm);
                    var data = {
                        'version': _this5.versionForm.version,
                        'value': {
                            650: 0,
                            700: _this5.versionForm.one,
                            750: _this5.versionForm.two,
                            800: _this5.versionForm.three,
                            850: _this5.versionForm.four
                        }
                    };
                    (0, _version.patchVersions)(sessionStorage.userId, data).then(function (res) {
                        console.log(res.data);
                        if (res.data) {
                            _this5.$message({
                                message: '新建成功',
                                type: 'success'
                            });
                            _this5.fetchList.push(data);
                            _this5.addVersion = false;

                            var localVersion = _this5.$store.state.currentIndex;
                            (0, _version.getVersions)().then(function (data) {
                                _this5.fetchList = data.data.filter(function (item) {
                                    if (item.version && item.version.indexOf('zm') == 0) {
                                        return item;
                                    }
                                });
                                if (localVersion.length) {
                                    _this5.fetchList.push(localVersion);
                                }
                            }, function (err) {
                                console.log(err, 'xx');
                            });

                            (0, _version.getGlobalSettings)().then(function (res) {
                                res.data.forEach(function (item) {
                                    if (item.SettingKey === 'zm_line') {
                                        _this5.global = item.SettingValue;
                                    }
                                });
                                console.log(res);
                            });
                        } else {
                            _this5.$message.error('新建失败');
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        editSubmit: function editSubmit(formName) {
            var _this6 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    console.log(_this6.editVersionForm);
                    var data = {
                        'version': _this6.editVersionForm.version,
                        'value': {
                            650: 0,
                            700: _this6.editVersionForm.one,
                            750: _this6.editVersionForm.two,
                            800: _this6.editVersionForm.three,
                            850: _this6.editVersionForm.four
                        }
                    };
                    (0, _version.patchVersionsId)(sessionStorage.userId, _this6.editVersionForm.id, data).then(function (res) {
                        console.log(res.data);
                        if (res.data) {
                            _this6.$message({
                                message: '更新成功',
                                type: 'success'
                            });
                            _this6.fetchList.forEach(function (item, index) {
                                if (item.id === _this6.editVersionForm.id) {
                                    _this6.fetchList[index] = data;
                                }
                            });
                            _this6.editVersion = false;
                        } else {
                            _this6.$message.error('更新失败');
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            equipmentForm: {
                storageId: '',
                deviceId: '',
                productIdentity: '',
                otherProperty: {}
            },
            addEquipmentRules: {
                deviceId: [{
                    required: true,
                    message: '请填写设备序列号',
                    trigger: 'blur'
                }],
                productIdentity: [{
                    required: true,
                    message: '请填写条形码编号',
                    trigger: 'blur'
                }],
                storageId: [{
                    type: 'number',
                    required: true,
                    message: '请选择所在仓库',
                    trigger: 'blur'
                }]

            },
            property: [],
            storageArr: [],
            key: '',
            value: ''
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getStorages)(sessionStorage.userId).then(function (res) {
            _this.storageArr = res.data;
        });
    },


    methods: {
        goBack: function goBack() {
            this.$router.push('/equipment/' + this.$route.params.id);
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.$refs['equipmentForm'].validate(function (valid) {
                if (valid) {
                    _this2.property.forEach(function (res) {
                        _this2.equipmentForm.otherProperty[res.name] = res.value;
                    });
                    _this2.equipmentForm.productDetailId = _this2.$route.params.id;
                    (0, _version.postProducts)(sessionStorage.userId, _this2.equipmentForm).then(function (res) {
                        console.log(res);
                        if (res.data) {
                            _this2.$message({
                                message: '恭喜你，成功添加设备',
                                type: 'success'
                            });
                            _this2.$router.push('/equipment/' + _this2.$route.params.id);
                        }
                    }, function (err) {
                        _this2.$message.error('添加失败');
                    });
                }
            });
        },
        addProperty: function addProperty() {
            if (this.key && this.value) {
                this.property.push({
                    name: this.key,
                    value: this.value
                });
                this.key = '';
                this.value = '';
            }
        },
        removeProperty: function removeProperty(index) {
            console.log(index);
            this.property.splice(--index, 1);
        }
    }
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            equipmentForm: {
                storageId: '',
                deviceId: '',
                productIdentity: '',
                otherProperty: {}
            },
            addEquipmentRules: {
                deviceId: [{
                    required: true,
                    message: '请填写设备序列号',
                    trigger: 'blur'
                }],
                productIdentity: [{
                    required: true,
                    message: '请填写条形码编号',
                    trigger: 'blur'
                }],
                storageId: [{
                    type: 'number',
                    required: true,
                    message: '请选择所在仓库',
                    trigger: 'blur'
                }]

            },
            property: [],
            storageArr: [],
            key: '',
            value: ''
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getStorages)(sessionStorage.userId).then(function (res) {
            _this.storageArr = res.data;
        });
    },


    methods: {
        goBack: function goBack() {
            this.$router.push('/optinalList');
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.$refs['equipmentForm'].validate(function (valid) {
                if (valid) {
                    _this2.property.forEach(function (res) {
                        _this2.equipmentForm.otherProperty[res.name] = res.value;
                    });
                    _this2.equipmentForm.productDetailId = _this2.$route.params.id;
                    (0, _version.postProducts)(sessionStorage.userId, _this2.equipmentForm).then(function (res) {
                        console.log(res);
                        if (res.data) {
                            _this2.$message({
                                message: '恭喜你，成功添加',
                                type: 'success'
                            });
                            _this2.$router.push('/optinalList');
                        }
                    }, function (err) {
                        _this2.$message.error('添加失败');
                    });
                }
            });
        },
        addProperty: function addProperty() {
            if (this.key && this.value) {
                this.property.push({
                    name: this.key,
                    value: this.value
                });
                this.key = '';
                this.value = '';
            }
        },
        removeProperty: function removeProperty(index) {
            console.log(index);
            this.property.splice(--index, 1);
        }
    }
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            optionalForm: {
                name: '',
                rental: '',
                accessoryType: '',
                deposit: '',
                description: ''
            },
            addOptionalRules: {
                name: [{
                    required: true,
                    message: '请填写商品名',
                    trigger: 'blur'
                }],
                accessoryType: [{
                    required: true,
                    message: '请选择结算方式',
                    trigger: 'blur'
                }],
                rental: [{
                    required: true,
                    message: '请填写价格',
                    trigger: 'blur'
                }],
                deposit: [{
                    required: true,
                    message: '请填写押金',
                    trigger: 'blur'
                }]

            }
        };
    },
    created: function created() {},


    methods: {
        goBack: function goBack() {
            this.$router.push('/optinalList');
        },
        onSubmit: function onSubmit() {
            var _this = this;

            this.$refs['optionalForm'].validate(function (valid) {
                if (valid) {
                    var data = JSON.parse((0, _stringify2.default)(_this.optionalForm));
                    console.log(_this.optionalForm);
                    data.rental = data.rental * 1;
                    data.deposit = data.deposit * 1;
                    data.accessoryType = data.accessoryType * 1;
                    (0, _version.addAccessory)(sessionStorage.userId, data).then(function (res) {
                        console.log(res);
                        if (res.data) {
                            _this.$message({
                                message: '恭喜你，成功添加选配',
                                type: 'success'
                            });
                            _this.$router.push('/optinalList');
                        }
                    }, function (err) {
                        _this.$message.error('添加失败');
                    });
                }
            });
        }
    }
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(69);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            productForm: {
                name: '',
                accessoryType: '',
                description: '',
                rental: '',
                oldRental: '',
                minimumDay: '',
                categoryId: '',
                rentalMore: '',
                isOnline: true,
                media: {
                    video: '',

                    pic: [],

                    detail: [],
                    videoThumb: ''
                },
                inventory: [],
                insurance: '',
                pushProductDetails: []
            },

            shopForm: {
                price_current: '',
                price_old: '',
                name: '',
                productDetailId: '',
                product: ''
            },
            addProductRules: {
                categoryId: [{
                    type: 'number',
                    required: true,
                    message: '请选择商品分类',
                    trigger: 'blur'
                }],
                name: [{
                    required: true,
                    message: '请填写商品名称',
                    trigger: 'blur'
                }],
                description: [{
                    required: true,
                    message: '请填写商品描述',
                    trigger: 'blur'
                }],
                deposit: [{
                    required: true,
                    message: '请填写商品押金',
                    trigger: 'blur'
                }],
                rental: [{
                    required: true,
                    message: '请填写商品的每日租金',
                    trigger: 'blur'
                }],
                oldRental: [{
                    required: true,
                    message: '请填写商品原租金价格',
                    trigger: 'blur'
                }],
                minimumDay: [{
                    required: true,
                    message: '请填写商品起租天数',
                    trigger: 'blur'
                }],
                rentalMore: [{
                    required: true,
                    message: '请填写商品后续价格',
                    trigger: 'blur'
                }]
            },
            list: {},
            dialogImageUrl: '',
            dialogVisible: false,
            uptoken: {
                token: sessionStorage.token
            },
            insurance: '0',
            zhenxuan: '1',
            catogreyArr: [],
            topicArr: [],
            topic: '',
            value10: '',
            xuanpeiArr: [],
            productArr: []
        };
    },
    created: function created() {
        var _this2 = this;

        (0, _version.getProductCategories)().then(function (res) {
            console.log(res, '分类');
            _this2.catogreyArr = res.data;
        }, function (err) {
            console.log(err);
        });

        (0, _version.getProductTags)().then(function (res) {
            console.log(res, '标签');
            _this2.topicArr = res.data;
        }, function (err) {
            console.log(err);
        });

        (0, _version.getProductDetailsOnly)(sessionStorage.userId, (0, _stringify2.default)({ where: { accessoryType: 0 } })).then(function (res) {
            _this2.productArr = res.data;
        });

        (0, _version.getProductAccessories)(sessionStorage.userId, (0, _stringify2.default)({ 'where': { 'accessoryType': { 'neq': 0 } } })).then(function (res) {
            console.log(res, '选配');
            _this2.xuanpeiArr = res.data;
        });
    },


    methods: {
        addList: function addList() {
            if (this.list.name && this.list.count) {
                this.productForm.inventory.push([this.list.name, this.list.count]);
                this.list = {
                    name: '',
                    count: ''
                };
            }
        },
        removeCard: function removeCard(index) {
            this.productForm.pushProductDetails.splice(index, 1);
        },
        addShop: function addShop() {
            if (!this.shopForm.name) {
                this.$message.error('请填写描述');
            } else if (!this.shopForm.product) {
                this.$message.error('请选择商品');
            } else {
                var data = {
                    productDetailId: this.shopForm.productDetailId,
                    rental: this.shopForm.product.rental,
                    oldRental: this.shopForm.product.oldRental,
                    name: this.shopForm.name,
                    media: this.shopForm.product.media
                };
                this.productForm.pushProductDetails.push(data);
                this.shopForm = {
                    price_current: '',
                    price_old: '',
                    name: '',
                    productDetailId: '',
                    product: ''
                };
            }
        },
        productChoose: function productChoose(val) {
            var _this3 = this;

            console.log(val);
            this.productArr.forEach(function (item) {
                if (item.productDetailId === val) {
                    _this3.shopForm.product = item;
                }
            });
        },
        handleRemove: function handleRemove(file, fileList) {
            console.log(file);
            console.log(fileList[0].response);
            var arr = [];
            fileList.forEach(function (item) {
                arr.push('https://img.shareplay.cc/' + item.response.key);
            });
            this.productForm.media.pic = arr;
        },
        handleDetailRemove: function handleDetailRemove(file, fileList) {
            console.log(file);
            console.log(fileList[0].response);
            var arr = [];
            fileList.forEach(function (item) {
                arr.push('https://img.shareplay.cc/' + item.response.key);
            });
            this.productForm.media.detail = arr;
        },
        handleVideoRemove: function handleVideoRemove(file, fileList) {},
        handlePictureCardPreview: function handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePicCardPreview: function handlePicCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        },
        handleVideoSuccess: function handleVideoSuccess(res, file) {
            this.productForm.media.videoThumb = 'https://img.shareplay.cc/' + res.key;
        },
        handlePicSuccess: function handlePicSuccess(res, file) {
            this.productForm.media.pic.push('https://img.shareplay.cc/' + res.key);
        },
        beforePicUpload: function beforePicUpload() {
            if (this.productForm.media.pic.length >= 6) {
                this.$message({
                    message: '橱窗图片最多上传6张',
                    type: 'warning'
                });
                return false;
            }
        },
        handleDetailSuccess: function handleDetailSuccess(res, file) {
            this.productForm.media.detail.push('https://img.shareplay.cc/' + res.key);
        },
        beforeDetailUpload: function beforeDetailUpload() {},
        onSubmit: function onSubmit() {
            var _this4 = this;

            this.$refs['productForm'].validate(function (valid) {
                if (valid) {
                    if (_this4.insurance === '1' && !_this4.productForm.insurance.length) {
                        _this4.$message.error('请填写保险服务价格');
                    } else if (!_this4.productForm.media.pic.length) {
                        _this4.$message.error('请上传商品橱窗图片');
                    } else if (!_this4.productForm.media.detail.length) {
                        _this4.$message.error('请上传商品详情图片');
                    } else if (_this4.zhenxuan === '0' && (!_this4.productForm.pushProductDetails || !_this4.productForm.pushProductDetails.length)) {
                        _this4.$message.error('请添加享玩甄选设置');
                    } else {
                        if (_this4.zhenxuan === '1') {
                            _this4.productForm.pushProductDetails = null;
                        }
                        (0, _version.addProductDetails)(sessionStorage.userId, _this4.productForm).then(function (res) {
                            if (res.data) {
                                _this4.productForm.insurance = '';
                                var topicArr = [];

                                if (_this4.topic.length) {

                                    _this4.topic.forEach(function (item) {
                                        var data = {
                                            "tagId": item,
                                            "productDetailId": res.data.productDetailId
                                        };
                                        topicArr.push((0, _version.postProductTag)(sessionStorage.userId, data).then(function (res) {
                                            console.log(res.data, '标签');
                                        }));
                                    });
                                }

                                if (_this4.value10.length) {
                                    _this4.value10.forEach(function (item) {
                                        var data = {
                                            "accessoryId": item,
                                            "productDetailId": res.data.productDetailId
                                        };
                                        topicArr.push((0, _version.postProductAccessories)(sessionStorage.userId, data).then(function (res) {
                                            console.log(res);
                                        }));
                                    });
                                }

                                _promise2.default.all(topicArr).then(function (val) {
                                    _this4.$message({
                                        message: '恭喜你，成功添加商品',
                                        type: 'success'
                                    });
                                    _this4.$router.push('/list');
                                });
                            }
                        }, function (err) {
                            _this4.$message.error('添加失败');
                        });
                    }
                }
            });
        },
        goBack: function goBack() {
            this.$router.push('/list');
        },
        removeThis: function removeThis(index) {
            var _this = index;
            this.productForm.inventory.splice(--_this, 1);
            console.log(index);
        }
    }
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            equipmentForm: {
                storageId: '',
                deviceId: '',
                productIdentity: '',
                otherProperty: {}
            },
            addEquipmentRules: {
                deviceId: [{
                    required: true,
                    message: '请填写设备序列号',
                    trigger: 'blur'
                }],
                productIdentity: [{
                    required: true,
                    message: '请填写条形码编号',
                    trigger: 'blur'
                }],
                storageId: [{
                    type: 'number',
                    required: true,
                    message: '请选择所在仓库',
                    trigger: 'blur'
                }]

            },
            property: [],
            storageArr: [],
            key: '',
            value: ''
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getStorages)(sessionStorage.userId).then(function (res) {
            _this.storageArr = res.data;
        });

        (0, _version.getProductsId)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            console.log(res.data, 'd');
            _this.equipmentForm = JSON.parse((0, _stringify2.default)(res.data));
            _this.equipmentForm.otherProperty = {};
            for (var i in res.data.otherProperty) {
                _this.property.push({
                    name: i,
                    value: res.data.otherProperty[i]
                });
            }
        });
    },


    methods: {
        goBack: function goBack() {
            this.$router.go(-1);
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.$refs['equipmentForm'].validate(function (valid) {
                if (valid) {
                    _this2.property.forEach(function (res) {
                        _this2.equipmentForm.otherProperty[res.name] = res.value;
                    });
                    (0, _version.putProducts)(sessionStorage.userId, _this2.$route.params.id, _this2.equipmentForm).then(function (res) {
                        console.log(res);
                        if (res.data) {
                            _this2.$message({
                                message: '恭喜你，成功更新设备信息',
                                type: 'success'
                            });
                            _this2.$router.go(-1);
                        }
                    }, function (err) {
                        _this2.$message.error('更新失败');
                    });
                }
            });
        },
        addProperty: function addProperty() {
            this.property.push({
                name: this.key,
                value: this.value
            });
            this.key = '';
            this.value = '';
        },
        removeProperty: function removeProperty(index) {
            console.log(index);
            this.property.splice(--index, 1);
        }
    }
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            equipmentForm: {
                storageId: '',
                deviceId: '',
                productIdentity: '',
                otherProperty: {}
            },
            addEquipmentRules: {
                deviceId: [{
                    required: true,
                    message: '请填写设备序列号',
                    trigger: 'blur'
                }],
                productIdentity: [{
                    required: true,
                    message: '请填写条形码编号',
                    trigger: 'blur'
                }],
                storageId: [{
                    type: 'number',
                    required: true,
                    message: '请选择所在仓库',
                    trigger: 'blur'
                }]

            },
            property: [],
            storageArr: [],
            key: '',
            value: ''
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getStorages)(sessionStorage.userId).then(function (res) {
            _this.storageArr = res.data;
        });
        (0, _version.getProductsIds)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            console.log(res.data);
            _this.equipmentForm = res.data;
            if (res.data.otherProperty) {
                for (var i in res.data.otherProperty) {
                    _this.property.push({
                        name: i,
                        value: res.data.otherProperty[i]
                    });
                }
            }
        });
    },


    methods: {
        goBack: function goBack() {
            this.$router.push('/optinalList');
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.$refs['equipmentForm'].validate(function (valid) {
                if (valid) {
                    _this2.equipmentForm.otherProperty = {};
                    _this2.property.forEach(function (res) {
                        _this2.equipmentForm.otherProperty[res.name] = res.value;
                    });
                    (0, _version.patchProductsIds)(sessionStorage.userId, _this2.equipmentForm.productId, _this2.equipmentForm).then(function (res) {
                        console.log(res);
                        if (res.data) {
                            _this2.$message({
                                message: '恭喜你，更新成功',
                                type: 'success'
                            });
                            _this2.$router.push('/optinalList');
                        }
                    }, function (err) {
                        _this2.$message.error('更新失败');
                    });
                }
            });
        },
        addProperty: function addProperty() {
            if (this.key && this.value) {
                this.property.push({
                    name: this.key,
                    value: this.value
                });
                this.key = '';
                this.value = '';
            }
        },
        removeProperty: function removeProperty(index) {
            console.log(index);
            this.property.splice(--index, 1);
        }
    }
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            optionalForm: {
                name: '',
                rental: '',
                accessoryType: '',
                deposit: '',
                description: ''
            },
            addOptionalRules: {
                name: [{
                    required: true,
                    message: '请填写商品名',
                    trigger: 'blur'
                }],
                accessoryType: [{
                    required: true,
                    message: '请选择结算方式',
                    trigger: 'blur'
                }],
                rental: [{
                    required: true,
                    message: '请填写价格',
                    trigger: 'blur'
                }],
                deposit: [{
                    required: true,
                    message: '请填写押金',
                    trigger: 'blur'
                }]

            }
        };
    },
    created: function created() {
        var _this = this;

        console.log(this.$route.params.id);
        (0, _version.getProductDetailsId)(this.$route.params.id).then(function (res) {
            console.log(res.data, 'e');
            _this.optionalForm = JSON.parse((0, _stringify2.default)(res.data));
            _this.optionalForm.accessoryType = _this.optionalForm.accessoryType + '';
            _this.optionalForm.rental = _this.optionalForm.rental * 100 + '';
            _this.optionalForm.deposit = _this.optionalForm.deposit * 100 + '';
        });
    },


    methods: {
        goBack: function goBack() {
            this.$router.push('/optinalList');
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            this.$refs['optionalForm'].validate(function (valid) {
                if (valid) {
                    var data = JSON.parse((0, _stringify2.default)(_this2.optionalForm));
                    console.log(_this2.optionalForm);
                    data.rental = data.rental * 1;
                    data.deposit = data.deposit * 1;
                    data.accessoryType = data.accessoryType * 1;
                    (0, _version.putProductDetailsId)(_this2.$route.params.id, sessionStorage.userId, data).then(function (res) {
                        console.log(res);
                        if (res.data) {
                            _this2.$message({
                                message: '更新成功',
                                type: 'success'
                            });
                            _this2.goBack();
                        }
                    }, function (err) {
                        _this2.$message.error('更新失败');
                    });
                }
            });
        }
    }
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(69);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            productForm: {
                name: '',
                accessoryType: '',
                description: '',
                rental: '',
                oldRental: '',
                minimumDay: '',
                categoryId: '',
                rentalMore: '',
                isOnline: true,
                media: {
                    video: '',

                    pic: [],

                    detail: []
                },
                inventory: [],
                insurance: '',
                pushProductDetails: [],
                fileListPic: []
            },

            shopForm: {
                price_current: '',
                price_old: '',
                name: '',
                productDetailId: '',
                product: ''
            },
            addProductRules: {
                categoryId: [{
                    type: 'number',
                    required: true,
                    message: '请选择商品分类',
                    trigger: 'blur'
                }],
                name: [{
                    required: true,
                    message: '请填写商品名称',
                    trigger: 'blur'
                }],
                description: [{
                    required: true,
                    message: '请填写商品描述',
                    trigger: 'blur'
                }],
                deposit: [{
                    required: true,
                    message: '请填写商品押金',
                    trigger: 'blur'
                }],
                rental: [{
                    required: true,
                    message: '请填写商品的每日租金',
                    trigger: 'blur'
                }],
                oldRental: [{
                    required: true,
                    message: '请填写商品原租金价格',
                    trigger: 'blur'
                }],
                minimumDay: [{
                    required: true,
                    message: '请填写商品起租天数',
                    trigger: 'blur'
                }],
                rentalMore: [{
                    required: true,
                    message: '请填写商品后续价格',
                    trigger: 'blur'
                }]
            },
            list: {},
            dialogImageUrl: '',
            dialogVisible: false,
            uptoken: {
                token: sessionStorage.token
            },
            insurance: '',
            zhenxuan: '1',
            catogreyArr: [],
            topicArr: [],
            topic: '',
            value10: '',
            oldTopic: [],
            oldValue10: [],
            xuanpeiArr: [],
            productArr: [],
            fileListPic: [],
            fileListDetail: [],
            zmRentTypeMap: {
                ZMSC_1_1_3: '数码摄像',
                ZMSC_1_1_4: '配件',
                ZMSC_1_1_5: '智能设备'
            }
        };
    },
    created: function created() {
        var _this2 = this;

        (0, _version.getProductCategories)().then(function (res) {
            console.log(res, '分类');
            _this2.catogreyArr = res.data;
        }, function (err) {
            console.log(err);
        });

        (0, _version.getProductTags)().then(function (res) {
            console.log(res, '标签');
            _this2.topicArr = res.data;
        }, function (err) {
            console.log(err);
        });

        (0, _version.getProductDetailsId)(this.$route.params.id).then(function (res) {
            _this2.productForm = res.data;
            _this2.productForm.deposit = _this2.productForm.deposit * 100 + '';
            _this2.productForm.rental = _this2.productForm.rental * 100 + '';
            _this2.productForm.oldRental = _this2.productForm.oldRental * 100 + '';
            _this2.productForm.minimumDay = _this2.productForm.minimumDay + '';
            _this2.productForm.rentalMore = _this2.productForm.rentalMore * 100 + '';
            _this2.productForm.zmRentType = res.data.zmRentType;
            if (_this2.productForm.insurance > 0) {
                _this2.productForm.insurance = _this2.productForm.insurance * 100 + '';
            } else {
                _this2.productForm.insurance = null;
            }

            if (_this2.productForm.insurance > 0) {
                _this2.insurance = '1';
            } else {
                _this2.insurance = '0';
            }
            if (_this2.productForm.pushProductDetails && _this2.productForm.pushProductDetails.length) {
                _this2.zhenxuan = '0';
            }

            if (_this2.productForm.media.pic.length) {

                _this2.productForm.media.pic.forEach(function (res) {
                    _this2.fileListPic.push({
                        url: res
                    });
                });
            }

            if (res.data.media.detail.length) {
                res.data.media.detail.forEach(function (res) {
                    _this2.fileListDetail.push({
                        url: res
                    });
                });
            }
        });

        (0, _version.getProductTagAll)(sessionStorage.userId, (0, _stringify2.default)({ "where": { "productDetailId": this.$route.params.id }, "include": "productTag" })).then(function (res) {
            console.log(res.data, 'bbb');
            if (res.data) {
                res.data.forEach(function (item) {
                    _this2.oldTopic.push(item.id);
                    _this2.topic.push(item.tagId);
                });
            }
        });

        (0, _version.getProductAccessoriesDetailId)(sessionStorage.userId, (0, _stringify2.default)({ 'where': { 'productDetailId': this.$route.params.id }, 'include': 'accessory' })).then(function (res) {
            if (res.data) {
                res.data.forEach(function (item) {
                    _this2.oldValue10.push(item.id);
                    _this2.value10.push(item.accessoryId);
                });
            }
        });

        (0, _version.getProductDetailsOnly)(sessionStorage.userId, (0, _stringify2.default)({ where: { accessoryType: 0 } })).then(function (res) {
            _this2.productArr = res.data;
        });

        (0, _version.getProductAccessories)(sessionStorage.userId, (0, _stringify2.default)({ 'where': { 'accessoryType': { 'neq': 0 } } })).then(function (res) {
            console.log(res, '选配');
            _this2.xuanpeiArr = res.data;
        });
    },


    methods: {
        addList: function addList() {
            if (this.list.name && this.list.count) {
                this.productForm.inventory.push([this.list.name, this.list.count]);
                this.list = {
                    name: '',
                    count: ''
                };
            }
        },
        removeCard: function removeCard(index) {
            this.productForm.pushProductDetails.splice(index, 1);
        },
        handleVideoRemove: function handleVideoRemove(file, fileList) {},
        handleVideoSuccess: function handleVideoSuccess(res, file) {
            this.productForm.media.videoThumb = 'https://img.shareplay.cc/' + res.key;
        },
        addShop: function addShop() {
            if (!this.shopForm.name) {
                this.$message.error('请填写描述');
            } else if (!this.shopForm.product) {
                this.$message.error('请选择商品');
            } else {
                var data = {
                    productDetailId: this.shopForm.productDetailId,
                    rental: this.shopForm.product.rental,
                    oldRental: this.shopForm.product.oldRental,
                    name: this.shopForm.name,
                    media: this.shopForm.product.media
                };
                if (!this.productForm.pushProductDetails) {
                    this.productForm.pushProductDetails = [];
                }
                this.productForm.pushProductDetails.push(data);
                this.shopForm = {
                    price_current: '',
                    price_old: '',
                    name: '',
                    productDetailId: '',
                    product: ''
                };
            }
        },
        productChoose: function productChoose(val) {
            var _this3 = this;

            console.log(val);
            this.productArr.forEach(function (item) {
                if (item.productDetailId === val) {
                    _this3.shopForm.product = item;
                }
            });
        },
        handleRemove: function handleRemove(file, fileList) {
            var arr = [];
            fileList.forEach(function (item) {
                if (item.response) {
                    arr.push('https://img.shareplay.cc/' + item.response.hash);
                } else {
                    arr.push(item.url);
                }
            });
            this.productForm.media.pic = arr;
        },
        handleDetailRemove: function handleDetailRemove(file, fileList) {
            console.log(file);
            console.log(fileList[0].response);
            var arr = [];
            fileList.forEach(function (item) {
                if (item.response) {
                    arr.push('https://img.shareplay.cc/' + item.response.hash);
                } else {
                    arr.push(item.url);
                }
            });
            this.productForm.media.detail = arr;
        },
        handlePictureCardPreview: function handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePicCardPreview: function handlePicCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleError: function handleError() {
            this.$message.error('请重新登录');
            this.$router.push('/login');
        },
        handlePicSuccess: function handlePicSuccess(res, file) {
            this.productForm.media.pic.push('https://img.shareplay.cc/' + res.key);
        },
        beforePicUpload: function beforePicUpload() {
            if (this.productForm.media.pic.length >= 6) {
                this.$message({
                    message: '橱窗图片最多上传6张',
                    type: 'warning'
                });
                return false;
            }
        },
        handleDetailSuccess: function handleDetailSuccess(res, file) {
            this.productForm.media.detail.push('https://img.shareplay.cc/' + res.key);
        },
        beforeDetailUpload: function beforeDetailUpload() {},
        onSubmit: function onSubmit() {
            var _this4 = this;

            this.$refs['productForm'].validate(function (valid) {
                console.log(_this4.productForm);
                console.log(_this4.value10, 't');
                if (valid) {
                    if (_this4.insurance === '1' && !_this4.productForm.insurance) {
                        _this4.$message.error('请填写保险服务价格');
                    } else if (!_this4.productForm.media.pic.length) {
                        _this4.$message.error('请上传商品橱窗图片');
                    } else if (!_this4.productForm.media.detail.length) {
                        _this4.$message.error('请上传商品详情图片');
                    } else if (_this4.zhenxuan === '0' && (!_this4.productForm.pushProductDetails || !_this4.productForm.pushProductDetails.length)) {
                        _this4.$message.error('请添加享玩甄选设置');
                    } else {

                        if (_this4.zhenxuan === '1') {
                            _this4.productForm.pushProductDetails = null;
                        }

                        (0, _version.putProductDetails)(sessionStorage.userId, _this4.$route.params.id, _this4.productForm).then(function (res) {
                            if (res.data) {
                                _this4.productForm.insurance = '';
                                var result = res.data;
                                var topicArr = [];
                                var oldArr = [];

                                if (_this4.oldTopic.length) {
                                    _this4.oldTopic.forEach(function (item) {
                                        oldArr.push((0, _version.deleteProductTag)(sessionStorage.userId, item).then(function (res) {}));
                                    });
                                }

                                if (_this4.oldValue10.length) {
                                    _this4.oldValue10.forEach(function (item) {
                                        oldArr.push((0, _version.deleteProductAccessories)(sessionStorage.userId, item).then(function (res) {}));
                                    });
                                }

                                _promise2.default.all(oldArr).then(function (res) {
                                    _this4.topic.forEach(function (item) {
                                        var data = {
                                            "tagId": item,
                                            "productDetailId": result.productDetailId
                                        };
                                        topicArr.push((0, _version.postProductTag)(sessionStorage.userId, data).then(function (res) {
                                            console.log(res.data, '标签');
                                        }));
                                    });

                                    _this4.value10.forEach(function (item) {
                                        var data = {
                                            "accessoryId": item,
                                            "productDetailId": result.productDetailId
                                        };
                                        topicArr.push((0, _version.postProductAccessories)(sessionStorage.userId, data).then(function (res) {
                                            console.log(res);
                                        }));
                                    });

                                    _promise2.default.all(topicArr).then(function (val) {
                                        _this4.$message({
                                            message: '恭喜你，成功添加商品',
                                            type: 'success'
                                        });
                                        _this4.$router.push('/list');
                                    });
                                });
                            }
                        }, function (err) {
                            _this4.$message.error('添加失败');
                        });
                    }
                }
            });
        },
        goBack: function goBack() {
            this.$router.push('/list');
        },
        removeThis: function removeThis(index) {
            var _this = index;
            this.productForm.inventory.splice(--_this, 1);
            console.log(index);
        }
    }
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            currentPage: 1,
            totalNum: 0,
            form: {},
            fetchList: [],
            storageArr: [],
            productId: '',
            dialogFormVisible: false,
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        this.productId = this.$route.params.id;
        (0, _version.getProductCount)(sessionStorage.userId, (0, _stringify2.default)({

            'productDetailId': this.productId

        })).then(function (res) {
            console.log(res.data);
            _this.totalNum = res.data.count;
        });

        (0, _version.getProducts)(sessionStorage.userId, (0, _stringify2.default)({
            'where': {
                'productDetailId': this.productId
            },
            "limit": 20,
            "skip": 0
        })).then(function (res) {

            _this.loading = false;
            res.data.forEach(function (item) {
                if (item.productDetailId === _this.$route.params.id * 1) {
                    console.log(1);
                    _this.fetchList.push(item);
                    _this.loading = false;
                }
            });

            (0, _version.getStorages)(sessionStorage.userId).then(function (res) {
                _this.storageArr = res.data;
                res.data.forEach(function (item) {
                    _this.fetchList.forEach(function (item2) {
                        if (item.id === item2.storageId) {
                            item2.storageName = item.storageName;
                        }
                    });
                });
            }, function (err) {
                console.log(err);
            });
        });
    },


    methods: {
        handleBack: function handleBack() {
            this.$router.push('/list');
        },
        handleOnline: function handleOnline(index, row) {
            var _this2 = this;

            this.$confirm('此操作将该设备设置为上架, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchProducts)(sessionStorage.userId, row.productId, {
                    isOnline: true
                }).then(function (res) {
                    if (res.data) {
                        row.isOnline = true;
                        _this2.$message({
                            message: '上架成功',
                            type: 'success'
                        });
                    }
                });
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消上架'
                });
            });
        },
        handleOff: function handleOff(index, row) {
            var _this3 = this;

            this.$confirm('此操作将该设备设置为下架, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchProducts)(sessionStorage.userId, row.productId, {
                    isOnline: false
                }).then(function (res) {
                    if (res.data) {
                        row.isOnline = false;
                        _this3.$message({
                            message: '下架成功',
                            type: 'success'
                        });
                    }
                });
            }).catch(function () {
                _this3.$message({
                    type: 'info',
                    message: '已取消下架'
                });
            });
        },
        handleSizeChange: function handleSizeChange(val) {
            console.log('\u6BCF\u9875 ' + val + ' \u6761');
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this4 = this;

            this.loading = true;
            (0, _version.getProducts)(sessionStorage.userId, (0, _stringify2.default)({
                'where': {
                    'productDetailId': this.productId
                },
                "limit": 20,
                "skip": 20 * --val
            })).then(function (res) {
                res.data.forEach(function (item) {
                    if (item.productDetailId === _this4.$route.params.id * 1) {
                        console.log(1);
                        _this4.fetchList.push(item);
                        _this4.loading = false;
                    }
                });

                (0, _version.getStorages)(sessionStorage.userId).then(function (res) {
                    _this4.storageArr = res.data;
                    res.data.forEach(function (item) {
                        _this4.fetchList.forEach(function (item2) {
                            if (item.id === item2.storageId) {
                                item2.storageName = item.storageName;
                            }
                        });
                    });
                }, function (err) {
                    console.log(err);
                });
            });
        },
        handleAdd: function handleAdd() {
            this.$router.push('/addEquipment/' + this.productId);
        },
        handleEdit: function handleEdit(index, row) {
            this.$router.push('/editEquipment/' + row.productId);
        },
        handleOrder: function handleOrder(index, row) {
            var _this5 = this;

            console.log(row);
            (0, _version.getRentHistory)(sessionStorage.userId, row.productId).then(function (res) {
                if (res.data) {
                    if (res.data.result) {
                        _this5.dialogFormVisible = true;
                        _this5.form = res.data.result;
                        _this5.form.created = row.created;
                    } else {
                        var h = _this5.$createElement;
                        _this5.$message({
                            message: h('p', null, [h('span', null, '暂无租赁历史 '), h('i', {
                                style: 'color: teal'
                            })])
                        });
                    }
                }
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this6 = this;

            console.log(row);
            this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this6.fetchList.splice(index, 1);

                (0, _version.deleteProducts)(row.productId).then(function (res) {
                    if (res.data) {
                        _this6.$message({
                            message: '成功删除',
                            type: 'success'
                        });
                    }
                }, function (err) {
                    _this6.$message.error('删除失败');
                });
            }).catch(function () {
                _this6.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
    }
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            currentPage: 1,
            totalNum: 0,
            form: {},
            fetchList: [],
            dialogFormVisible: false
        };
    },
    created: function created() {
        var _this = this;

        var data = {
            'where': {
                'accessoryType': {
                    neq: 0
                }
            },
            "limit": 20,
            "skip": 0
        };
        (0, _version.getProductdetailsCount)(sessionStorage.userId, (0, _stringify2.default)({
            'accessoryType': {
                'neq': 0
            }
        })).then(function (res) {
            console.log(res.data);
            _this.totalNum = res.data.count;
        });
        (0, _version.getAccessory)(sessionStorage.userId, (0, _stringify2.default)(data)).then(function (res) {

            res.data.forEach(function (item) {
                (0, _version.getProducts)(sessionStorage.userId, (0, _stringify2.default)({
                    'where': {
                        'productDetailId': item.productDetailId
                    }
                })).then(function (response) {
                    item.deviceArr = response.data;
                    response.data.forEach(function (items) {
                        (0, _version.getStoragesId)(sessionStorage.userId, items.storageId).then(function (response) {
                            items.storageArr = response.data;
                        });
                        (0, _version.getRentHistory)(sessionStorage.userId, items.productId).then(function (res) {
                            items.rentHistory = res.data;
                            console.log(res.data, 'gg');
                        });
                    });
                });
            });
            _this.fetchList = res.data;
            console.log(res.data, 'ff');
        }, function (err) {
            console.log(err);
        });
    },


    methods: {
        handleOnlined: function handleOnlined(index, row, props) {
            var _this2 = this;

            console.log(props);
            this.$confirm('此操作将该设备设置为上架, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchProducts)(sessionStorage.userId, row[index].productId, {
                    isOnline: true
                }).then(function (res) {
                    if (res.data) {
                        row[index].isOnline = true;
                        ++props.productCount;
                        _this2.$message({
                            message: '上架成功',
                            type: 'success'
                        });
                    }
                });
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消上架'
                });
            });
        },
        handleOffd: function handleOffd(index, row, props) {
            var _this3 = this;

            this.$confirm('此操作将该设备设置为下架, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchProducts)(sessionStorage.userId, row[index].productId, {
                    isOnline: false
                }).then(function (res) {
                    if (res.data) {
                        row[index].isOnline = false;
                        --props.productCount;
                        _this3.$message({
                            message: '下架成功',
                            type: 'success'
                        });
                    }
                });
            }).catch(function () {
                _this3.$message({
                    type: 'info',
                    message: '已取消下架'
                });
            });
        },
        handleSizeChange: function handleSizeChange(val) {
            console.log('\u6BCF\u9875 ' + val + ' \u6761');
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this4 = this;

            this.loading = true;

            var data = {
                'where': {
                    'accessoryType': {
                        neq: 0
                    }
                },

                "limit": 20,
                "skip": 20 * --val
            };
            (0, _version.getAccessory)(sessionStorage.userId, (0, _stringify2.default)(data)).then(function (res) {

                res.data.forEach(function (item) {
                    (0, _version.getProducts)(sessionStorage.userId, (0, _stringify2.default)({
                        'where': {
                            'productDetailId': item.productDetailId
                        }
                    })).then(function (response) {
                        item.deviceArr = response.data;
                        response.data.forEach(function (items) {
                            (0, _version.getStoragesId)(sessionStorage.userId, items.storageId).then(function (response) {
                                items.storageArr = response.data;
                            });
                            (0, _version.getRentHistory)(sessionStorage.userId, items.productId).then(function (res) {
                                items.rentHistory = res.data;
                                console.log(res.data, 'gg');
                            });
                        });
                    });
                });
                _this4.fetchList = res.data;
                _this4.loading = false;
                console.log(res.data, 'ff');
            }, function (err) {
                console.log(err);
            });
        },
        handleView: function handleView(index, row) {
            if (row.result) {
                this.dialogFormVisible = true;
                this.form = row.result;
            } else {
                var h = this.$createElement;
                this.$message({
                    message: h('p', null, [h('span', null, '暂无租赁历史 '), h('i', {
                        style: 'color: teal'
                    })])
                });
            }
        },
        editDevice: function editDevice(index, row) {
            this.$router.push('/editEquipmentX/' + row[index].productId);
        },
        deleteDevice: function deleteDevice(index, row) {
            var _this5 = this;

            console.log(row);

            this.$confirm('此操作将删除该设备, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                (0, _version.deleteProductsOne)(sessionStorage.userId, row[index].productId).then(function (res) {
                    if (res.data) {
                        _this5.$message({
                            message: '成功删除',
                            type: 'success'
                        });
                        row.splice(index, 1);
                    }
                }, function (err) {
                    _this5.$message.error('删除失败');
                });
            }).catch(function () {
                _this5.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleAdd: function handleAdd(index, row) {
            this.$router.push('/addEquipmentX/' + row.productDetailId);
        },
        handleAddNew: function handleAddNew() {
            this.$router.push('/addOptional');
        },
        handleOnline: function handleOnline(index, row) {
            var _this6 = this;

            this.$confirm('此操作将该选配设置为上架, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchProductDetails)(sessionStorage.userId, row.productDetailId, {
                    isOnline: true
                }).then(function (res) {
                    if (res.data) {
                        row.isOnline = true;
                        _this6.$message({
                            message: '上架成功',
                            type: 'success'
                        });
                    }
                });
            }).catch(function () {
                _this6.$message({
                    type: 'info',
                    message: '已取消上架'
                });
            });
        },
        handleOff: function handleOff(index, row) {
            var _this7 = this;

            this.$confirm('此操作将该选配设置为下架, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchProductDetails)(sessionStorage.userId, row.productDetailId, {
                    isOnline: false
                }).then(function (res) {
                    if (res.data) {
                        row.isOnline = false;
                        _this7.$message({
                            message: '下架成功',
                            type: 'success'
                        });
                    }
                });
            }).catch(function () {
                _this7.$message({
                    type: 'info',
                    message: '已取消下架'
                });
            });
        },
        handleEdit: function handleEdit(index, val) {
            this.$router.push('/editOptional/' + val.productDetailId);
        }
    }
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            addCategory: false,
            editCategory: false,
            uptoken: {
                token: sessionStorage.token
            },
            categoryForm: {
                name: '',
                description: '',
                picUrl: ''
            },
            picUrl: '',
            addCategoryRules: {
                name: [{
                    required: true,
                    message: '请输入分类名称',
                    trigger: 'blur'
                }],
                description: [{
                    required: true,
                    message: '请输入分类描述',
                    trigger: 'blur'
                }],
                picUrl: [{
                    reuqired: true,
                    message: '请上传分类图片',
                    trigger: 'blur'
                }]
            }
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getProductCategories)().then(function (res) {
            _this.fetchList = res.data;
        }, function (err) {
            console.log(err);
        });
    },


    methods: {
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.fetchList.splice(index, 1);

                (0, _version.deleteProductCategories)(row.categoryId, sessionStorage.userId).then(function (res) {
                    if (res.data.count) {
                        _this2.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                }, function (err) {
                    _this2.$message.error('删除分类失败');
                });
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleEdit: function handleEdit(index, row) {
            this.editCategory = true;
            this.categoryForm = row;
        },
        handleAdd: function handleAdd() {
            this.categoryForm = {
                name: '',
                description: '',
                picUrl: ''
            };
            this.addCategory = true;
        },
        handleUpdateCategory: function handleUpdateCategory() {
            var _this3 = this;

            this.$refs['categoryForm'].validate(function (valid) {
                if (_this3.categoryForm.picUrl) {
                    var data = JSON.parse((0, _stringify2.default)(_this3.categoryForm));
                    delete data.categoryId;
                    (0, _version.patchProductCategories)(_this3.categoryForm.categoryId, sessionStorage.userId, data).then(function (res) {
                        _this3.editCategory = false;
                    }, function (err) {
                        _this3.$message.error('新增分类失败');
                    });
                } else {
                    _this3.$message.error('请上传分类图片');
                }
            });
        },
        handleNewCategory: function handleNewCategory() {
            var _this4 = this;

            this.$refs['categoryForm'].validate(function (valid) {
                if (_this4.categoryForm.picUrl) {
                    _this4.categoryForm.isOnline = true;
                    (0, _version.putProductCategories)(sessionStorage.userId, _this4.categoryForm).then(function (res) {
                        _this4.fetchList.push(res.data);
                        _this4.addCategory = false;
                    }, function (err) {
                        _this4.$message.error('新增分类失败');
                    });
                } else {
                    _this4.$message.error('请上传分类图片');
                }
            });
        },
        beforeAvatarUpload: function beforeAvatarUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            };

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        handleAvatarSuccess: function handleAvatarSuccess(res, file) {
            this.categoryForm.picUrl = 'https://img.shareplay.cc/' + res.key;
        }
    }
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            clicked: false,
            demoEvents: [],
            loading: false,
            dialogTableVisible: false,
            totalNum: 0,
            currentPage: 1,
            fetchList: [],
            curPro: '',
            formInline: {
                name: '',
                categoryId: '',
                dayStart: '',
                dayEnd: '',
                productDetailNo: ''
            },
            catogreyArr: [],
            pickerOptionsStart: {
                disabledDate: function disabledDate(time) {}
            },
            pickerOptionsEnd: {
                disabledDate: function disabledDate(time) {}
            }
        };
    },
    created: function created() {
        var _this = this;

        var filter = (0, _stringify2.default)({
            "limit": 20,
            "skip": 0,
            'where': {
                'accessoryType': 0
            }
        });
        (0, _version.getProductDetailsOnly)(sessionStorage.userId, filter).then(function (res) {
            console.log(res);
            _this.fetchList = res.data;
        }, function (err) {
            console.log(err);
        });

        (0, _version.getProductdetailCount)(sessionStorage.userId, (0, _stringify2.default)({

            'accessoryType': 0

        })).then(function (res) {
            console.log(res.data);
            _this.totalNum = res.data.count;
        });

        (0, _version.getProductCategories)().then(function (res) {
            console.log(res, '分类');
            _this.catogreyArr = res.data;
        }, function (err) {
            console.log(err);
        });
    },


    methods: {
        getLastDay: function getLastDay(year, month) {
            var new_year = year;
            var new_month = month++;
            if (month > 12) {
                new_month -= 12;
                new_year++;
            }
            var new_date = new Date(new_year, new_month, 1);
            return new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate();
        },
        handleFreash: function handleFreash(index, row) {
            var _this2 = this;

            (0, _version.putProduct)(sessionStorage.userId, row.productDetailId).then(function (res) {
                if (res.data) {
                    console.log(res.data);
                    _this2.fetchList.forEach(function (item, index) {
                        if (item.productDetailId === res.data.productDetailId) {
                            _this2.fetchList[index] = res.data;
                            _this2.$message({
                                type: 'success',
                                message: '更新成功!'
                            });
                        }
                    });
                }
            });
        },
        dayChange: function dayChange(v) {
            var _this3 = this;

            console.log(v);
            if (v.events.length) {
                var filter = {
                    'where': {
                        'date': v.events[0].date.split('/').join('-'),
                        'productDetailId': this.curPro,
                        'status': 1
                    },
                    'include': 'order'
                };
                (0, _version.getProductRent)(sessionStorage.userId, (0, _stringify2.default)(filter)).then(function (res) {
                    console.log(res);
                    if (res.data.length) {
                        _this3.demoEvents.forEach(function (item, index) {
                            if (item.date === v.events[0].date) {
                                _this3.demoEvents[index].title = [];
                                res.data.forEach(function (item2) {
                                    _this3.demoEvents[index].title.push({
                                        'text': '\u8BA2\u5355\u53F7\uFF1A ' + item2.order.orderNo
                                    });
                                });
                            }
                        });
                    }
                });
            }
        },
        handleSizeChange: function handleSizeChange(val) {
            console.log('\u6BCF\u9875 ' + val + ' \u6761');
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this4 = this;

            this.loading = true;
            var filter = (0, _stringify2.default)({
                "limit": 20,
                "skip": 20 * --val,
                'where': {
                    'accessoryType': 0
                }
            });
            (0, _version.getProductDetailsOnly)(sessionStorage.userId, filter).then(function (res) {
                console.log(res);
                _this4.fetchList = res.data;
                _this4.loading = false;
            }, function (err) {
                console.log(err);
            });
        },
        handleEdit: function handleEdit(index, row) {
            this.$router.push('/editProduct/' + row.productDetailId);
        },
        handleOff: function handleOff(index, row) {
            var _this5 = this;

            (0, _version.patchProductDetails)(sessionStorage.userId, row.productDetailId, {
                isOnline: false
            }).then(function (res) {
                console.log(res);
                if (res.data) {
                    row.isOnline = false;
                    _this5.$message({
                        message: '下架成功',
                        type: 'success'
                    });
                }
            }, function (err) {
                _this5.$message.error(err.response.data.error.message);
            });
        },
        handleOn: function handleOn(index, row) {
            var _this6 = this;

            (0, _version.patchProductDetails)(sessionStorage.userId, row.productDetailId, {
                isOnline: true
            }).then(function (res) {
                console.log(res);
                if (res.data) {
                    row.isOnline = true;
                    _this6.$message({
                        message: '成功上架',
                        type: 'success'
                    });
                }
            });
        },
        handleView: function handleView(index, row) {
            var _this7 = this;

            this.curPro = row.productDetailId;

            function GetDateStr(AddDayCount) {
                var dd = new Date();
                dd.setDate(dd.getDate() + AddDayCount);
                var y = dd.getFullYear();
                var m = dd.getMonth() + 1;
                var d = dd.getDate();
                return y + "-" + m + "-" + d;
            }

            var nextD = GetDateStr(30);
            var y = nextD.split('-')[0];
            var m = nextD.split('-')[1];
            var d = this.getLastDay(y, m);
            console.log(d, 'd');

            this.dialogTableVisible = true;
            (0, _version.getMount)(sessionStorage.userId, row.productDetailId, GetDateStr(0), y + '-' + m + '-' + d).then(function (res) {
                console.log(res);
                _this7.demoEvents = [];
                for (var i in res.data.result) {
                    console.log((i + '').split('-').join('/'));
                    _this7.demoEvents.push({
                        'date': (i + '').split('-').join('/'),
                        'title': [],
                        'number': res.data.result[i]
                    });
                }
            });
        },
        categoryChoose: function categoryChoose() {},
        handleEquipment: function handleEquipment(index, row) {
            this.$router.push('/equipment/' + row.productDetailId);
        },
        resetForm: function resetForm(formName) {
            this.formInline.dayEnd = '';
            this.$refs[formName].resetFields();
        },
        handleAdd: function handleAdd() {
            this.$router.push('/addProduct');
        },
        Search: function Search() {
            var _this8 = this;

            var data = {};
            data.accessoryType = 0;
            this.formInline.name ? data.name = {
                'like': '%25' + this.formInline.name + '%25'
            } : '';
            this.formInline.productDetailNo ? data.productDetailNo = this.formInline.productDetailNo : '';
            this.formInline.categoryId ? data.categoryId = this.formInline.categoryId : '';
            if (this.formInline.dayStart && !this.dayEnd) {
                data.created = {
                    gt: this.formInline.dayStart
                };
            } else if (!this.formInline.dayStart && this.formInline.dayEnd) {
                data.created = {
                    lt: this.formInline.dayStart
                };
            } else if (this.formInline.dayStart && this.formInline.dayEnd) {
                data.created = {
                    between: [this.formInline.dayStart, this.formInline.dayEnd]
                };
            }
            console.log(data);
            var search = {
                'where': data
            };
            console.log((0, _stringify2.default)(search));
            (0, _version.filterProductDetails)((0, _stringify2.default)(search)).then(function (res) {
                _this8.fetchList = res.data;
            }, function (err) {
                console.log(err);
            });

            (0, _version.getProductdetailCount)(sessionStorage.userId, (0, _stringify2.default)(search.where)).then(function (res) {
                console.log(res.data);
                _this8.totalNum = res.data.count;
            });
        },
        startChange: function startChange(val) {
            console.log(val);
            this.pickerOptionsEnd = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < new Date(val).getTime();
                }
            };
        },
        endChange: function endChange(val) {
            console.log(val);
            this.pickerOptionsStart = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > new Date(val).getTime();
                }
            };
        }
    }
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            fetchList: [],
            addTag: false,
            editTag: false,
            uptoken: {
                token: sessionStorage.token
            },
            tagForm: {
                name: '',
                description: ''
            },
            addTagRules: {
                name: [{
                    required: true,
                    message: '请输入标签名称',
                    trigger: 'blur'
                }],
                description: [{
                    required: true,
                    message: '请输入标签描述',
                    trigger: 'blur'
                }]
            }
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getProductTags)().then(function (res) {
            console.log(res.data);
            _this.fetchList = res.data;
        }, function (err) {
            console.log(err);
        });
    },


    methods: {
        handleDelete: function handleDelete(index, row) {
            var _this2 = this;

            this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.fetchList.splice(index, 1);

                (0, _version.deleteProductTags)(row.tagId, sessionStorage.userId).then(function (res) {
                    if (res.data.count) {
                        _this2.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                }, function (err) {
                    _this2.$message.error('删除分类失败');
                });
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleEdit: function handleEdit(index, row) {
            this.editTag = true;
            this.tagForm = row;
        },
        handleAdd: function handleAdd() {
            this.tagForm = {
                name: '',
                description: ''
            };
            this.addTag = true;
        },
        handleUpdateTag: function handleUpdateTag() {
            var _this3 = this;

            this.$refs['tagForm'].validate(function (valid) {
                var data = JSON.parse((0, _stringify2.default)(_this3.tagForm));
                delete data.tagId;
                (0, _version.patchProductTags)(_this3.tagForm.tagId, sessionStorage.userId, data).then(function (res) {
                    _this3.editTag = false;
                    _this3.$message({
                        type: 'success',
                        message: '更新成功!'
                    });
                }, function (err) {
                    _this3.$message.error('新增分类失败');
                });
            });
        },
        handleNewTag: function handleNewTag() {
            var _this4 = this;

            this.$refs['tagForm'].validate(function (valid) {
                _this4.tagForm.isOnline = true;
                (0, _version.postProductTags)(sessionStorage.userId, _this4.tagForm).then(function (res) {
                    _this4.fetchList.push(res.data);
                    _this4.addTag = false;
                    _this4.$message({
                        type: 'success',
                        message: '成功增加分类!'
                    });
                }, function (err) {
                    _this4.$message.error('新增分类失败');
                });
            });
        }
    }
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _version = __webpack_require__(2);

exports.default = {
    data: function data() {
        return {
            userInfo: {},
            addressInfo: {},
            userDetail: {},
            dialogVisible: false,
            passVisible: false,
            line: '',
            remark: ''
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getIdentificationId)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            console.log(res.data, 'ffd');
            _this.userInfo = res.data;
            res.data.pictures.forEach(function (item, index) {
                console.log(item);
                if (item.length > 4) {
                    _this.userInfo.pictures[index] = 'https://img.shareplay.cc/' + item;
                }
            });
            console.log(_this.userInfo.pictures, 'ff');
        });

        (0, _version.getUsersDetail)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            _this.userDetail = res.data;
        });

        (0, _version.getDefaultAddress)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            console.log(res.data);
            _this.addressInfo = res.data;
        });
    },


    methods: {
        goBack: function goBack() {
            this.$router.push('/identified');
        },
        handleNo: function handleNo() {
            this.passVisible = true;
        },
        surePass: function surePass() {
            var _this2 = this;

            (0, _version.putUserManage)(sessionStorage.userId, this.$route.params.id, {
                id: this.$route.params.id,
                remark: this.remark,
                line: 0
            }).then(function (res) {
                if (res.data) {
                    _this2.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    _this2.$router.push('/identified');
                }
            }, function (err) {
                _this2.$message.error('提交失败');
            });
        },
        sureEnter: function sureEnter() {
            var _this3 = this;

            (0, _version.putUserManage)(sessionStorage.userId, this.$route.params.id, {
                id: this.$route.params.id,
                line: this.line * 1
            }).then(function (res) {
                if (res.data) {
                    _this3.$message({
                        message: '审核通过',
                        type: 'success'
                    });
                    _this3.$router.push('/identified');
                }
            }, function (err) {
                _this3.$message.error('审核失败');
            });
        },
        onSubmit: function onSubmit() {
            this.dialogVisible = true;
        }
    }
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            fetchList: [],
            formInline: {
                nickName: '',
                username: '',
                dayStart: '',
                dayEnd: ''
            }

        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getIdentification)(sessionStorage.userId, (0, _stringify2.default)({
            "include": "userManage",
            "order": "userId desc",
            "where": {
                "status": 1
            }
        })).then(function (res) {
            console.log(res.data);
            _this.fetchList = res.data;
        });
    },


    methods: {
        resetForm: function resetForm(formName) {
            this.formInline = {
                nickName: '',
                username: ''
            };
            this.$refs[formName].resetFields();
        },
        handleChange: function handleChange(index, row) {
            this.$router.push('/changeIdentified/' + row.userId);
        },
        Search: function Search() {
            var _this2 = this;

            var data = {};

            this.formInline.nickName ? data.nickName = {
                'like': '%25' + this.formInline.nickName + '%25'
            } : '';
            this.formInline.username ? data.username = {
                'like': '%25' + this.formInline.username + '%25'
            } : '';

            if (data.nickName || data.username) {
                (0, _version.filterUser)(sessionStorage.userId, (0, _stringify2.default)({
                    'where': data
                })).then(function (res) {
                    if (res.data && res.data.length) {
                        _this2.fetchList = [];
                        res.data.forEach(function (item) {
                            var userId = item.userId;
                            var search = {
                                'include': 'userManage',
                                "order": "userId desc",
                                'where': {
                                    userId: userId,
                                    status: '1'
                                }
                            };
                            (0, _version.getIdentification)(sessionStorage.userId, (0, _stringify2.default)(search)).then(function (res) {
                                if (res.data.length) {
                                    _this2.fetchList.push(res.data[0]);
                                }
                            }, function (err) {
                                console.log(err);
                            });
                        });
                    } else {
                        _this2.fetchList = [];
                    }
                });
            } else {
                (0, _version.getIdentification)(sessionStorage.userId, (0, _stringify2.default)({
                    "include": "userManage",
                    "order": "userId desc",
                    "where": {
                        "status": 1
                    }
                })).then(function (res) {
                    console.log(res.data);
                    _this2.fetchList = res.data;
                });
            }
        }
    }
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            clientTypeMap: {
                alipay: '支付宝小程序',
                wechat: '微信小程序',
                h5: 'H5网页APP'
            },
            totalNum: 0,
            currentPage: 1,
            loading: false,
            fetchList: [],
            filter: {},
            formInline: {
                nickName: '',
                username: '',
                dayStart: '',
                dayEnd: ''
            },
            pickerOptionsStart: {
                disabledDate: function disabledDate(time) {}
            },
            pickerOptionsEnd: {
                disabledDate: function disabledDate(time) {}
            }
        };
    },
    created: function created() {
        var _this = this;

        this.filter = (0, _stringify2.default)({
            "limit": 20,
            "skip": 0,
            "order": "userId desc"
        });
        (0, _version.getUsers)(sessionStorage.userId, this.filter).then(function (res) {
            _this.fetchList = res.data;
            _this.loading = false;
        });
        (0, _version.getUserCount)(sessionStorage.userId, (0, _stringify2.default)({})).then(function (res) {
            _this.totalNum = res.data.count;
        });
    },


    methods: {
        handleSizeChange: function handleSizeChange(val) {
            console.log('\u6BCF\u9875 ' + val + ' \u6761');
        },
        handleCurrentChange: function handleCurrentChange(val) {
            var _this2 = this;

            this.loading = true;
            var filter = JSON.parse(this.filter);
            filter.skip = 20 * --val;
            (0, _version.getUsers)(sessionStorage.userId, (0, _stringify2.default)(filter)).then(function (res) {
                _this2.fetchList = res.data;
                _this2.loading = false;
            });
        },
        handleEdit: function handleEdit() {},
        handleCancel: function handleCancel(index, row) {
            var _this3 = this;

            this.$confirm('此操作将激活该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchUsersPsd)(sessionStorage.userId, row.userId, {
                    isForbidden: false
                }).then(function (res) {
                    if (res.data) {
                        _this3.$message({
                            message: '成功激活',
                            type: 'success'
                        });
                        row.isForbidden = false;
                    }
                });
            }).catch(function () {
                _this3.$message({
                    type: 'info',
                    message: '已取消激活'
                });
            });
        },
        handleView: function handleView(index, row) {
            this.$router.push('/userView/' + row.userId);
        },
        handleStop: function handleStop(index, row) {
            var _this4 = this;

            this.$confirm('此操作将禁用该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.patchUsersPsd)(sessionStorage.userId, row.userId, {
                    isForbidden: true
                }).then(function (res) {
                    if (res.data) {
                        _this4.$message({
                            message: '成功禁用',
                            type: 'success'
                        });
                        row.isForbidden = true;
                    }
                });
            }).catch(function () {
                _this4.$message({
                    type: 'info',
                    message: '已取消禁用'
                });
            });
        },
        handleDelete: function handleDelete(index, row) {
            var _this5 = this;

            this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {

                (0, _version.deleteUser)(sessionStorage.userId, row.userId).then(function (res) {
                    if (res.data) {
                        _this5.$message({
                            message: '成功删除',
                            type: 'success'
                        });
                        _this5.fetchList.splice(index, 1);
                    }
                }, function (err) {
                    _this5.$message.error('删除失败');
                });
            }).catch(function () {
                _this5.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        resetForm: function resetForm(formName) {
            this.formInline.dayEnd = '';
            this.$refs[formName].resetFields();
        },
        handleAdd: function handleAdd() {
            this.$router.push('/addProduct');
        },
        Search: function Search() {
            var _this6 = this;

            var data = JSON.parse(this.filter);
            data.skip = 0;
            delete data.nickName;
            delete data.username;
            this.formInline.nickName ? data.nickName = {
                'like': '%25' + this.formInline.nickName + '%25'
            } : '';
            this.formInline.username ? data.username = {
                'like': '%25' + this.formInline.username + '%25'
            } : '';
            if (this.formInline.dayStart && !this.dayEnd) {
                data.created = {
                    gt: this.formInline.dayStart
                };
            } else if (!this.formInline.dayStart && this.formInline.dayEnd) {
                data.created = {
                    lt: this.formInline.dayStart
                };
            } else if (this.formInline.dayStart && this.formInline.dayEnd) {
                data.created = {
                    between: [this.formInline.dayStart, this.formInline.dayEnd]
                };
            }
            console.log(data);
            var search = {
                'where': data
            };
            this.filter = (0, _stringify2.default)(data);
            console.log((0, _stringify2.default)(search));
            (0, _version.filterUser)(sessionStorage.userId, (0, _stringify2.default)(search)).then(function (res) {
                _this6.fetchList = res.data;
            }, function (err) {
                console.log(err);
            });

            (0, _version.getUserCount)(sessionStorage.userId, (0, _stringify2.default)(data)).then(function (res) {
                _this6.totalNum = res.data.count;
            });
        },
        startChange: function startChange(val) {
            console.log(val);
            this.pickerOptionsEnd = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < new Date(val).getTime();
                }
            };
        },
        endChange: function endChange(val) {
            console.log(val);
            this.pickerOptionsStart = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > new Date(val).getTime();
                }
            };
        }
    }
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(3);

var _stringify2 = _interopRequireDefault(_stringify);

var _version = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            Role: sessionStorage.power,
            clientTypeMap: {
                alipay: '支付宝小程序',
                wechat: '微信小程序',
                h5: 'H5网页APP'
            },
            userInfo: {},
            otherInfo: {},
            addressInfo: {},
            psdForm: {
                psd: ''
            },
            orderData: [],
            dialogFormVisible: false,
            dialogOrderVisible: false
        };
    },
    created: function created() {
        var _this = this;

        (0, _version.getUsersDetail)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            console.log(res.data);
            _this.userInfo = res.data;
            _this.userInfo.zmLine = _this.userInfo.zmLine / 100;
            _this.userInfo.identifiedLine = _this.userInfo.identifiedLine / 100;
        });

        (0, _version.getUserIdentification)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            _this.otherInfo = res.data;
            if (_this.otherInfo.pictures) {
                _this.otherInfo.pictures.forEach(function (item, index) {
                    if (item) {
                        _this.otherInfo.pictures[index] = 'https://img.shareplay.cc/' + item;
                    }
                });
            }
        });

        (0, _version.getDefaultAddress)(sessionStorage.userId, this.$route.params.id).then(function (res) {
            console.log(res.data);
            _this.addressInfo = res.data;
        });
        console.log(this.$route.params.id);
    },


    methods: {
        goBack: function goBack() {
            this.$router.push('/userList');
        },
        changePsd: function changePsd() {
            this.dialogFormVisible = true;
        },
        submitNew: function submitNew() {
            var _this2 = this;

            if (this.psdForm.psd) {
                var data = {
                    isSetPassword: true,
                    password: this.psdForm.psd
                };
                (0, _version.patchUsersPsd)(sessionStorage.userId, this.$route.params.id, data).then(function (res) {
                    if (res.data) {
                        _this2.dialogFormVisible = false;
                        _this2.$message({
                            message: '成功修改密码',
                            type: 'success'
                        });
                    }
                }, function (err) {
                    _this2.$message.error('修改密码失败');
                });
            }
        },
        handleOrder: function handleOrder() {
            var _this3 = this;

            this.dialogOrderVisible = true;

            (0, _version.getUserOrder)(sessionStorage.userId, this.$route.params.id, (0, _stringify2.default)({
                "order": "id desc"
            })).then(function (res) {
                console.log(res.data);
                res.data.orders.forEach(function (item, index) {
                    item.counts = 0;
                    if (item.dispalyExtra && item.dispalyExtra.mainItems) {
                        item.dispalyExtra.mainItems.forEach(function (item2) {
                            res.data.orders[index].counts += item2.amount;
                        });
                    }
                });
                _this3.orderData = res.data.orders;
            });
        }
    }
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUser = exports.editUser = exports.batchRemoveUser = exports.removeUser = exports.getUserListPage = exports.getUserList = exports.requestLogin = undefined;

var _axios = __webpack_require__(151);

var _axios2 = _interopRequireDefault(_axios);

var _baseUrl = __webpack_require__(104);

var _baseUrl2 = _interopRequireDefault(_baseUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = _baseUrl2.default;

var requestLogin = exports.requestLogin = function requestLogin(params) {
  return _axios2.default.post(base + '/login', params).then(function (res) {
    return res.data;
  });
};

var getUserList = exports.getUserList = function getUserList(params) {
  return _axios2.default.get(base + '/user/list', { params: params });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
  return _axios2.default.get(base + '/user/listpage', { params: params });
};

var removeUser = exports.removeUser = function removeUser(params) {
  return _axios2.default.get(base + '/user/remove', { params: params });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
  return _axios2.default.get(base + '/user/batchremove', { params: params });
};

var editUser = exports.editUser = function editUser(params) {
  return _axios2.default.get(base + '/user/edit', { params: params });
};

var addUser = exports.addUser = function addUser(params) {
  return _axios2.default.get(base + '/user/add', { params: params });
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.login = login;
exports.getToken = getToken;

var _request = __webpack_require__(157);

var _request2 = _interopRequireDefault(_request);

var _baseUrl = __webpack_require__(104);

var _baseUrl2 = _interopRequireDefault(_baseUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEBUG_MODE = false;
var URL_PREFIX = DEBUG_MODE ? '' : _baseUrl2.default;

function login(data) {
  return _request2.default.post(URL_PREFIX + '/api/AdminUsers/login', data);
}

function getToken(id, token) {
  return _request2.default.get(URL_PREFIX + '/api/AdminUsers/' + id + '/getUploadToken?access_token=' + token);
}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(224);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(22);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(230);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(225);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(226);

var _vueRouter = __webpack_require__(231);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(223);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(149);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(222);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(227);

__webpack_require__(228);

var _vueCalendarC = __webpack_require__(229);

var _vueCalendarC2 = _interopRequireDefault(_vueCalendarC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueCalendarC2.default, { locale: 'zh' });

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

var router = new _vueRouter2.default({
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  var user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

var settoken = exports.settoken = function settoken(_ref3) {
    var commit = _ref3.commit;

    commit('SETTOKEN');
};

var setCurrentIndex = exports.setCurrentIndex = function setCurrentIndex(_ref4) {
    var commit = _ref4.commit;

    commit('SETCURRENTINDEX');
};

var setCategoryArr = exports.setCategoryArr = function setCategoryArr(_ref5) {
    var commit = _ref5.commit;

    commit('SETCATEGORYARR');
};

var setProductArr = exports.setProductArr = function setProductArr(_ref6) {
    var commit = _ref6.commit;

    commit('SETPRODUCTARR');
};

var setTopicArr = exports.setTopicArr = function setTopicArr(_ref7) {
    var commit = _ref7.commit;

    commit('SETTOPICARR');
};

var setLocalBanner = exports.setLocalBanner = function setLocalBanner(_ref8) {
    var commit = _ref8.commit;

    commit('SETLOCALBANNER');
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

var getToken = exports.getToken = function getToken(state) {
    return state.uptoken;
};

var getCurrentIndex = exports.getCurrentIndex = function getCurrentIndex(state) {
    return state.currentIndex;
};

var getTopicArr = exports.getTopicArr = function getTopicArr(state) {
    return state.topicArr;
};

var getProductArr = exports.getProductArr = function getProductArr(state) {
    return state.productArr;
};

var getCategoryArr = exports.getCategoryArr = function getCategoryArr(state) {
    return state.categoryArr;
};

var getLocalBanner = exports.getLocalBanner = function getLocalBanner(state) {
    return state.localBanner;
};

/***/ }),
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */,
/* 653 */,
/* 654 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(605)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(714),
  /* scopeId */
  "data-v-174fd0bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(607)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  "data-v-1d158685",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(751),
  /* scopeId */
  "data-v-b8ff9e9a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(743),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(748),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(738),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(742),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(609)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(613)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(757),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(624)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(747),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(610)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(745),
  /* scopeId */
  "data-v-939c1694",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(758),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(746),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(755),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(619)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(729),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(739),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(608)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(615)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(725),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(614)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(616)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(726),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(611)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(740),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(753),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  "data-v-1204ccb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(736),
  /* scopeId */
  "data-v-63552986",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(618)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(728),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(617)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(727),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(761),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(756),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(621)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(612)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(754),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(606)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(762),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(749),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(744),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(737),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(741),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(759),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(620)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(760),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(750),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(752),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("专题列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList,
      "default-sort": {
        prop: 'title',
        prop: 'caption',
        prop: 'topicType'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "sortable": "",
      "label": "专题标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "图片",
      "width": "180"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('img', {
            staticClass: "user-pic",
            attrs: {
              "src": _vm.row.banner
            }
          })
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "caption",
      "label": "专题描述",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "分类／标签",
      "width": "180",
      "prop": "topicType",
      "sortable": ""
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.topicType === 0) ? _c('span', [_vm._v("\n\t\t\t            分类\n\t\t\t          ")]) : (_vm.row.topicType === 1) ? _c('span', [_vm._v("\n\t\t\t            标签\n\t\t\t        ")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑用户"
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.username),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "username", $$v)
      },
      expression: "editForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择活动区域"
    },
    model: {
      value: (_vm.editForm.address),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "address", $$v)
      },
      expression: "editForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("商品列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加商品")])], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名"
    },
    model: {
      value: (_vm.formInline.name),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "name", $$v)
      },
      expression: "formInline.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类选择",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    on: {
      "change": _vm.categoryChoose
    },
    model: {
      value: (_vm.formInline.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "categoryId", $$v)
      },
      expression: "formInline.categoryId"
    }
  }, _vm._l((_vm.catogreyArr), function(item) {
    return _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创建时间",
      "prop": "dayStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptionsStart
    },
    on: {
      "change": _vm.startChange
    },
    model: {
      value: (_vm.formInline.dayStart),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dayStart", $$v)
      },
      expression: "formInline.dayStart"
    }
  }), _vm._v("\n                -\n                "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptionsEnd
    },
    on: {
      "change": _vm.endChange
    },
    model: {
      value: (_vm.formInline.dayEnd),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dayEnd", $$v)
      },
      expression: "formInline.dayEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "条形码编号",
      "prop": "productDetailNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "编号"
    },
    model: {
      value: (_vm.formInline.productDetailNo),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "productDetailNo", $$v)
      },
      expression: "formInline.productDetailNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "default-sort": {
        prop: 'date',
        order: 'descending'
      },
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productDetailId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rental",
      "label": "租金",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deposit",
      "label": "押金",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rentalCount",
      "label": "租赁次数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productCount",
      "label": "设备数量",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "创建时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "isOnline",
      "label": "商品状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.isOnline) ? _c('span', [_vm._v("上架")]) : _c('span', [_vm._v("下架")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEquipment(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("设备管理")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.Role === '1' && _vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOff(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), (!_vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOn(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看库存")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleFreash(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("更新商品统计")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看库存",
      "visible": _vm.dialogTableVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [(_vm.dialogTableVisible) ? _c('vue-event-calendar', {
    attrs: {
      "events": _vm.demoEvents
    },
    on: {
      "day-changed": _vm.dayChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.showEvents), function(event, index) {
          return _c('div', {
            staticClass: "event-wrapper"
          }, _vm._l((event.title), function(item) {
            return _c('div', {
              staticClass: "event-item"
            }, [_vm._v("\n                            " + _vm._s(item.text) + "\n                        ")])
          }), 0)
        })
      }
    }], null, false, 956717776)
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加商品")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "productForm",
    attrs: {
      "label-width": "150px",
      "model": _vm.productForm,
      "rules": _vm.addProductRules
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("商品分类：")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择商品分类",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.productForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "categoryId", $$v)
      },
      expression: "productForm.categoryId"
    }
  }, _vm._l((_vm.catogreyArr), function(item) {
    return _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品标签"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "标签"
    },
    model: {
      value: (_vm.topic),
      callback: function($$v) {
        _vm.topic = $$v
      },
      expression: "topic"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("基本信息：")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名"
    },
    model: {
      value: (_vm.productForm.name),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "name", $$v)
      },
      expression: "productForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品描述"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品描述"
    },
    model: {
      value: (_vm.productForm.description),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "description", $$v)
      },
      expression: "productForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品押金(单位：分)",
      "prop": "deposit"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品押金"
    },
    model: {
      value: (_vm.productForm.deposit),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "deposit", $$v)
      },
      expression: "productForm.deposit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起租的每日租金(单位：分)",
      "prop": "rental"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "起租的每日租金"
    },
    model: {
      value: (_vm.productForm.rental),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "rental", $$v)
      },
      expression: "productForm.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原租金价格(单位：分)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原租金价格"
    },
    model: {
      value: (_vm.productForm.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "oldRental", $$v)
      },
      expression: "productForm.oldRental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起租天数设置",
      "prop": "minimumDay"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "起租天数设置"
    },
    model: {
      value: (_vm.productForm.minimumDay),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "minimumDay", $$v)
      },
      expression: "productForm.minimumDay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "后续价格(单位：分)",
      "prop": "rentalMore"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "后续价格"
    },
    model: {
      value: (_vm.productForm.rentalMore),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "rentalMore", $$v)
      },
      expression: "productForm.rentalMore"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传商品橱窗图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "list-type": "picture-card",
      "on-preview": _vm.handlePicCardPreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handlePicSuccess,
      "before-upload": _vm.beforePicUpload,
      "data": _vm.uptoken
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频链接(选填)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "视频链接"
    },
    model: {
      value: (_vm.productForm.media.video),
      callback: function($$v) {
        _vm.$set(_vm.productForm.media, "video", $$v)
      },
      expression: "productForm.media.video"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传视频封面图(选填)"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "show-file-list": false,
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "on-remove": _vm.handleVideoRemove,
      "on-success": _vm.handleVideoSuccess,
      "before-upload": _vm.beforeDetailUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.productForm.media.videoThumb) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.productForm.media.videoThumb
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品清单"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称"
    },
    model: {
      value: (_vm.list.name),
      callback: function($$v) {
        _vm.$set(_vm.list, "name", $$v)
      },
      expression: "list.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    staticStyle: {
      "text-align": "center",
      "border": "0"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数量"
    },
    model: {
      value: (_vm.list.count),
      callback: function($$v) {
        _vm.$set(_vm.list, "count", $$v)
      },
      expression: "list.count"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addList
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), (_vm.productForm.inventory.length) ? _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, _vm._l((_vm.productForm.inventory), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v(_vm._s(++index) + "、" + _vm._s(item[0]) + "*" + _vm._s(item[1]) + " "), _c('el-button', {
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeThis(index)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否提供PlayCare保险服务"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.insurance),
      callback: function($$v) {
        _vm.insurance = $$v
      },
      expression: "insurance"
    }
  }, [_vm._v("提供")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.insurance),
      callback: function($$v) {
        _vm.insurance = $$v
      },
      expression: "insurance"
    }
  }, [_vm._v("不提供")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "20px",
      "width": "200px"
    },
    attrs: {
      "placeholder": "如果提供请输入价格(单位：分)"
    },
    model: {
      value: (_vm.productForm.insurance),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "insurance", $$v)
      },
      expression: "productForm.insurance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传商品详情图"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleDetailRemove,
      "on-success": _vm.handleDetailSuccess,
      "before-upload": _vm.beforeDetailUpload,
      "data": _vm.uptoken
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配设置"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "商品"
    },
    model: {
      value: (_vm.value10),
      callback: function($$v) {
        _vm.value10 = $$v
      },
      expression: "value10"
    }
  }, _vm._l((_vm.xuanpeiArr), function(item) {
    return _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("享玩甄选设置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.zhenxuan),
      callback: function($$v) {
        _vm.zhenxuan = $$v
      },
      expression: "zhenxuan"
    }
  }, [_vm._v("默认为首页的享玩甄选")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.zhenxuan),
      callback: function($$v) {
        _vm.zhenxuan = $$v
      },
      expression: "zhenxuan"
    }
  }, [_vm._v("重新设置")])], 1), _vm._v(" "), (_vm.zhenxuan != '1') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "享玩甄选描述",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.name),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "name", $$v)
      },
      expression: "shopForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品选择",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.shopForm.productDetailId),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "productDetailId", $$v)
      },
      expression: "shopForm.productDetailId"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.shopForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.shopForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "rental", $$v)
      },
      expression: "shopForm.product.rental"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shopForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "原租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "oldRental", $$v)
      },
      expression: "shopForm.product.oldRental"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addShop
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "50px",
      "overflow": "hidden"
    },
    attrs: {
      "label": "",
      "label-width": "150px"
    }
  }, _vm._l((_vm.productForm.pushProductDetails), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('el-card', {
      staticClass: "box-card",
      staticStyle: {
        "width": "260px",
        "margin-right": "20px",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "line-height": "36px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeCard(index)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('div', {
      staticClass: "text item"
    }, [_c('p', [_vm._v("当前租金：" + _vm._s(item.rental))]), _vm._v(" "), _c('p', [_vm._v("原来租金：" + _vm._s(item.oldReantal))])])])], 1)
  }), 0)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("数据统计")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.freashRent
    }
  }, [_vm._v("手动更细订单总金额与租金")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-danger"
  }, [_c('h3', [_vm._v("昨日新用户数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.lastUserNum))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-info"
  }, [_c('h3', [_vm._v("昨日成功订单数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.lastSuccessOrder))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-warning"
  }, [_c('h3', [_vm._v("过去一个月注册用户数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.monthRegister))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-success"
  }, [_c('h3', [_vm._v("过去一个月支付订单数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.monthSuccessOrder))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h3', [_vm._v("累计获的租金")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.rentalSum))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h3', [_vm._v("上架商品总数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.onlineProduct))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h3', [_vm._v("过去一个月获的租金")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.monthRental))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h3', [_vm._v("已芝麻绑定用户数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.zmUserNum))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-info"
  }, [_vm._v("\n                    待发货订单\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderUnderDeliver))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-silver"
  }, [_vm._v("\n                    待返还确认订单\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderUnderReturn))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-warning"
  }, [_vm._v("\n                    未付款订单数\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderUnderPay))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-success"
  }, [_vm._v("\n                    待返还订单\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderDelivered))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-danger"
  }, [_vm._v("\n                    订单总金额\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderPayMount))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("租赁次数前10的商品")])]), _vm._v(" "), _vm._l((_vm.fetch.rentalCountTopProducts), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_vm._v("\n                        " + _vm._s(++i) + "、" + _vm._s(o.name) + "\n                    ")])
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("累计租金最高的前10商品")])]), _vm._v(" "), _vm._l((_vm.fetch.rentalSumTopProducts), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_vm._v("\n                        " + _vm._s(++i) + "、" + _vm._s(o.name) + "\n                    ")])
  })], 2)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("首页版本设置")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "版本号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "当前状态",
      "width": "180"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.global[0] && _vm.global[0].SettingValue) ? _c('div', [(_vm.row.version === _vm.global[0].SettingValue[_vm.row.refer]) ? _c('span', {
            staticStyle: {
              "color": "#67C23A"
            }
          }, [_vm._v("激活中")]) : _c('span', {
            staticStyle: {
              "color": "#999"
            }
          }, [_vm._v("未激活")])]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户端来源",
      "context": _vm._self
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(_vm.referList[_vm.row.refer]))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "版本名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "context": _vm._self
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作",
      "align": "right"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.global[0] && _vm.global[0].SettingValue) ? _c('span', [(_vm.row.version !== _vm.global[0].SettingValue[_vm.row.refer]) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleLive(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("激活")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.Role !== '0' && (_vm.row.version !== _vm.global[0].SettingValue)) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1) : _vm._e()
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建首页版本"
    },
    model: {
      value: (_vm.addVersion),
      callback: function($$v) {
        _vm.addVersion = $$v
      },
      expression: "addVersion"
    }
  }, [_c('el-form', {
    ref: "versionForm",
    attrs: {
      "model": _vm.versionForm,
      "rules": _vm.addVersionRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本号",
      "label-width": "120px",
      "prop": "version"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.version),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "version", $$v)
      },
      expression: "versionForm.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版本名称",
      "label-width": "120px",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "remark", $$v)
      },
      expression: "versionForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户端来源",
      "label-width": "120px",
      "prop": "remark"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.versionForm.refer),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "refer", $$v)
      },
      expression: "versionForm.refer"
    }
  }, _vm._l((_vm.referList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "基于某个版本",
      "label-width": "120px",
      "prop": "base"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "基于版本"
    },
    model: {
      value: (_vm.versionForm.base),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "base", $$v)
      },
      expression: "versionForm.base"
    }
  }, _vm._l((_vm.versionOption), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.version,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('versionForm')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑首页版本"
    },
    model: {
      value: (_vm.editVersion),
      callback: function($$v) {
        _vm.editVersion = $$v
      },
      expression: "editVersion"
    }
  }, [_c('el-form', {
    ref: "versionForm",
    attrs: {
      "model": _vm.versionForm,
      "rules": _vm.addVersionRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本号",
      "label-width": "120px",
      "prop": "version"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.version),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "version", $$v)
      },
      expression: "versionForm.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版本名称",
      "label-width": "120px",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "remark", $$v)
      },
      expression: "versionForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户端来源",
      "label-width": "120px",
      "prop": "remark"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.versionForm.refer),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "refer", $$v)
      },
      expression: "versionForm.refer"
    }
  }, _vm._l((_vm.referList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('versionForm')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑设备")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "equipmentForm",
    attrs: {
      "model": _vm.equipmentForm,
      "rules": _vm.addEquipmentRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备序列号",
      "label-width": "150px",
      "prop": "deviceId"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "deviceId", $$v)
      },
      expression: "equipmentForm.deviceId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "条形码编码",
      "label-width": "150px",
      "prop": "productIdentity"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.productIdentity),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "productIdentity", $$v)
      },
      expression: "equipmentForm.productIdentity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在仓库",
      "label-width": "150px",
      "prop": "storageId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库"
    },
    model: {
      value: (_vm.equipmentForm.storageId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "storageId", $$v)
      },
      expression: "equipmentForm.storageId"
    }
  }, _vm._l((_vm.storageArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.storageName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "添加字段",
      "label-width": "150px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addProperty($event)
      }
    }
  }, [_vm._v("增加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("key:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.key),
      callback: function($$v) {
        _vm.key = $$v
      },
      expression: "key"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("value:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1), _vm._v(" "), (_vm.property.length) ? _c('el-form-item', {
    attrs: {
      "label": "已加字段",
      "label-width": "150px"
    }
  }, _vm._l((_vm.property), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt10"
    }, [_vm._v("\n                " + _vm._s(++index) + "、" + _vm._s(item.name) + " - " + _vm._s(item.value) + "\n                "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeProperty(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.equipmentForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "remark", $$v)
      },
      expression: "equipmentForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t享玩\n\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("订单详情")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-header"
  }, [(_vm.row.status >= 0) ? _c('p', {
    staticClass: "text-left"
  }, [_vm._v("当前订单状态：\n                "), (_vm.row.status === 0) ? _c('span', [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("交易关闭")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 3) ? _c('span', [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 4) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 5) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 6) ? _c('span', [_vm._v("待返还确认")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 7) ? _c('span', [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 8) ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 9) ? _c('span', [_vm._v("已退款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 98) ? _c('span', [_vm._v("已预约顺丰")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 99) ? _c('span', [_vm._v("完成中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 100) ? _c('span', [_vm._v("已删除")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "更多操作"
    },
    on: {
      "change": _vm.controlChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('h3', [_vm._v("订单信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.row
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.orderNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单时间：",
      "label-width": "260px"
    }
  }, [(_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "付款时间：",
      "label-width": "260px"
    }
  }, [(_vm.row.status === 0 || _vm.row.status === 2 || _vm.row.status === 100) ? _c('span', [_vm._v(" 暂无 ")]) : _vm._e(), _vm._v(" "), (_vm.row.status !== 0 && _vm.row.status !== 2 && _vm.row.status !== 100 && _vm.row.rentOrders && _vm.row.rentOrders.length && _vm.row.rentOrders[0].payment) ? _c('span', [_vm._v("\n                        " + _vm._s(new Date(_vm.row.rentOrders[0].payment.updated).getFullYear() + '-' + (new Date(_vm.row.rentOrders[0].payment.updated).getMonth() + 1) + '-' + new Date(_vm.row.rentOrders[0].payment.updated).getDate() + ' ' + new Date(_vm.row.rentOrders[0].payment.updated).getHours() + ':' + new Date(_vm.row.rentOrders[0].payment.updated).getMinutes() + ':' + new Date(_vm.row.rentOrders[0].payment.updated).getSeconds()) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货时间：",
      "label-width": "260px"
    }
  }, [_c('div', [(_vm.row.delivery && _vm.row.delivery.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.delivery.created).getFullYear() + '-' + (new Date(_vm.row.delivery.created).getMonth() + 1) + '-' + new Date(_vm.row.delivery.created).getDate() + ' ' + new Date(_vm.row.delivery.created).getHours() + ':' + new Date(_vm.row.delivery.created).getMinutes() + ':' + new Date(_vm.row.delivery.created).getSeconds()) + " ")]) : _c('span', [_vm._v("暂未发货")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式：",
      "label-width": "260px"
    }
  }, [(_vm.row.status !== 0 && _vm.row.status !== 2 && _vm.row.status !== 100 && _vm.row.rentOrders && _vm.row.rentOrders.length) ? _c('span', [_vm._v(_vm._s(_vm.row.isAlipayMini ? '支付宝支付' : '微信支付'))]) : _c('span', [_vm._v("暂未支付")])]), _vm._v(" "), (!_vm.row.isAlipayMini) ? _c('el-form-item', {
    attrs: {
      "label": "支付流水号：",
      "label-width": "260px"
    }
  }, [(_vm.row.status !== 0 && _vm.row.status !== 2 && _vm.row.status !== 100 && _vm.row.rentOrders && _vm.row.rentOrders.length && _vm.row.rentOrders[0].payment) ? _c('span', [_vm._v(_vm._s(_vm.row.rentOrders[0].payment.tradeNo))]) : _c('span', [_vm._v("暂未支付")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "260px"
    }
  }, [(_vm.xuDay > 0) ? _c('el-tag', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("已续租" + _vm._s(_vm.xuDay) + "天")]) : _vm._e()], 1), _vm._v(" "), (_vm.row.isAlipayMini) ? [_c('el-form-item', {
    attrs: {
      "label": "身份证号：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.certNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "人脸识别：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.zmFace ? '通过' : '未通过'))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "芝麻订单号：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.zmOrderNo))])])] : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('h3', [_vm._v("物流信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.row
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件人：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.receiverName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.receiverTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址：",
      "label-width": "260px"
    }
  }, [(_vm.row.addressDetail) ? _c('span', [_vm._v(_vm._s(_vm.row.addressDetail.province + ' ' + _vm.row.addressDetail.city + ' ' + _vm.row.addressDetail.district + ' ' + (_vm.row.addressDetail.detail || _vm.row.addressDetail.fullAddress)))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物流公司：",
      "label-width": "260px"
    }
  }, [_c('div', [(_vm.expressData && _vm.expressData.shipper) ? _c('span', [_vm._v(_vm._s(_vm.expressData.shipper === 'SELF' ? '自提' : _vm.expressData.shipper))]) : _c('span', [_vm._v("暂无")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "快递单号：",
      "label-width": "260px"
    }
  }, [(_vm.expressData && _vm.expressData.expressNum) ? _c('span', [_vm._v(_vm._s(_vm.expressData.expressNum))]) : _c('span', [_vm._v("暂无")]), _vm._v(" "), (_vm.expressData && _vm.expressData.expressNum && _vm.expressData.shipper !== 'SELF') ? _c('el-button', {
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.searchExpress
    }
  }, [_vm._v("查物流")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货人：",
      "label-width": "260px"
    }
  }, [(_vm.row.status === 0 || _vm.row.status === 2 || _vm.row.status === 100) ? _c('span', [_vm._v(" 暂无 ")]) : _c('span', [_vm._v(_vm._s(_vm.row.delivery && _vm.row.delivery.operator ? _vm.row.delivery.operator : '暂无'))])])], 1)], 1), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.nickName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "真实姓名：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.identityInfo ? _vm.identityInfo.zmName : ''))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(((_vm.identityInfo && _vm.identityInfo.zmPhone) ? _vm.identityInfo.zmPhone : _vm.row.receiverTel) || ''))])]), _vm._v(" "), (_vm.row.dispalyExtra && _vm.row.dispalyExtra.tenancy.length) ? _c('el-form-item', {
    attrs: {
      "label": "租赁时间：",
      "label-width": "260px"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.fromatDate(_vm.row.dispalyExtra.tenancy[0].begin)))]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm.rentDay) + "天")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.row && _vm.row.dispalyExtra && _vm.row.dispalyExtra.tenancy) ? _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.fromatDate(_vm.row.dispalyExtra.tenancy[0].end)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "租金(单位：元)：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row.status === 0 || _vm.row.status === 2) ? _vm.row.dispalyExtra.unpaidRentOrder.rental : _vm.row.dispalyExtra.paidData.rental))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "优惠券抵扣(单位：元)：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row.status === 0 || _vm.row.status === 2) ? _vm.row.dispalyExtra.unpaidRentOrder.discount : _vm.row.dispalyExtra.paidData.discount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "押金(单位：元)：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row.status === 0 || _vm.row.status === 2) ? _vm.row.dispalyExtra.unpaidRentOrder.deposit : _vm.row.dispalyExtra.paidData.deposit))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "减免押金(单位：元)：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row.status === 0 || _vm.row.status === 2) ? _vm.row.dispalyExtra.unpaidRentOrder.depositDiscount : _vm.row.dispalyExtra.paidData.depositDiscount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "费用统计(单位：元)：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row.status === 0 || _vm.row.status === 2) ? _vm.row.dispalyExtra.unpaidRentOrder.payMount : _vm.row.dispalyExtra.paymount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "费用统计(单位：元)：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row.status === 0 || _vm.row.status === 2) ? _vm.row.dispalyExtra.unpaidRentOrder.payMount : _vm.row.dispalyExtra.paymount))])]) : _vm._e(), _vm._v(" "), (_vm.row.isAlipayMini) ? [(_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "支付宝小程序-芝麻信用免押金额(单位：元)：",
      "label-width": "300px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row.dispalyExtra.unpaidRentOrder && _vm.row.dispalyExtra.unpaidRentOrder.creditAmount) || _vm.row.dispalyExtra.paidData.creditAmount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "支付宝小程序-冻结押金金额(单位：元)：",
      "label-width": "300px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row.dispalyExtra.unpaidRentOrder && _vm.row.dispalyExtra.unpaidRentOrder.freezeAmount) || _vm.row.dispalyExtra.paidData.freezeAmount))])]) : _vm._e(), _vm._v(" "), (_vm.row.rentOrders.length && _vm.row.rentOrders[0].payment) ? _c('el-form-item', {
    attrs: {
      "label": "支付宝小程序-押金冻结方式：",
      "label-width": "300px"
    }
  }, [_c('span', [_vm._v(_vm._s({
    'WITHHOLD': '代扣',
    'PREAUTH': '预授权',
    'ALL': '代扣&预授权'
  } [_vm.row.rentOrders[0].payment.fundType]))])]) : _vm._e(), _vm._v(" "), (_vm.row.status > 2 && _vm.row.status < 8) ? _c('el-form-item', {
    attrs: {
      "label": "支付宝小程序-扣款记录：",
      "label-width": "300px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.row.dispalyExtra.paidData.installmentHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderId",
      "label": "订单ID",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "内部订单号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zmOrderNo",
      "label": "芝麻订单号",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transNo",
      "label": "资金流水号",
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payAmount",
      "label": "金额(元)",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "扣款类型"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', {
            style: ({
              'color': (_vm.row.isFinishLose ? '#F56C6C' : '#67C23A')
            })
          }, [_vm._v(_vm._s(_vm.row.isFinishLose ? '资损扣款' : '分期扣款'))])
        
      },
      staticRenderFns: []
    }
  })], 1)], 1) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.row.orderItems
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productCount",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "价格(元)"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('span', [_vm._v(_vm._s(_vm.row.unitPrice / 100))]), _c('span', [_vm._v(_vm._s(_vm.row.accessoryType === 2 ? '/天' : ''))])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "序列号"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.status === 0 || _vm.status === 2 || _vm.status === 1 || _vm.status === 100 || _vm.status === 8 || _vm.status === 9) ? _c('span', [_vm._v(" 暂无 ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.row.deviceArr), function(i) {
            return _c('p', {
              key: i
            }, [_vm._v(_vm._s(i))])
          })], 2)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "仓库"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.status === 0 || _vm.status === 2 || _vm.status === 1 || _vm.status === 100 || _vm.status === 8 || _vm.status === 9) ? _c('span', [_vm._v(" 暂无 ")]) : _c('span', [_vm._v(_vm._s(_vm.storageName))])
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3,
      "offset": 19
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.row.dispalyExtra) ? _c('p', [_vm._v("实际支付：" + _vm._s(_vm.row.dispalyExtra.paidData.paymount))]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('h3', [_vm._v("用户设备返还物流信息")]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "快递单号：",
      "label-width": "260px"
    }
  }, [(_vm.row && _vm.row.delivery && _vm.row.delivery.returnExpressNum) ? _c('span', [_vm._v(_vm._s(_vm.row.delivery.returnExpressNum))]) : _vm._e(), _vm._v(" "), (_vm.row && _vm.row.delivery && !_vm.row.delivery.returnExpressNum) ? _c('span', [_vm._v("暂无")]) : _vm._e(), _vm._v(" "), (_vm.row && _vm.row.delivery && _vm.row.delivery.returnExpressNum) ? _c('el-button', {
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.searchBackExpress
    }
  }, [_vm._v("查物流")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "物流信息",
      "visible": _vm.dialogFormVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "model": _vm.form,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "快递单号：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.expressNum))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物流公司：",
      "label-width": "260px"
    }
  }, [_c('span', [_vm._v("顺丰")])]), _vm._v(" "), (_vm.form.status) ? _c('el-form-item', {
    attrs: {
      "label": "状态：",
      "label-width": "260px"
    }
  }, [(_vm.form.status.State === '0') ? _c('span', [_vm._v("无轨迹")]) : _vm._e(), _vm._v(" "), (_vm.form.status.State === '1') ? _c('span', [_vm._v("已揽收")]) : _vm._e(), _vm._v(" "), (_vm.form.status.State === '2') ? _c('span', [_vm._v("在途中")]) : _vm._e(), _vm._v(" "), (_vm.form.status.State === '3') ? _c('span', [_vm._v("签收")]) : _vm._e(), _vm._v(" "), (_vm.form.status.State === '4') ? _c('span', [_vm._v("问题件")]) : _vm._e(), _vm._v(" "), (_vm.form.status.State === '201') ? _c('span', [_vm._v("到达派件城市")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.form.status) ? _c('el-form-item', {
    attrs: {
      "label": "物流信息：",
      "label-width": "260px"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, _vm._l((_vm.form.status.Traces), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item.AcceptTime
      }
    }, [_c('span'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.AcceptStation))])])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认返还",
      "visible": _vm.dialogBack
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogBack = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.sureB
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入返还的快递单号",
      "label-width": "200px"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.sureB.name),
      callback: function($$v) {
        _vm.$set(_vm.sureB, "name", $$v)
      },
      expression: "sureB.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogBack = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureBackOrder
    }
  }, [_vm._v("确认返还")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更改返还快递单号",
      "visible": _vm.dialogBacke
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogBacke = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.sureB
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返还的快递单号",
      "label-width": "200px"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.sureB.name),
      callback: function($$v) {
        _vm.$set(_vm.sureB, "name", $$v)
      },
      expression: "sureB.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogBacke = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureBackOrdere
    }
  }, [_vm._v("确认更改")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更改物流信息",
      "visible": _vm.dialogWu
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogWu = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.wuliu
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入快递单号",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.wuliu.expressNum),
      callback: function($$v) {
        _vm.$set(_vm.wuliu, "expressNum", $$v)
      },
      expression: "wuliu.expressNum"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogWu = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureChangeW
    }
  }, [_vm._v("确认更改")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加专题")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "topicForm",
    attrs: {
      "model": _vm.topicForm,
      "rules": _vm.addTopicRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专题标题",
      "label-width": "150px",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.title),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "title", $$v)
      },
      expression: "topicForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题描述",
      "label-width": "150px",
      "prop": "caption"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.caption),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "caption", $$v)
      },
      expression: "topicForm.caption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传banner图",
      "label-width": "150px",
      "prop": "banner"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.topicForm.banner) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.topicForm.banner
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转类型选择",
      "label-width": "150px",
      "prop": "topicType"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.topicForm.topicType),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "topicType", $$v)
      },
      expression: "topicForm.topicType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("商品标签")])], 1)], 1), _vm._v(" "), (_vm.topicForm.topicType) ? _c('el-form-item', {
    attrs: {
      "label": "已选择",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.choosedNow),
      callback: function($$v) {
        _vm.choosedNow = $$v
      },
      expression: "choosedNow"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题下的商品选择",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.topicForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "shop", $$v)
      },
      expression: "topicForm.shop"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), (_vm.topicForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.topicForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.topicForm.product, "rental", $$v)
      },
      expression: "topicForm.product.rental"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.topicForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "商品原价(元)",
      "label-width": "150px",
      "prop": "oldRental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.topicForm.product, "oldRental", $$v)
      },
      expression: "topicForm.product.oldRental"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题二维码尺寸",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "show-file-list": false,
      "on-success": _vm.handlePicArrSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.topicUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.topicUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("添加该商品")])], 1), _vm._v(" "), (_vm.topicForm.productDetails.length) ? _c('el-form-item', {
    attrs: {
      "label": "已选择商品",
      "label-width": "150px"
    }
  }, [_c('el-row', _vm._l((_vm.topicForm.productDetails), function(o, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 8,
        "offset": index > 0 ? 2 : 0
      }
    }, [_c('el-card', {
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [(o.qrcode) ? _c('img', {
      staticClass: "image",
      attrs: {
        "src": o.qrcode
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "14px"
      }
    }, [_c('span', [_vm._v(_vm._s(o.name))]), _vm._v(" "), _c('div', {
      staticClass: "bottom clearfix"
    }, [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    }, [_vm._v("删除")])], 1)])])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择标签"
    },
    model: {
      value: (_vm.chooseTopic),
      callback: function($$v) {
        _vm.chooseTopic = $$v
      },
      expression: "chooseTopic"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_topic
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择标签",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "标签"
    },
    model: {
      value: (_vm.cur_topic.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_topic, "now", $$v)
      },
      expression: "cur_topic.now"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseTopic = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.topicChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择分类"
    },
    model: {
      value: (_vm.chooseCatogry),
      callback: function($$v) {
        _vm.chooseCatogry = $$v
      },
      expression: "chooseCatogry"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_categroy
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.cur_categroy.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_categroy, "now", $$v)
      },
      expression: "cur_categroy.now"
    }
  }, _vm._l((_vm.categoryArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseCatogry = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.catogryChoose
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("享玩甄选设置")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList,
      "default-sort": {
        prop: 'name',
        prop: 'description'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "描述",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("仓库地址列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "storageNo",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageName",
      "label": "仓库名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "recipient",
      "label": "收件人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "提交时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceCount",
      "label": "拥有的设备数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看仓库信息",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库名称：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.storageName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "仓库编号：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.storageNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.recipient))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.mobile))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.fullAddress))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建仓库地址",
      "visible": _vm.dialogNewVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogNewVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库名称",
      "label-width": "150px",
      "prop": "storageName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.storageName),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "storageName", $$v)
      },
      expression: "newForm.storageName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "仓库编号",
      "label-width": "150px",
      "prop": "storageNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.storageNo),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "storageNo", $$v)
      },
      expression: "newForm.storageNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人",
      "label-width": "150px",
      "prop": "recipient"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.recipient),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "recipient", $$v)
      },
      expression: "newForm.recipient"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "150px",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "mobile", $$v)
      },
      expression: "newForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市区选择",
      "label-width": "150px"
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "large",
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "label-width": "150px",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.address),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "address", $$v)
      },
      expression: "newForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogNewVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNewOne
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑仓库地址",
      "visible": _vm.dialogEditVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库名称",
      "label-width": "150px",
      "prop": "storageName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.storageName),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "storageName", $$v)
      },
      expression: "newForm.storageName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "仓库编号",
      "label-width": "150px",
      "prop": "storageNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.storageNo),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "storageNo", $$v)
      },
      expression: "newForm.storageNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人",
      "label-width": "150px",
      "prop": "recipient"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.recipient),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "recipient", $$v)
      },
      expression: "newForm.recipient"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "150px",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "mobile", $$v)
      },
      expression: "newForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市区选择",
      "label-width": "150px"
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "large",
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "label-width": "150px",
      "prop": "fullAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.fullAddress),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "fullAddress", $$v)
      },
      expression: "newForm.fullAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogEditVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editStorage
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "equipmentForm",
    attrs: {
      "model": _vm.equipmentForm,
      "rules": _vm.addEquipmentRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备序列号",
      "label-width": "150px",
      "prop": "deviceId"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "deviceId", $$v)
      },
      expression: "equipmentForm.deviceId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "条形码编号",
      "label-width": "150px",
      "prop": "productIdentity"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.productIdentity),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "productIdentity", $$v)
      },
      expression: "equipmentForm.productIdentity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在仓库",
      "label-width": "150px",
      "prop": "storageId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库"
    },
    model: {
      value: (_vm.equipmentForm.storageId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "storageId", $$v)
      },
      expression: "equipmentForm.storageId"
    }
  }, _vm._l((_vm.storageArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.storageName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "添加字段",
      "label-width": "150px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addProperty($event)
      }
    }
  }, [_vm._v("增加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("key:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.key),
      callback: function($$v) {
        _vm.key = $$v
      },
      expression: "key"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "20px",
      "margin-right": "10px"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("value:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1), _vm._v(" "), (_vm.property.length) ? _c('el-form-item', {
    attrs: {
      "label": "已加字段",
      "label-width": "150px"
    }
  }, _vm._l((_vm.property), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt10"
    }, [_vm._v("\n                " + _vm._s(++index) + "、" + _vm._s(item.name) + " - " + _vm._s(item.value) + "\n                "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeProperty(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.equipmentForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "remark", $$v)
      },
      expression: "equipmentForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑轮播banner")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.bannerForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传banner图",
      "label-width": "100px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转类型选择",
      "label-width": "100px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.bannerForm.type),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "type", $$v)
      },
      expression: "bannerForm.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("商品类型")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("商品标签")])], 1)], 1), _vm._v(" "), (_vm.bannerForm.type === '0') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品类型",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.type === '2') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.type === '1') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品标签",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择分类"
    },
    model: {
      value: (_vm.chooseCatogry),
      callback: function($$v) {
        _vm.chooseCatogry = $$v
      },
      expression: "chooseCatogry"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_categroy
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.cur_categroy.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_categroy, "now", $$v)
      },
      expression: "cur_categroy.now"
    }
  }, _vm._l((_vm.categoryArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseCatogry = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.catogryChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择标签"
    },
    model: {
      value: (_vm.chooseTopic),
      callback: function($$v) {
        _vm.chooseTopic = $$v
      },
      expression: "chooseTopic"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_topic
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择标签",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "标签"
    },
    model: {
      value: (_vm.cur_topic.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_topic, "now", $$v)
      },
      expression: "cur_topic.now"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseTopic = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.topicChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择商品"
    },
    model: {
      value: (_vm.chooseProduct),
      callback: function($$v) {
        _vm.chooseProduct = $$v
      },
      expression: "chooseProduct"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_product
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择商品",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    model: {
      value: (_vm.cur_product.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_product, "now", $$v)
      },
      expression: "cur_product.now"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseProduct = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.productChoose
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动区域"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择活动区域"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.$set(_vm.form, "region", $$v)
      },
      expression: "form.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "区域一",
      "value": "shanghai"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "区域二",
      "value": "beijing"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.$set(_vm.form, "date1", $$v)
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "fixed-time",
      "placeholder": "选择时间"
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.$set(_vm.form, "date2", $$v)
      },
      expression: "form.date2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "即时配送"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动性质"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "美食/餐厅线上活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "地推活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "线下主题活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "单纯品牌曝光",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特殊资源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.resource),
      callback: function($$v) {
        _vm.$set(_vm.form, "resource", $$v)
      },
      expression: "form.resource"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "线上品牌商赞助"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "线下场地免费"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动形式"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("订单列表")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, _vm._l((_vm.filterBtn), function(i, index) {
    return _c('el-button', {
      key: i.name,
      attrs: {
        "type": i.checked ? 'info' : 'warning'
      },
      on: {
        "click": function($event) {
          return _vm.Search(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(i.name) + "\n        ")])
  }), 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "昵称"
    },
    model: {
      value: (_vm.formInline.nickName),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "nickName", $$v)
      },
      expression: "formInline.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.formInline.username),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "username", $$v)
      },
      expression: "formInline.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "orderNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "订单编号"
    },
    model: {
      value: (_vm.formInline.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "orderNo", $$v)
      },
      expression: "formInline.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "dayStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptionsStart
    },
    on: {
      "change": _vm.startChange
    },
    model: {
      value: (_vm.formInline.dayStart),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dayStart", $$v)
      },
      expression: "formInline.dayStart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "dayStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptionsEnd
    },
    on: {
      "change": _vm.endChange
    },
    model: {
      value: (_vm.formInline.dayEnd),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dayEnd", $$v)
      },
      expression: "formInline.dayEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.SearchFilter
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "用户名"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.userManage) ? _c('span', [_vm._v(_vm._s(_vm.row.userManage.nickName))]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rentDay",
      "label": "租赁天数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dispalyExtra.paidData.rental",
      "label": "租金金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "支付方式"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(_vm.row.isAlipayMini ? '支付宝支付' : '微信支付'))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "订单状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 0) ? _c('span', [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("交易关闭")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 3) ? _c('span', [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 4) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 5) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 6) ? _c('span', [_vm._v("待返还确认")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 7) ? _c('span', [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 8) ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 9) ? _c('span', [_vm._v("已退款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 98) ? _c('span', [_vm._v("已预约顺丰")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 99) ? _c('span', [_vm._v("完成中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 100) ? _c('span', [_vm._v("已删除")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "下单时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看详情")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("订单发货管理")])])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "用户名"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.userManage) ? _c('span', [_vm._v(_vm._s(_vm.row.userManage.nickName))]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rentDay",
      "label": "租赁天数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dispalyExtra.paidData.rental",
      "label": "租金金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "支付方式"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(_vm.row.isAlipayMini ? '支付宝支付' : '微信支付'))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "订单状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 0) ? _c('span', [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("交易关闭")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 3) ? _c('span', [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 4) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 5) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 6) ? _c('span', [_vm._v("待返还确认")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 7) ? _c('span', [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 8) ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 9) ? _c('span', [_vm._v("已退款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 98) ? _c('span', [_vm._v("已预约顺丰")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 99) ? _c('span', [_vm._v("完成中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 100) ? _c('span', [_vm._v("已删除")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "下单时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleSend(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("发货")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("发货")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productCount",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "已选择设备"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', _vm._l((_vm.row.choosed), function(i) {
            return _c('p', {
              key: i
            }, [_vm._v(_vm._s(i))])
          }), 0)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleChoose(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("选择设备")])
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), (_vm.row.isAlipayMini && _vm.row.dispalyExtra) ? _c('section', {
    staticClass: "installment"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._v("\n                 分期数：" + _vm._s(_vm.hasInstallmentCount) + " / " + _vm._s(_vm.installmentCount) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._v("\n                租金：" + _vm._s((_vm.hasInstallmentCount * _vm.row.dispalyExtra.paidData.rental / _vm.installmentCount).toFixed(2)) + " / " + _vm._s(_vm.row.dispalyExtra.paidData.rental) + "\n            ")]), _vm._v(" "), (!_vm.canInstallment && !_vm.installmentDone) ? _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("今日已扣款，请明日执行")]) : _vm._e(), _vm._v(" "), (_vm.installmentDone) ? _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("扣款完成，可以发货")]) : _vm._e(), _vm._v(" "), (!_vm.installmentDone) ? _c('el-button', {
    attrs: {
      "disabled": !_vm.canInstallment,
      "type": "primary"
    },
    on: {
      "click": _vm.doInstallment
    }
  }, [_vm._v("扣款")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.row
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件人：",
      "label-width": "100px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.receiverName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "100px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.receiverTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址：",
      "label-width": "100px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.addressDetail.province + ' ' + _vm.row.addressDetail.city + ' ' + _vm.row.addressDetail.district + ' ' + _vm.row.addressDetail.fullAddress))])])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.sendForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运送方式",
      "label-width": "100px",
      "prop": "description"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.wayValue),
      callback: function($$v) {
        _vm.wayValue = $$v
      },
      expression: "wayValue"
    }
  }, _vm._l((_vm.waysArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.wayValue === 'express') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "快递公司",
      "label-width": "100px",
      "prop": "description"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sendForm.shipper),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "shipper", $$v)
      },
      expression: "sendForm.shipper"
    }
  }, _vm._l((_vm.expressArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "快递单号",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sendForm.expressNumber),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "expressNumber", $$v)
      },
      expression: "sendForm.expressNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货人",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sendForm.operator),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "operator", $$v)
      },
      expression: "sendForm.operator"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("发货")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.wayValue === 'self') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "快递单号",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sendForm.expressNumber),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "expressNumber", $$v)
      },
      expression: "sendForm.expressNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货人",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sendForm.operator),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "operator", $$v)
      },
      expression: "sendForm.operator"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("发货")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.nickName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.username))])]), _vm._v(" "), (_vm.row.dispalyExtra && _vm.row.dispalyExtra.tenancy.length) ? _c('el-form-item', {
    attrs: {
      "label": "租赁时间：",
      "label-width": "180px"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.fromatDate(_vm.row.dispalyExtra.tenancy[0].begin)))]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm.rentDay) + "天")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.row && _vm.row.dispalyExtra && _vm.row.dispalyExtra.tenancy) ? _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.fromatDate(_vm.row.dispalyExtra.tenancy[0].end)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "租金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.rental))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "优惠券抵扣(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.discount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "押金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.deposit))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "减免押金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.depositDiscount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "费用统计(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paymount))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加设备",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择仓库",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.storageChange
    },
    model: {
      value: (_vm.storage),
      callback: function($$v) {
        _vm.storage = $$v
      },
      expression: "storage"
    }
  }, _vm._l((_vm.storageArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.storageName,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.storageName))])])
  }), 1)], 1), _vm._v(" "), (_vm.storage) ? _c('el-form-item', {
    attrs: {
      "label": "选择设备",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.productId,
      attrs: {
        "label": item.deviceId,
        "value": item.productId
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.deviceId))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("序列号")])])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureNow
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Role === '1') ? _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "bannerForm",
    staticClass: "rules",
    attrs: {
      "model": _vm.bannerForm,
      "rules": _vm.bannerFormFules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户协议",
      "label-width": "150px",
      "prop": "user"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.bannerForm.user),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "user", $$v)
      },
      expression: "bannerForm.user"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "服务条款",
      "label-width": "150px",
      "prop": "service"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.bannerForm.service),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "service", $$v)
      },
      expression: "bannerForm.service"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "租赁协议",
      "label-width": "150px",
      "prop": "liu"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.bannerForm.liu),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "liu", $$v)
      },
      expression: "bannerForm.liu"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [(_vm.Role === '1') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)], 1)], 1)]) : _c('h3', [_vm._v("\n    暂无权限\n")])
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("热门搜索标签设置")])])], 1), _vm._v(" "), _c('el-form', {
    ref: "hotForm",
    attrs: {
      "model": _vm.hotForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "热门关键词设置",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.hot),
      callback: function($$v) {
        _vm.hot = $$v
      },
      expression: "hot"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "label-width": "150px"
    }
  }, [_c('div', _vm._l((_vm.row), function(item) {
    return _c('el-tag', {
      key: item,
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "type": "warning",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("设备返还入库")])])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "用户名"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.userManage) ? _c('span', [_vm._v(_vm._s(_vm.row.userManage.nickName))]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rentDay",
      "label": "租赁天数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dispalyExtra.paidData.rental",
      "label": "租金金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "支付方式"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.isAlipayMini) ? _c('span', [_vm._v("支付宝")]) : _c('span', [_vm._v("微信支付\n                        ")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "订单状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 0) ? _c('span', [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("交易关闭")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 3) ? _c('span', [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 4) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 5) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 6) ? _c('span', [_vm._v("待返还确认")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 7) ? _c('span', [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 8) ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 9) ? _c('span', [_vm._v("已退款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 98) ? _c('span', [_vm._v("已预约顺丰")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 99) ? _c('span', [_vm._v("完成中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 100) ? _c('span', [_vm._v("已删除")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "下单时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleSend(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("设备入库")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("商品标签")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tagId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "标签名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "创建时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建标签"
    },
    model: {
      value: (_vm.addTag),
      callback: function($$v) {
        _vm.addTag = $$v
      },
      expression: "addTag"
    }
  }, [_c('el-form', {
    ref: "tagForm",
    attrs: {
      "model": _vm.tagForm,
      "rules": _vm.addTagRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标签名称",
      "label-width": "120px",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tagForm.name),
      callback: function($$v) {
        _vm.$set(_vm.tagForm, "name", $$v)
      },
      expression: "tagForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签描述",
      "label-width": "120px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tagForm.description),
      callback: function($$v) {
        _vm.$set(_vm.tagForm, "description", $$v)
      },
      expression: "tagForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleNewTag
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑标签"
    },
    model: {
      value: (_vm.editTag),
      callback: function($$v) {
        _vm.editTag = $$v
      },
      expression: "editTag"
    }
  }, [_c('el-form', {
    ref: "tagForm",
    attrs: {
      "model": _vm.tagForm,
      "rules": _vm.addTagRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标签名称",
      "label-width": "120px",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tagForm.name),
      callback: function($$v) {
        _vm.$set(_vm.tagForm, "name", $$v)
      },
      expression: "tagForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签描述",
      "label-width": "120px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tagForm.description),
      callback: function($$v) {
        _vm.$set(_vm.tagForm, "description", $$v)
      },
      expression: "tagForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editTag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpdateTag
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加设备(设备入库)")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "equipmentForm",
    attrs: {
      "model": _vm.equipmentForm,
      "rules": _vm.addEquipmentRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备序列号",
      "label-width": "150px",
      "prop": "deviceId"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "deviceId", $$v)
      },
      expression: "equipmentForm.deviceId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "条形码编号",
      "label-width": "150px",
      "prop": "productIdentity"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.productIdentity),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "productIdentity", $$v)
      },
      expression: "equipmentForm.productIdentity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在仓库",
      "label-width": "150px",
      "prop": "storageId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库"
    },
    model: {
      value: (_vm.equipmentForm.storageId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "storageId", $$v)
      },
      expression: "equipmentForm.storageId"
    }
  }, _vm._l((_vm.storageArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.storageName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "添加字段",
      "label-width": "150px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addProperty($event)
      }
    }
  }, [_vm._v("增加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("key:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.key),
      callback: function($$v) {
        _vm.key = $$v
      },
      expression: "key"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("value:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1), _vm._v(" "), (_vm.property.length) ? _c('el-form-item', {
    attrs: {
      "label": "已加字段",
      "label-width": "150px"
    }
  }, _vm._l((_vm.property), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt10"
    }, [_vm._v("\n                " + _vm._s(++index) + "、" + _vm._s(item.name) + " - " + _vm._s(item.value) + "\n                "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeProperty(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.equipmentForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "remark", $$v)
      },
      expression: "equipmentForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Role === '1') ? _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('h3', [(_vm.isAlipay) ? _c('span', [_vm._v("支付宝小程序")]) : _vm._e(), _vm._v("租赁规则")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [(_vm.Role === '1') ? _c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Q",
      "label": "标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "A",
      "label": "内容"
    }
  }), _vm._v(" "), (_vm.Role === '1') ? _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑租赁规则",
      "visible": _vm.dialogEditVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Q", $$v)
      },
      expression: "editForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.A),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "A", $$v)
      },
      expression: "editForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogEditVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editRule
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建租赁规则",
      "visible": _vm.dialogNewVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogNewVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogNewVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNewOne
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1) : _c('h3', [_vm._v("\n    暂无权限\n")])
},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑专题")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "topicForm",
    attrs: {
      "model": _vm.topicForm,
      "rules": _vm.addTopicRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专题标题",
      "label-width": "150px",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.title),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "title", $$v)
      },
      expression: "topicForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题描述",
      "label-width": "150px",
      "prop": "caption"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.caption),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "caption", $$v)
      },
      expression: "topicForm.caption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传banner图",
      "label-width": "150px",
      "prop": "banner"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.topicForm.banner) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.topicForm.banner
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转类型选择",
      "label-width": "150px",
      "prop": "topicType"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.topicForm.topicType),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "topicType", $$v)
      },
      expression: "topicForm.topicType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("商品标签")])], 1)], 1), _vm._v(" "), (_vm.topicForm.topicType) ? _c('el-form-item', {
    attrs: {
      "label": "已选择",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.choosedNow),
      callback: function($$v) {
        _vm.choosedNow = $$v
      },
      expression: "choosedNow"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题下的商品选择",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.topicForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "shop", $$v)
      },
      expression: "topicForm.shop"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), (_vm.topicForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.topicForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.topicForm.product, "rental", $$v)
      },
      expression: "topicForm.product.rental"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.topicForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "商品原价(元)",
      "label-width": "150px",
      "prop": "oldRental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.topicForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.topicForm.product, "oldRental", $$v)
      },
      expression: "topicForm.product.oldRental"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专题二维码尺寸",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "show-file-list": false,
      "on-success": _vm.handlePicArrSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.topicUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.topicUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("添加该商品")])], 1), _vm._v(" "), (_vm.topicForm.productDetails.length) ? _c('el-form-item', {
    attrs: {
      "label": "已选择商品",
      "label-width": "150px"
    }
  }, [_c('el-row', _vm._l((_vm.topicForm.productDetails), function(o, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 8,
        "offset": index > 0 ? 2 : 0
      }
    }, [_c('el-card', {
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [(o.qrcode) ? _c('img', {
      staticClass: "image",
      attrs: {
        "src": o.qrcode
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "14px"
      }
    }, [_c('span', [_vm._v(_vm._s(o.name))]), _vm._v(" "), _c('div', {
      staticClass: "bottom clearfix"
    }, [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    }, [_vm._v("删除")])], 1)])])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择标签"
    },
    model: {
      value: (_vm.chooseTopic),
      callback: function($$v) {
        _vm.chooseTopic = $$v
      },
      expression: "chooseTopic"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_topic
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择标签",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "标签"
    },
    model: {
      value: (_vm.cur_topic.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_topic, "now", $$v)
      },
      expression: "cur_topic.now"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseTopic = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.topicChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择分类"
    },
    model: {
      value: (_vm.chooseCatogry),
      callback: function($$v) {
        _vm.chooseCatogry = $$v
      },
      expression: "chooseCatogry"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_categroy
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.cur_categroy.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_categroy, "now", $$v)
      },
      expression: "cur_categroy.now"
    }
  }, _vm._l((_vm.categoryArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseCatogry = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.catogryChoose
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("轮播banner管理")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList,
      "default-sort": {
        prop: 'type',
        prop: 'targetName'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "图片",
      "width": "180"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('img', {
            staticClass: "user-pic",
            attrs: {
              "src": _vm.row.picUrl
            }
          })
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "跳转类型",
      "width": "180",
      "prop": "type",
      "sortable": ""
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.type === 0) ? _c('span', [_vm._v("\n\t\t\t\t            分类\n\t\t\t\t          ")]) : (_vm.row.type === 1) ? _c('span', [_vm._v("\n\t\t\t\t            标签\n\t\t\t\t        ")]) : _c('span', [_vm._v("\n\t\t\t\t\t\t\t商品\n\t\t\t\t\t\t")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "targetName",
      "label": "名称",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("实名信息审核")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "model": _vm.userInfo,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userDetail.nickName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userDetail.username))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('div', [(_vm.userDetail.gender === '1') ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.userDetail.gender === '2') ? _c('span', [_vm._v("女")]) : _vm._e(), _vm._v(" "), (_vm.userDetail.gender === '0' || _vm.userDetail.gender === null) ? _c('span', [_vm._v("暂无")]) : _vm._e()])]), _vm._v(" "), (_vm.userInfo && _vm.userInfo.zmUpdated) ? _c('el-form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('span', [_vm._v(_vm._s(new Date(_vm.userInfo.zmUpdated).getFullYear() + '-' + (new Date(_vm.userInfo.zmUpdated).getMonth() + 1) + '-' + new Date(_vm.userInfo.zmUpdated).getDate() + ' ' + new Date(_vm.userInfo.zmUpdated).getHours() + ':' + new Date(_vm.userInfo.zmUpdated).getMinutes() + ':' + new Date(_vm.userInfo.zmUpdated).getSeconds()) + " ")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "真实姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.realName || '未填写'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.idCard))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "工作单位／学校"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.institution))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "现居住地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.address || '暂无'))])]), _vm._v(" "), (_vm.userInfo.pictures) ? _c('el-form-item', {
    attrs: {
      "label": "身份证照片"
    }
  }, [(_vm.userInfo.pictures[0].length < 4) ? _c('span', [_vm._v("暂未上传")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userInfo.pictures), function(item, index) {
    return (index != 3) ? _c('img', {
      key: index,
      staticStyle: {
        "margin-right": "15px",
        "width": "200px"
      },
      attrs: {
        "src": item,
        "alt": ""
      }
    }) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.userInfo.pictures && _vm.userInfo.pictures[3].length) ? _c('el-form-item', {
    attrs: {
      "label": "学生证照片"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "15px",
      "width": "300px"
    },
    attrs: {
      "src": _vm.userInfo.pictures[3],
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleNo
    }
  }, [_vm._v("审核不通过")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("审核通过，请输入免押金额度（单位：分）")]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.line),
      callback: function($$v) {
        _vm.line = $$v
      },
      expression: "line"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureEnter
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.passVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.passVisible = $event
      }
    }
  }, [_c('span', [_vm._v("审核不通过，请输入原因")]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.passVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePass
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Role === '1') ? _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.isAlipay) ? _c('h3', [_vm._v("支付宝小程序帮助中心")]) : _vm._e(), _vm._v(" "), (!_vm.isAlipay) ? _c('h3', [_vm._v("帮助中心")]) : _vm._e()])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.titles[0]))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCommon
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.comonQ), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_c('p', [_vm._v("\n                    标题：" + _vm._s(o.Q) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    内容：" + _vm._s(o.A) + "\n                ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.commonDelete(i)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.commonEdit(i)
        }
      }
    }, [_vm._v("编辑")])], 1)
  })], 2), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.titles[1]))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPay
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.payQ), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_c('p', [_vm._v("\n                    标题：" + _vm._s(o.Q) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    内容：" + _vm._s(o.A) + "\n                ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.payDelete(i)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.payEdit(i)
        }
      }
    }, [_vm._v("编辑")])], 1)
  })], 2), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.titles[2]))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDinner
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.dinnerQ), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_c('p', [_vm._v("\n                    标题：" + _vm._s(o.Q) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    内容：" + _vm._s(o.A) + "\n                ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.orderDelete(i)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.orderEdit(i)
        }
      }
    }, [_vm._v("编辑")])], 1)
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '新增' + _vm.titles[0],
      "visible": _vm.dialogCommon,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCommon = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCommon = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCommonOne
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '编辑' + _vm.titles[1],
      "visible": _vm.dialogCommonEdit,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCommonEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCommonEdit = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCommonOne
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '编辑' + _vm.titles[2],
      "visible": _vm.dialogPayEdit,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPayEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogPayEdit = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editPayOne
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑订单问题",
      "visible": _vm.dialogDinnerEdit,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDinnerEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogDinnerEdit = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editDinnerOne
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增订单问题",
      "visible": _vm.dialogDinner,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDinner = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCommon = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDinnerOne
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增支付问题",
      "visible": _vm.dialogPay,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPay = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCommon = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPayOne
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadHelp
    }
  }, [_vm._v("提交")])], 1)]) : _c('h3', [_vm._v("\n    暂无权限\n")])
},staticRenderFns: []}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("设备列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加设备")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("返回")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceId",
      "label": "机器序列号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productIdentity",
      "label": "条形码编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageName",
      "label": "所在仓库"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.isOnline) ? _c('span', [_vm._v("上架")]) : _c('span', [_vm._v("下架")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOrder(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看租赁历史")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (!_vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOnline(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (_vm.Role === '1' && _vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOff(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("下架")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "租赁历史",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上一个租赁客户ID",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderUserId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上一个租赁客户姓名",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderUsername))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上一次租赁订单号",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(new Date(_vm.form.created).getFullYear() + '-' + (new Date(_vm.form.created).getMonth() + 1) + '-' + new Date(_vm.form.created).getDate() + ' ' + new Date(_vm.form.created).getHours() + ':' + new Date(_vm.form.created).getMinutes() + ':' + new Date(_vm.form.created).getSeconds()) + " ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁次数",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.orderCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁天数",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.dayCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁资金",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.rentalSum))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("新增首页分类")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "categoryForm",
    attrs: {
      "model": _vm.categoryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择要显示的分类",
      "label-width": "150px",
      "prop": "catogrey"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    on: {
      "change": _vm.catogreyChoose
    },
    model: {
      value: (_vm.categoryForm.catogrey),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "catogrey", $$v)
      },
      expression: "categoryForm.catogrey"
    }
  }, _vm._l((_vm.catogreyArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("意见反馈列表")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.formInline.phone),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "phone", $$v)
      },
      expression: "formInline.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中",
      "default-sort": {
        prop: 'status'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userManage.nickName",
      "label": "用户昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "反馈类型"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.type === 0) ? _c('span', [_vm._v("产品建议")]) : _vm._e(), _vm._v(" "), (_vm.row.type === 1) ? _c('span', [_vm._v("程序错误")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "提交时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "状态",
      "sortable": "",
      "prop": "status"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 0 || _vm.row.status === null) ? _c('span', [_vm._v("未处理")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("已处理")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(_vm.row.status === 0 || _vm.row.status === null) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleCheck(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("标记已反馈")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            }
          }, [_vm._v("已反馈")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看反馈详情",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "150px"
    }
  }, [(_vm.form.userManage) ? _c('span', [_vm._v(_vm._s(_vm.form.userManage.nickName))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "反馈类型：",
      "label-width": "150px"
    }
  }, [(_vm.form.type === 0) ? _c('span', [_vm._v("产品建议")]) : _vm._e(), _vm._v(" "), (_vm.form.type === 1) ? _c('span', [_vm._v("程序错误")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式：",
      "label-width": "150px"
    }
  }, [(_vm.form.userManage) ? _c('span', [_vm._v(_vm._s(_vm.form.userManage.username))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "反馈内容：",
      "label-width": "150px"
    }
  }, [(_vm.form.content) ? _c('span', [_vm._v(_vm._s(_vm.form.content))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("关于我们")])])], 1), _vm._v(" "), _c('el-form', {
    ref: "aboutForm",
    attrs: {
      "model": _vm.aboutForm,
      "rules": _vm.bannerFormFules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "关于我们LOGO图",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imgUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imgUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前版本号",
      "label-width": "150px",
      "prop": "description"
    }
  }, [(_vm.aboutForm.value) ? _c('el-input', {
    model: {
      value: (_vm.aboutForm.value.version),
      callback: function($$v) {
        _vm.$set(_vm.aboutForm.value, "version", $$v)
      },
      expression: "aboutForm.value.version"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("选配列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAddNew
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productDetailId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "选配名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "结算方式"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.accessoryType == 1) ? _c('span', [_vm._v("按次")]) : _vm._e(), _vm._v(" "), (_vm.row.accessoryType == 2) ? _c('span', [_vm._v("按天")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rental",
      "label": "价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deposit",
      "label": "押金"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productCount",
      "label": "设备数量",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.isOnline) ? _c('span', [_vm._v("上架")]) : _c('span', [_vm._v("下架")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "创建时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (!_vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOnline(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (_vm.Role === '1' && _vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOff(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleAdd(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("添加")])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          staticClass: "demo-table-expand",
          attrs: {
            "data": props.row.deviceArr,
            "inline": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "productIdentity",
            "label": "选配编码"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "storageArr.storageName",
            "label": "所在仓库"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "context": _vm._self,
            "label": "状态"
          },
          inlineTemplate: {
            render: function() {
              var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
                return _c('div', [(_vm.row.isOnline) ? _c('span', [_vm._v("上架")]) : _c('span', [_vm._v("下架")])])
              
            },
            staticRenderFns: []
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "context": _vm._self,
            "width": "200",
            "label": "操作"
          },
          inlineTemplate: {
            render: function() {
              var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
                return _c('span', [_c('el-button', {
                  attrs: {
                    "type": "text",
                    "size": "small"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.handleView(_vm.$index, _vm.row.rentHistory)
                    }
                  }
                }, [_vm._v("查看租赁历史")]), _vm._v(" "), _c('el-button', {
                  attrs: {
                    "type": "text",
                    "size": "small"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.editDevice(_vm.$index, props.row.deviceArr)
                    }
                  }
                }, [_vm._v("编辑")]), _vm._v(" "), (!_vm.row.isOnline) ? _c('el-button', {
                  attrs: {
                    "type": "text",
                    "size": "small"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.handleOnlined(_vm.$index, props.row.deviceArr, props.row)
                    }
                  }
                }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (_vm.Role === '1' && _vm.row.isOnline) ? _c('el-button', {
                  attrs: {
                    "type": "text",
                    "size": "small"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.handleOffd(_vm.$index, props.row.deviceArr, props.row)
                    }
                  }
                }, [_vm._v("下架")]) : _vm._e()], 1)
              
            },
            staticRenderFns: []
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "租赁历史",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上一个租赁客户ID",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderUserId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上一个租赁客户姓名",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderUsername))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上一次租赁订单号",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间",
      "label-width": "150px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁次数",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.orderCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁天数",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.dayCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁资金",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.rentalSum))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("新增甄选享玩设置")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "shopForm",
    attrs: {
      "model": _vm.shopForm,
      "rules": _vm.addShopRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "享玩甄选描述",
      "label-width": "150px",
      "prop": "description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.name),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "name", $$v)
      },
      expression: "shopForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品选择",
      "label-width": "150px",
      "prop": "shop"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.shopForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "shop", $$v)
      },
      expression: "shopForm.shop"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.shopForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "rental", $$v)
      },
      expression: "shopForm.product.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原租金(元)",
      "label-width": "150px",
      "prop": "oldRental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "oldRental", $$v)
      },
      expression: "shopForm.product.oldRental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("账号列表")])]), _vm._v(" "), (_vm.Role === '1') ? _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "账号ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "用户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickName",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phoneNumber",
      "label": "电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "角色"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('span', [_vm._v(_vm._s(_vm.row.power === 0 ? '普通' : '高级'))])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creatorId",
      "label": "创建人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "创建时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), (_vm.Role === '1') ? _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEditPsd(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加账号"
    },
    model: {
      value: (_vm.addTag),
      callback: function($$v) {
        _vm.addTag = $$v
      },
      expression: "addTag"
    }
  }, [_c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userForm,
      "rules": _vm.addTagRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "label-width": "120px",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.username),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "username", $$v)
      },
      expression: "userForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "label-width": "120px",
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "nickName", $$v)
      },
      expression: "userForm.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "120px",
      "prop": "phoneNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "phoneNumber", $$v)
      },
      expression: "userForm.phoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "label-width": "120px",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.password),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "password", $$v)
      },
      expression: "userForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "power"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.userForm.power),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "power", $$v)
      },
      expression: "userForm.power"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "管理员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "运营",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleNewTag
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialogPsdVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPsdVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.psdForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.psdForm.psd),
      callback: function($$v) {
        _vm.$set(_vm.psdForm, "psd", $$v)
      },
      expression: "psdForm.psd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogPsdVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitNewPsd
    }
  }, [_vm._v("确定修改")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑账号"
    },
    model: {
      value: (_vm.editTag),
      callback: function($$v) {
        _vm.editTag = $$v
      },
      expression: "editTag"
    }
  }, [_c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userForm,
      "rules": _vm.addTagRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "label-width": "120px",
      "prop": "username"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userForm.username))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "label-width": "120px",
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "nickName", $$v)
      },
      expression: "userForm.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "120px",
      "prop": "phoneNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "phoneNumber", $$v)
      },
      expression: "userForm.phoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.userForm.power),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "power", $$v)
      },
      expression: "userForm.power"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "管理员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "运营",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editTag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handlePostTag
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑商品")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "productForm",
    attrs: {
      "label-width": "150px",
      "model": _vm.productForm,
      "rules": _vm.addProductRules
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("商品分类：")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择商品分类",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.productForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "categoryId", $$v)
      },
      expression: "productForm.categoryId"
    }
  }, _vm._l((_vm.catogreyArr), function(item) {
    return _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品标签"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "标签"
    },
    model: {
      value: (_vm.topic),
      callback: function($$v) {
        _vm.topic = $$v
      },
      expression: "topic"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("基本信息：")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名"
    },
    model: {
      value: (_vm.productForm.name),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "name", $$v)
      },
      expression: "productForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品描述"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品描述"
    },
    model: {
      value: (_vm.productForm.description),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "description", $$v)
      },
      expression: "productForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品押金",
      "prop": "deposit"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品押金"
    },
    model: {
      value: (_vm.productForm.deposit),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "deposit", $$v)
      },
      expression: "productForm.deposit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起租的每日租金",
      "prop": "rental"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "起租的每日租金"
    },
    model: {
      value: (_vm.productForm.rental),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "rental", $$v)
      },
      expression: "productForm.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原租金价格"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原租金价格"
    },
    model: {
      value: (_vm.productForm.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "oldRental", $$v)
      },
      expression: "productForm.oldRental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起租天数设置",
      "prop": "minimumDay"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "起租天数设置"
    },
    model: {
      value: (_vm.productForm.minimumDay),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "minimumDay", $$v)
      },
      expression: "productForm.minimumDay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "后续价格",
      "prop": "rentalMore"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "后续价格"
    },
    model: {
      value: (_vm.productForm.rentalMore),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "rentalMore", $$v)
      },
      expression: "productForm.rentalMore"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传商品橱窗图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://upload.qiniup.com/",
      "file-list": _vm.fileListPic,
      "on-error": _vm.handleError,
      "list-type": "picture-card",
      "on-preview": _vm.handlePicCardPreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handlePicSuccess,
      "before-upload": _vm.beforePicUpload,
      "data": _vm.uptoken
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频链接(选填)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "视频链接"
    },
    model: {
      value: (_vm.productForm.media.video),
      callback: function($$v) {
        _vm.$set(_vm.productForm.media, "video", $$v)
      },
      expression: "productForm.media.video"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传视频封面图(选填)"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-error": _vm.handleError,
      "on-remove": _vm.handleVideoRemove,
      "on-success": _vm.handleVideoSuccess,
      "before-upload": _vm.beforeDetailUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.productForm.media.videoThumb) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.productForm.media.videoThumb
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品清单"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称"
    },
    model: {
      value: (_vm.list.name),
      callback: function($$v) {
        _vm.$set(_vm.list, "name", $$v)
      },
      expression: "list.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    staticStyle: {
      "text-align": "center",
      "border": "0"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数量"
    },
    model: {
      value: (_vm.list.count),
      callback: function($$v) {
        _vm.$set(_vm.list, "count", $$v)
      },
      expression: "list.count"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addList
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), (_vm.productForm.inventory.length) ? _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, _vm._l((_vm.productForm.inventory), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v(_vm._s(++index) + "、" + _vm._s(item[0]) + "*" + _vm._s(item[1]) + " "), _c('el-button', {
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeThis(index)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否提供PlayCare保险服务"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.insurance),
      callback: function($$v) {
        _vm.insurance = $$v
      },
      expression: "insurance"
    }
  }, [_vm._v("提供")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.insurance),
      callback: function($$v) {
        _vm.insurance = $$v
      },
      expression: "insurance"
    }
  }, [_vm._v("不提供")]), _vm._v(" "), (_vm.insurance === '1') ? _c('el-input', {
    staticStyle: {
      "margin-left": "20px",
      "width": "200px"
    },
    attrs: {
      "placeholder": "如果提供请输入价格(单位：分)"
    },
    model: {
      value: (_vm.productForm.insurance),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "insurance", $$v)
      },
      expression: "productForm.insurance"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传商品详情图"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://upload.qiniup.com/",
      "file-list": _vm.fileListDetail,
      "on-error": _vm.handleError,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleDetailRemove,
      "on-success": _vm.handleDetailSuccess,
      "before-upload": _vm.beforeDetailUpload,
      "data": _vm.uptoken
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配设置"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "商品"
    },
    model: {
      value: (_vm.value10),
      callback: function($$v) {
        _vm.value10 = $$v
      },
      expression: "value10"
    }
  }, _vm._l((_vm.xuanpeiArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "租赁设备类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "600px"
    },
    model: {
      value: (_vm.productForm.zmRentType),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "zmRentType", $$v)
      },
      expression: "productForm.zmRentType"
    }
  }, _vm._l((_vm.zmRentTypeMap), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("享玩甄选设置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.zhenxuan),
      callback: function($$v) {
        _vm.zhenxuan = $$v
      },
      expression: "zhenxuan"
    }
  }, [_vm._v("默认为首页的享玩甄选")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.zhenxuan),
      callback: function($$v) {
        _vm.zhenxuan = $$v
      },
      expression: "zhenxuan"
    }
  }, [_vm._v("重新设置")])], 1), _vm._v(" "), (_vm.zhenxuan != '1') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "享玩甄选描述",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.name),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "name", $$v)
      },
      expression: "shopForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品选择",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.shopForm.productDetailId),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "productDetailId", $$v)
      },
      expression: "shopForm.productDetailId"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), (_vm.shopForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.shopForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "rental", $$v)
      },
      expression: "shopForm.product.rental"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shopForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "原租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "oldRental", $$v)
      },
      expression: "shopForm.product.oldRental"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addShop
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "50px",
      "overflow": "hidden"
    },
    attrs: {
      "label": "",
      "label-width": "150px"
    }
  }, _vm._l((_vm.productForm.pushProductDetails), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('el-card', {
      staticClass: "box-card",
      staticStyle: {
        "width": "260px",
        "margin-right": "20px",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "line-height": "36px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeCard(index)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('div', {
      staticClass: "text item"
    }, [_c('p', [_vm._v("当前租金：" + _vm._s(item.rental))]), _vm._v(" "), _c('p', [_vm._v("原来租金：" + _vm._s(item.oldRental))])])])], 1)
  }), 0)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("更新")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUser
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180",
      "sortable": ""
    }
  })], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("退款订单列表")])])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "退款编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userManage.nickName",
      "label": "用户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "支付方式"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.isAlipayMini) ? _c('span', [_vm._v("支付宝")]) : _c('span', [_vm._v("微信支付")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "退款金额"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s((_vm.row.dispalyExtra.paidData && _vm.row.dispalyExtra.paidData.rental) || (_vm.row.dispalyExtra.unpaidRentOrder && _vm.row.dispalyExtra.unpaidRentOrder.rental)))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "申请时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cancelReason",
      "label": "退款原因"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "退款状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 0) ? _c('span', [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("交易关闭")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 3) ? _c('span', [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 4) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 5) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 6) ? _c('span', [_vm._v("待返还确认")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 7) ? _c('span', [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 8) ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 9) ? _c('span', [_vm._v("已退款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 98) ? _c('span', [_vm._v("已预约顺丰")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 99) ? _c('span', [_vm._v("完成中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 100) ? _c('span', [_vm._v("已删除")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.isAlipayMini && _vm.row.status === 8) ? _c('el-button', {
            attrs: {
              "type": "primary",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.agreeRefund(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("同意")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("首页商品分类设置")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "分类名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "分类图片",
      "width": "180"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('img', {
            staticClass: "user-pic",
            attrs: {
              "src": _vm.row.picUrl
            }
          })
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加轮播banner")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.bannerForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传banner图",
      "label-width": "100px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转类型选择",
      "label-width": "100px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.bannerForm.type),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "type", $$v)
      },
      expression: "bannerForm.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "商品类型"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "商品"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "商品标签"
    }
  })], 1)], 1), _vm._v(" "), (_vm.bannerForm.type === '商品类型') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品类型",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.type === '商品') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.type === '商品标签') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品标签",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择分类"
    },
    model: {
      value: (_vm.chooseCatogry),
      callback: function($$v) {
        _vm.chooseCatogry = $$v
      },
      expression: "chooseCatogry"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_categroy
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.cur_categroy.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_categroy, "now", $$v)
      },
      expression: "cur_categroy.now"
    }
  }, _vm._l((_vm.categoryArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseCatogry = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.catogryChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择标签"
    },
    model: {
      value: (_vm.chooseTopic),
      callback: function($$v) {
        _vm.chooseTopic = $$v
      },
      expression: "chooseTopic"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_topic
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择标签",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "标签"
    },
    model: {
      value: (_vm.cur_topic.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_topic, "now", $$v)
      },
      expression: "cur_topic.now"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseTopic = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.topicChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择商品"
    },
    model: {
      value: (_vm.chooseProduct),
      callback: function($$v) {
        _vm.chooseProduct = $$v
      },
      expression: "chooseProduct"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_product
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择商品",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    model: {
      value: (_vm.cur_product.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_product, "now", $$v)
      },
      expression: "cur_product.now"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseProduct = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.productChoose
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑选配")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "optionalForm",
    attrs: {
      "label-width": "150px",
      "model": _vm.optionalForm,
      "rules": _vm.addOptionalRules
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("选配基本信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配名称",
      "label-width": "150px",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.name),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "name", $$v)
      },
      expression: "optionalForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "accessoryType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.optionalForm.accessoryType),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "accessoryType", $$v)
      },
      expression: "optionalForm.accessoryType"
    }
  }, [_vm._v("按天算")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.optionalForm.accessoryType),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "accessoryType", $$v)
      },
      expression: "optionalForm.accessoryType"
    }
  }, [_vm._v("按次算")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格",
      "label-width": "150px",
      "prop": "rental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.rental),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "rental", $$v)
      },
      expression: "optionalForm.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配押金",
      "label-width": "150px",
      "prop": "deposit"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.deposit),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "deposit", $$v)
      },
      expression: "optionalForm.deposit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "label-width": "150px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.optionalForm.description),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "description", $$v)
      },
      expression: "optionalForm.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("更新")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("用户列表")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "昵称"
    },
    model: {
      value: (_vm.formInline.nickName),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "nickName", $$v)
      },
      expression: "formInline.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.formInline.username),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "username", $$v)
      },
      expression: "formInline.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册时间",
      "prop": "dayStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptionsStart
    },
    on: {
      "change": _vm.startChange
    },
    model: {
      value: (_vm.formInline.dayStart),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dayStart", $$v)
      },
      expression: "formInline.dayStart"
    }
  }), _vm._v("\n            -\n            "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptionsEnd
    },
    on: {
      "change": _vm.endChange
    },
    model: {
      value: (_vm.formInline.dayEnd),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dayEnd", $$v)
      },
      expression: "formInline.dayEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickName",
      "label": "昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "性别"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.gender === '1') ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.row.gender === '2') ? _c('span', [_vm._v("女")]) : _vm._e(), _vm._v(" "), (_vm.row.gender === '0' || _vm.row.gender === null) ? _c('span', [_vm._v("暂无")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zmPhone",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "是否实名"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.isIdentified) ? _c('span', [_vm._v("实名")]) : _c('span', [_vm._v("未实名")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "芝麻信用分值"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v("\n                    " + _vm._s(_vm.row.zmScore || '暂无') + "\n                ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "是否绑定微信"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.wxid) ? _c('span', [_vm._v("已绑定")]) : _c('span', [_vm._v("未绑定")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "客户端类型"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('span', [_vm._v(_vm._s(_vm.clientTypeMap[_vm.row.clientType]))])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "上次登录时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.lastLogin) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.lastLogin).getFullYear() + '-' + (new Date(_vm.row.lastLogin).getMonth() + 1) + '-' + new Date(_vm.row.lastLogin).getDate() + ' ' + new Date(_vm.row.lastLogin).getHours() + ':' + new Date(_vm.row.lastLogin).getMinutes() + ':' + new Date(_vm.row.lastLogin).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "注册时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.Role === '1' && !_vm.row.isForbidden) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleStop(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("禁用")]) : _vm._e(), _vm._v(" "), (_vm.Role === '1' && _vm.row.isForbidden) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleCancel(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("取消禁用")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("享玩SharePlay后台管理系统")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("用户信息")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple",
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "width": "80px",
      "height": "80px",
      "src": _vm.userInfo.avatarUrl,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('p', [_vm._v("微信ID：" + _vm._s(_vm.userInfo.wxid))]), _vm._v(" "), _c('p', [_vm._v("昵称：" + _vm._s(_vm.userInfo.nickName))]), _vm._v(" "), _c('p', [_vm._v("是否绑定微信：" + _vm._s(_vm.userInfo.wxid ? '已绑定' : '未绑定'))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('p', [_vm._v("手机号：" + _vm._s(_vm.userInfo.username))]), _vm._v(" "), _c('p', [_vm._v("注册时间：" + _vm._s(new Date(_vm.userInfo.created).getFullYear() + '-' + (new Date(_vm.userInfo.created).getMonth() + 1) + '-' + new Date(_vm.userInfo.created).getDate() + ' ' + new Date(_vm.userInfo.created).getHours() + ':' + new Date(_vm.userInfo.created).getMinutes() + ':' + new Date(_vm.userInfo.created).getSeconds()))]), _vm._v(" "), _c('p', [_vm._v("是否实名：" + _vm._s(_vm.userInfo.isIdentified ? '已实名' : '未实名'))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('p', [_vm._v("性别：\n                    "), (_vm.userInfo.gender === '1') ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.gender === '2') ? _c('span', [_vm._v("女")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.gender === '0' || _vm.userInfo.gender === null) ? _c('span', [_vm._v("暂无")]) : _vm._e()]), _vm._v(" "), (_vm.Role === '1') ? _c('p', [_vm._v("密码：\n                    "), _c('el-button', {
    on: {
      "click": _vm.changePsd
    }
  }, [_vm._v("修改")])], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("客户端来源：\n                    "), _c('span', [_vm._v(_vm._s(_vm.clientTypeMap[_vm.userInfo.clientType]))])])])])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.userInfo
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "真实姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.otherInfo.zmName || _vm.otherInfo.realName || '无'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.otherInfo.zmIdCard || _vm.otherInfo.idCard || '无'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "工作单位／学校"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.otherInfo.institution || '无'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "现居住地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.otherInfo.address || '无'))])])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "已通过审核实名信息"
    }
  }, [_c('div', [_vm._l((_vm.otherInfo.pictures), function(item, index) {
    return (index != 3 && _vm.userInfo.isIdentified) ? _c('img', {
      key: index,
      staticStyle: {
        "margin-right": "15px",
        "width": "200px"
      },
      attrs: {
        "src": item,
        "alt": ""
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.userInfo.isIdentified) ? _c('span', [_vm._v("暂无")]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.userInfo
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "芝麻信用分值"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.zmScore || 0))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "已获得免押金额度（单位：元）"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.totalLine || 0))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "当前剩余免押金额度（单位：元）"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.totalRemain || 0))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "芝麻信用获取的免押金额度（单位：元）"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.zmLine || 0))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "实名认证获取的免押金额度（单位：元）"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.identifiedLine || 0))])])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生证照片"
    }
  }, [(_vm.otherInfo.pictures && _vm.otherInfo.pictures[3].length) ? _c('img', {
    staticStyle: {
      "margin-right": "15px",
      "width": "300px"
    },
    attrs: {
      "src": _vm.otherInfo.pictures[3],
      "alt": ""
    }
  }) : _c('span', [_vm._v("暂无")])])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleOrder
    }
  }, [_vm._v("查看用户订单")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.psdForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.psdForm.psd),
      callback: function($$v) {
        _vm.$set(_vm.psdForm, "psd", $$v)
      },
      expression: "psdForm.psd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitNew
    }
  }, [_vm._v("确定修改")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户订单",
      "visible": _vm.dialogOrderVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogOrderVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.orderData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "orderNo",
      "label": "订单编号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "商品名",
      "width": "200"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row && _vm.row.dispalyExtra) ? _c('div', _vm._l((_vm.row.dispalyExtra.mainItems), function(item) {
            return _c('p', [_vm._v(_vm._s(item.name))])
          }), 0) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "receiverName",
      "label": "收货人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "receiverTel",
      "label": "收货人电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "address",
      "label": "收货地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "counts",
      "label": "商品数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "订单状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 0) ? _c('span', [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("交易关闭")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 3) ? _c('span', [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 4) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 5) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 6) ? _c('span', [_vm._v("待返还确认")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 7) ? _c('span', [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 8) ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 9) ? _c('span', [_vm._v("已退款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 100) ? _c('span', [_vm._v("已删除")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("网站banner设置")])])], 1), _vm._v(" "), _c('el-form', {
    ref: "bannerForm",
    attrs: {
      "model": _vm.bannerForm,
      "rules": _vm.bannerFormFules
    }
  }, [(_vm.bannerForm.value) ? _c('el-form-item', {
    attrs: {
      "label": "标题：",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "label-width": "150px",
      "prop": "description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bannerForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "remark", $$v)
      },
      expression: "bannerForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型选择",
      "label-width": "150px",
      "prop": "shop"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.bannerForm.value && _vm.type === 'video') ? _c('el-form-item', {
    attrs: {
      "label": "视频链接",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.videoUrl),
      callback: function($$v) {
        _vm.videoUrl = $$v
      },
      expression: "videoUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.value && _vm.type === 'video') ? _c('el-form-item', {
    attrs: {
      "label": "视频封面",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imgUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imgUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'pic') ? _c('el-form-item', {
    attrs: {
      "label": "封面图：",
      "label-width": "150px"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://upload.qiniup.com/",
      "file-list": _vm.fileListDetail,
      "on-error": _vm.handleError,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleDetailRemove,
      "on-success": _vm.handleDetailSuccess,
      "before-upload": _vm.beforeDetailUpload,
      "data": _vm.uptoken
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加选配")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "optionalForm",
    attrs: {
      "label-width": "150px",
      "model": _vm.optionalForm,
      "rules": _vm.addOptionalRules
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("选配基本信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配名称",
      "label-width": "150px",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.name),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "name", $$v)
      },
      expression: "optionalForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "accessoryType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.optionalForm.accessoryType),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "accessoryType", $$v)
      },
      expression: "optionalForm.accessoryType"
    }
  }, [_vm._v("按次算")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.optionalForm.accessoryType),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "accessoryType", $$v)
      },
      expression: "optionalForm.accessoryType"
    }
  }, [_vm._v("按天算")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格(单位：分)",
      "label-width": "150px",
      "prop": "rental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.rental),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "rental", $$v)
      },
      expression: "optionalForm.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配押金(单位：分)",
      "label-width": "150px",
      "prop": "deposit"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.deposit),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "deposit", $$v)
      },
      expression: "optionalForm.deposit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "label-width": "150px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.optionalForm.description),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "description", $$v)
      },
      expression: "optionalForm.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("评论列表")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号",
      "prop": "orderNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "订单号"
    },
    model: {
      value: (_vm.formInline.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "orderNo", $$v)
      },
      expression: "formInline.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.formInline.username),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "username", $$v)
      },
      expression: "formInline.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中",
      "default-sort": {
        prop: 'status'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderInfo.orderNo",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userManage.nickName",
      "label": "用户昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userInfo.username",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productObj.name",
      "label": "设备名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "评价内容"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "评价时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "状态",
      "sortable": "",
      "prop": "status"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 1) ? _c('span', [_vm._v("审核通过")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("审核不通过")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 0 || _vm.row.status === null) ? _c('span', [_vm._v("待审核")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(_vm.row.status === 0 || _vm.row.status === null) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleCheck(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看评论详情",
      "visible": _vm.dialogFormVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号：",
      "label-width": "150px"
    }
  }, [(_vm.form.orderInfo) ? _c('span', [_vm._v(_vm._s(_vm.form.orderInfo.orderNo))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "150px"
    }
  }, [(_vm.form.userManage) ? _c('span', [_vm._v(_vm._s(_vm.form.userManage.nickName))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "150px"
    }
  }, [(_vm.form.userInfo) ? _c('span', [_vm._v(_vm._s(_vm.form.userInfo.username))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称：",
      "label-width": "150px"
    }
  }, [(_vm.form.productObj) ? _c('span', [_vm._v(_vm._s(_vm.form.productObj.name))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价时间：",
      "label-width": "150px"
    }
  }, [(_vm.form.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.form.created).getFullYear() + '-' + (new Date(_vm.form.created).getMonth() + 1) + '-' + new Date(_vm.form.created).getDate() + ' ' + new Date(_vm.form.created).getHours() + ':' + new Date(_vm.form.created).getMinutes() + ':' + new Date(_vm.form.created).getSeconds()) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价内容：",
      "label-width": "150px"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.form.content))]), _vm._v(" "), (_vm.form.photo && _vm.form.photo.length) ? _c('div', {
    staticClass: "img-item"
  }, _vm._l((_vm.form.photo), function(item) {
    return _c('img', {
      key: item,
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), 0) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价分数：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.grade) + " "), _c('small', [_vm._v("（最高5分，最低1分）")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核评论详情",
      "visible": _vm.dialogCheckVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCheckVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号：",
      "label-width": "150px"
    }
  }, [(_vm.form.orderInfo) ? _c('span', [_vm._v(_vm._s(_vm.form.orderInfo.orderNo))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "150px"
    }
  }, [(_vm.form.userManage) ? _c('span', [_vm._v(_vm._s(_vm.form.userManage.nickName))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "150px"
    }
  }, [(_vm.form.userInfo) ? _c('span', [_vm._v(_vm._s(_vm.form.userInfo.username))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称：",
      "label-width": "150px"
    }
  }, [(_vm.form.productObj) ? _c('span', [_vm._v(_vm._s(_vm.form.productObj.name))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价时间：",
      "label-width": "150px"
    }
  }, [(_vm.form.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.form.created).getFullYear() + '-' + (new Date(_vm.form.created).getMonth() + 1) + '-' + new Date(_vm.form.created).getDate() + ' ' + new Date(_vm.form.created).getHours() + ':' + new Date(_vm.form.created).getMinutes() + ':' + new Date(_vm.form.created).getSeconds()) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价内容：",
      "label-width": "150px"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.form.content))]), _vm._v(" "), (_vm.form.photo && _vm.form.photo.length) ? _c('div', {
    staticClass: "img-item"
  }, _vm._l((_vm.form.photo), function(item) {
    return _c('img', {
      key: item,
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), 0) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价分数：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.grade) + " "), _c('small', [_vm._v("（最高5分，最低1分）")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handlePass
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.handleNo
    }
  }, [_vm._v("审核不通过")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Role === '1') ? _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("芝麻信用免押金设置")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建版本")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleUser
    }
  }, [_vm._v("更新特定用户")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "版本名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "context": _vm._self
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(_vm.row.created.split('T')[0] + ' ' + _vm.row.created.split('T')[1].split('.')[0]))]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(_vm.row.version !== _vm.global) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleLive(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("激活")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.global && _vm.global.length && _vm.row.version !== _vm.global[0].SettingValue) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建芝麻信用版本"
    },
    model: {
      value: (_vm.addVersion),
      callback: function($$v) {
        _vm.addVersion = $$v
      },
      expression: "addVersion"
    }
  }, [_c('el-form', {
    ref: "versionForm",
    attrs: {
      "model": _vm.versionForm,
      "rules": _vm.addVersionRules,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本名称",
      "label-width": "200px",
      "prop": "version"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.version),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "version", $$v)
      },
      expression: "versionForm.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "650-700分(单位：分)",
      "label-width": "200px",
      "prop": "one"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.one),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "one", $$v)
      },
      expression: "versionForm.one"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "701-750分(单位：分)",
      "label-width": "200px",
      "prop": "two"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.two),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "two", $$v)
      },
      expression: "versionForm.two"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "751-800分(单位：分)",
      "label-width": "200px",
      "prop": "three"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.three),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "three", $$v)
      },
      expression: "versionForm.three"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "801-850分(单位：分)",
      "label-width": "200px",
      "prop": "four"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.versionForm.four),
      callback: function($$v) {
        _vm.$set(_vm.versionForm, "four", $$v)
      },
      expression: "versionForm.four"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('versionForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新特定用户",
      "visible": _vm.dialogSearch
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSearch = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.searchForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户手机号",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.searchForm.username),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "username", $$v)
      },
      expression: "searchForm.username"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogSearch = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searhSure
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑芝麻信用版本"
    },
    model: {
      value: (_vm.editVersion),
      callback: function($$v) {
        _vm.editVersion = $$v
      },
      expression: "editVersion"
    }
  }, [_c('el-form', {
    ref: "editVersionForm",
    attrs: {
      "model": _vm.editVersionForm,
      "rules": _vm.addVersionRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本名称",
      "label-width": "200px",
      "prop": "version"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editVersionForm.version),
      callback: function($$v) {
        _vm.$set(_vm.editVersionForm, "version", $$v)
      },
      expression: "editVersionForm.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "650-700分(单位：分)",
      "label-width": "200px",
      "prop": "one"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editVersionForm.one),
      callback: function($$v) {
        _vm.$set(_vm.editVersionForm, "one", $$v)
      },
      expression: "editVersionForm.one"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "701-750分(单位：分)",
      "label-width": "200px",
      "prop": "two"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editVersionForm.two),
      callback: function($$v) {
        _vm.$set(_vm.editVersionForm, "two", $$v)
      },
      expression: "editVersionForm.two"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "751-800分(单位：分)",
      "label-width": "200px",
      "prop": "three"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editVersionForm.three),
      callback: function($$v) {
        _vm.$set(_vm.editVersionForm, "three", $$v)
      },
      expression: "editVersionForm.three"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "801-850分(单位：分)",
      "label-width": "200px",
      "prop": "four"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editVersionForm.four),
      callback: function($$v) {
        _vm.$set(_vm.editVersionForm, "four", $$v)
      },
      expression: "editVersionForm.four"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit('editVersionForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1) : _c('h3', [_vm._v("\n    暂无权限\n")])
},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑甄选享玩设置")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "shopForm",
    attrs: {
      "model": _vm.shopForm,
      "rules": _vm.addShopRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "享玩甄选描述",
      "label-width": "150px",
      "prop": "description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.name),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "name", $$v)
      },
      expression: "shopForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品选择",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.shopForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "shop", $$v)
      },
      expression: "shopForm.shop"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.shopForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "rental", $$v)
      },
      expression: "shopForm.product.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原租金(元)",
      "label-width": "150px",
      "prop": "oldRental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "oldRental", $$v)
      },
      expression: "shopForm.product.oldRental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("入库")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productCount",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleChoose(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("入库")])
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "model": _vm.form
    }
  }, [(!_vm.row.isAlipayMini) ? _c('el-form-item', {
    attrs: {
      "label": "退款押金数值(单位：分)",
      "label-width": "200px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.backCount),
      callback: function($$v) {
        _vm.backCount = $$v
      },
      expression: "backCount"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "资损扣款(单位：分)",
      "label-width": "200px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.withholdCount),
      callback: function($$v) {
        _vm.withholdCount = $$v
      },
      expression: "withholdCount"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isFinish
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("确 定")])], 1), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.nickName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.username))])]), _vm._v(" "), (_vm.row.dispalyExtra && _vm.row.dispalyExtra.tenancy.length) ? _c('el-form-item', {
    attrs: {
      "label": "租赁时间：",
      "label-width": "180px"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.fromatDate(_vm.row.dispalyExtra.tenancy[0].begin)))]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm.rentDay) + "天")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.row && _vm.row.dispalyExtra && _vm.row.dispalyExtra.tenancy) ? _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.fromatDate(_vm.row.dispalyExtra.tenancy[0].end)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "租金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.rental))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "优惠券抵扣(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.discount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "押金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.deposit))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "减免押金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.depositDiscount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "费用统计(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paymount))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设备信息",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, _vm._l((_vm.productVal), function(i) {
    return _c('div', {
      key: i.productId,
      staticClass: "border"
    }, [_c('el-form-item', {
      attrs: {
        "label": "设备ID",
        "label-width": "100px"
      }
    }, [_c('span', [_vm._v(_vm._s(i.deviceId))])]), _vm._v(" "), _vm._l((i.otherProperty), function(item, index) {
      return _c('el-form-item', {
        key: index,
        attrs: {
          "label": index,
          "label-width": "100px"
        }
      }, [_c('el-input', {
        model: {
          value: (i.otherProperty[index]),
          callback: function($$v) {
            _vm.$set(i.otherProperty, index, $$v)
          },
          expression: "i.otherProperty[index]"
        }
      })], 1)
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureNow
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("商品分类")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "categoryId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "分类名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "分类图片",
      "width": "180"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('img', {
            staticClass: "user-pic",
            attrs: {
              "src": _vm.row.picUrl
            }
          })
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "创建时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建分类"
    },
    model: {
      value: (_vm.addCategory),
      callback: function($$v) {
        _vm.addCategory = $$v
      },
      expression: "addCategory"
    }
  }, [_c('el-form', {
    ref: "categoryForm",
    attrs: {
      "model": _vm.categoryForm,
      "rules": _vm.addCategoryRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类名称",
      "label-width": "120px",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.categoryForm.name),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "name", $$v)
      },
      expression: "categoryForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类描述",
      "label-width": "120px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.categoryForm.description),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "description", $$v)
      },
      expression: "categoryForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传banner图",
      "label-width": "120px",
      "prop": "picUrl"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.categoryForm.picUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.categoryForm.picUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addCategory = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleNewCategory
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑分类"
    },
    model: {
      value: (_vm.editCategory),
      callback: function($$v) {
        _vm.editCategory = $$v
      },
      expression: "editCategory"
    }
  }, [_c('el-form', {
    ref: "categoryForm",
    attrs: {
      "model": _vm.categoryForm,
      "rules": _vm.addCategoryRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类名称",
      "label-width": "120px",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.categoryForm.name),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "name", $$v)
      },
      expression: "categoryForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类描述",
      "label-width": "120px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.categoryForm.description),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "description", $$v)
      },
      expression: "categoryForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传banner图",
      "label-width": "120px",
      "prop": "picUrl"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.categoryForm.picUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.categoryForm.picUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editCategory = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpdateCategory
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("实名认证管理")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "昵称"
    },
    model: {
      value: (_vm.formInline.nickName),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "nickName", $$v)
      },
      expression: "formInline.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.formInline.username),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "username", $$v)
      },
      expression: "formInline.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userManage.nickName",
      "label": "昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userManage.username",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "申请时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.applyDate) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.applyDate).getFullYear() + '-' + (new Date(_vm.row.applyDate).getMonth() + 1) + '-' + new Date(_vm.row.applyDate).getDate() + ' ' + new Date(_vm.row.applyDate).getHours() + ':' + new Date(_vm.row.applyDate).getMinutes() + ':' + new Date(_vm.row.applyDate).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "status",
      "label": "状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 1) ? _c('span', [_vm._v("等待审核")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 3) ? _c('span', [_vm._v("未通过")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("通过")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), (_vm.Role === '1') ? _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "fixed": "right",
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleChange(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("审核")])], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("小程序封面图设置")])])], 1), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "封面图：",
      "label-width": "100px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑设备")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "equipmentForm",
    attrs: {
      "model": _vm.equipmentForm,
      "rules": _vm.addEquipmentRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备序列号",
      "label-width": "150px",
      "prop": "deviceId"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "deviceId", $$v)
      },
      expression: "equipmentForm.deviceId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "条形码编号",
      "label-width": "150px",
      "prop": "productIdentity"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.productIdentity),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "productIdentity", $$v)
      },
      expression: "equipmentForm.productIdentity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在仓库",
      "label-width": "150px",
      "prop": "storageId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库"
    },
    model: {
      value: (_vm.equipmentForm.storageId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "storageId", $$v)
      },
      expression: "equipmentForm.storageId"
    }
  }, _vm._l((_vm.storageArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.storageName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "添加字段",
      "label-width": "150px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addProperty($event)
      }
    }
  }, [_vm._v("增加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("key:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.key),
      callback: function($$v) {
        _vm.key = $$v
      },
      expression: "key"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("value:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1), _vm._v(" "), (_vm.property.length) ? _c('el-form-item', {
    attrs: {
      "label": "已加字段",
      "label-width": "150px"
    }
  }, _vm._l((_vm.property), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt10"
    }, [_vm._v("\n                " + _vm._s(++index) + "、" + _vm._s(item.name) + " - " + _vm._s(item.value) + "\n                "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeProperty(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.equipmentForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "remark", $$v)
      },
      expression: "equipmentForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("更新")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[328]);


// WEBPACK FOOTER //
// static/js/app.e9241164f0e8793c08c8.js